import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  Decimal: { input: string; output: string };
};

export type AccessStatus = {
  status: ListingAccessStatuses;
};

/** The account object */
export type Account = {
  /** The accounts review summaries array */
  accountReviewSummaries: Array<AccountReviewSummary>;
  /** The number of active listings belonging to an account */
  activeListingsCount: Scalars['Int']['output'];
  /** The address line one associated with the account */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The address line two associated with the account */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account has been archived */
  archived: Scalars['Boolean']['output'];
  /** The card enrolled for autopay (the Stripe customer's default payment method); null when the account has not enrolled */
  autopayCard?: Maybe<Card>;
  /** The coupon available to be applied to the account */
  availableCoupon?: Maybe<Coupon>;
  /** The avatar file name */
  avatarFileName?: Maybe<Scalars['String']['output']>;
  /** The account avatar path, relative to the endpoint */
  avatarPath?: Maybe<Scalars['String']['output']>;
  /** The avatar processing status */
  avatarProcessing: Scalars['Boolean']['output'];
  /** The avatar upload url */
  avatarUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The account host image URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The subscription associated with the listing */
  billingSubscription?: Maybe<BillingSubscription>;
  /** The strategy implemented for book direct urls for the account */
  bookDirectUrlStrategy?: Maybe<Scalars['String']['output']>;
  /** The account booking website url */
  bookDirectWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The city associated with the account */
  city?: Maybe<Scalars['String']['output']>;
  /** Whether commission billing is enabled for the account */
  commissionable?: Maybe<Scalars['Boolean']['output']>;
  /** The account company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** The country associated with the account */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /**
   * The coupon available to be applied to the account
   * @deprecated This will be deprecated soon use 'available_coupon' instead
   */
  coupon?: Maybe<Coupon>;
  /** Whether the account owner has a card on file in Stripe */
  creditCardOnFile: Scalars['Boolean']['output'];
  /** The default listing level for the account */
  defaultListingLevel: SubscriptionType;
  /** The account description */
  description?: Maybe<Scalars['String']['output']>;
  /** The account email */
  email?: Maybe<Scalars['String']['output']>;
  /** The account facebook page URL */
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  /** Datetime the account first published a listing */
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The hero file name */
  heroFileName?: Maybe<Scalars['String']['output']>;
  /** The account hero path, relative to the endpoint */
  heroPath?: Maybe<Scalars['String']['output']>;
  /** The hero processing status */
  heroProcessing: Scalars['Boolean']['output'];
  /** The hero upload url */
  heroUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The account hero image URL */
  heroUrl?: Maybe<Scalars['String']['output']>;
  /** The account homeowner marketing url */
  homeownerMarketingUrl?: Maybe<Scalars['String']['output']>;
  /** The account ID */
  id: Scalars['ID']['output'];
  /** The year the account has been in business since */
  inBusinessSince?: Maybe<Scalars['Int']['output']>;
  /** Datetime the account was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Instagram username */
  instagramUsername?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account is pay per reservation */
  isPpr: Scalars['Boolean']['output'];
  /** Whether the account is based in the United States */
  isUsBased?: Maybe<Scalars['Boolean']['output']>;
  /** The latest task ran on the account */
  latestTask?: Maybe<Task>;
  /** The account linkedin page URL */
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** The number of listings that the account has at each level */
  listingLevels: ListingLevels;
  /** The listing owned by the account */
  listings: Array<Listing>;
  /** The account website url */
  marketingWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The number of listings that the account said they had */
  numberOfClaimedListings?: Maybe<Scalars['Int']['output']>;
  /** Whether the account has completed PM onboarding */
  onboardingCompleted: Scalars['Boolean']['output'];
  /** Datetime when PM onboarding was completed */
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The users that owns the account */
  owner: User;
  /** The account phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The active onboarding session for this account */
  pmOnboardingSession?: Maybe<PmOnboardingSession>;
  /** The pms_conneciton for the account */
  pmsConnection?: Maybe<PmsConnection>;
  /**
   * The pms_connecton type or the pms_software that the account reported at sign up
   * @deprecated This will be deprecated soon use 'reported_pms_software' and 'pms_connection' instead
   */
  pmsSoftware?: Maybe<Scalars['String']['output']>;
  /** The accounts policies array */
  policies: Array<Policy>;
  /** The postal code associated with the account */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the account was created as a private account */
  private: Scalars['Boolean']['output'];
  /** The pms_software that the account reported at sign up */
  reportedPmsSoftware?: Maybe<Scalars['String']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  /** The account SEO friendly url slug */
  slug: Scalars['String']['output'];
  /** The state/province long name associated with the account */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The Stripe customer ID associated with the account */
  stripeCustomerId: Scalars['String']['output'];
  /** Datetime the account accepted the updated Terms of Use */
  termsOfUseAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The account title */
  title?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter handle */
  twitterHandle?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter URL */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** The users that belong to the account */
  users: Array<User>;
  /** The account youtube page URL */
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

/** The account object */
export type AccountListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** What an account action link lets its recipient do right now */
export type AccountActionLink = {
  authorizationStatement: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  shouldAcceptTermsOfUse: Scalars['Boolean']['output'];
  shouldAddCreditCard: Scalars['Boolean']['output'];
  termsOfUseVersion: Scalars['String']['output'];
};

export type AccountActionLinkAcceptTermsOfUseResult =
  | AccountActionLink
  | UnprocessableContentError
  | ValidationErrorCollection;

export type AccountActionLinkCreateCardSetupSessionResult =
  | CardSetupSession
  | NotFoundError
  | ServiceUnavailableError
  | UnprocessableContentError;

/** A new link is on its way to the email the old link was sent to */
export type AccountActionLinkNewLinkSent = {
  message: Scalars['String']['output'];
};

export type AccountActionLinkRequestNewLinkResult =
  | AccountActionLinkNewLinkSent
  | UnprocessableContentError;

export type AccountActionLinkResult =
  | AccountActionLink
  | UnprocessableContentError;

export type AccountBulkUpdateLocationObfuscatedInput = {
  /** Set location_obfuscated to this value for all listings on the account */
  obfuscated: Scalars['Boolean']['input'];
};

export type AccountBulkUpdateLocationObfuscatedResult =
  | AccountBulkUpdateResults
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type AccountBulkUpdateResults = {
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

/** Response for fetching an active account by its id */
export type AccountByIdResponse = Account | NotFoundError;

/** Response for fetching an account by its slug */
export type AccountBySlugResponse = Account | NotFoundError;

/** Account cancellation policy record */
export type AccountCancellationPolicy = Policy & {
  /** The cancellation policy description */
  cancellationPolicy: Scalars['String']['output'];
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** Response for getting cards */
export type AccountCardsListAllResponse =
  | CardCollection
  | ServiceUnavailableError
  | UnauthenticatedError
  | UnauthorizedError;

/** Accounts collection object contains a paginated collection of accounts and meta data about the collection */
export type AccountCollection = {
  /** The collection of accounts for a given page */
  entries: Array<Account>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** Response for fetching the account for the current user */
export type AccountForCurrentUserResponse = Account | UnauthenticatedError;

/** Response for getting the listings for the current authenticated user's account */
export type AccountListingsResponse = ListingCollection | UnauthenticatedError;

/** Account review summary object */
export type AccountReviewSummary = {
  /** The review summary ID */
  id: Scalars['String']['output'];
  /** The review summary image URL (currently only used for tripadvisor) */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The review summary total number of reviews */
  numberOfReviews?: Maybe<Scalars['Int']['output']>;
  /** The review summary rating */
  rating: Scalars['Float']['output'];
  /** The review summary source */
  source: AccountReviewSummarySource;
  /** The review summary source_id */
  sourceId: Scalars['String']['output'];
  /** The review summary URL */
  url?: Maybe<Scalars['String']['output']>;
};

export type AccountReviewSummaryCreateInput = {
  /** The account review summary source */
  source: AccountReviewSummarySource;
  /** The account review summary source ID */
  sourceId: Scalars['String']['input'];
};

/** The result of the create account review summary mutation for an authenticated innkeeper */
export type AccountReviewSummaryCreateResult =
  | AccountReviewSummary
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** The review summary source enum */
export enum AccountReviewSummarySource {
  /** The review summary source google_reviews enum value */
  GoogleReviews = 'GOOGLE_REVIEWS',
  /** The review summary source tripadvisor enum value */
  TripAdvisor = 'TRIP_ADVISOR',
}

export enum AccountRole {
  Member = 'MEMBER',
  Owner = 'OWNER',
}

/** Account terms and conditions policy record */
export type AccountTermsAndConditions = Policy & {
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The terms and conditions link */
  termsLink?: Maybe<Scalars['String']['output']>;
  /** The terms and conditions upload url */
  termsUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The policy type */
  type: PolicyType;
};

export type AccountUpdateAllListingSubscriptionsInput = {
  /** The plan id for the listing subscriptions */
  planId: Scalars['String']['input'];
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
};

export type AccountUpdateAllListingSubscriptionsResult =
  | AccountBulkUpdateResults
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type AccountUpdateInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  avatarUploadUrl?: InputMaybe<Scalars['String']['input']>;
  bookDirectWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  defaultListingLevel?: InputMaybe<SubscriptionType>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookPageUrl?: InputMaybe<Scalars['String']['input']>;
  heroUploadUrl?: InputMaybe<Scalars['String']['input']>;
  homeownerMarketingUrl?: InputMaybe<Scalars['String']['input']>;
  inBusinessSince?: InputMaybe<Scalars['Int']['input']>;
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  marketingWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the account create mutation for an authenticated user */
export type AccountUpdateResult =
  | Account
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Response for getting the accounts */
export type AccountsResponse = AccountCollection;

/** The admin object */
export type Admin = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Affiliation object */
export type Affiliation = {
  /** The affiliation ID */
  id: Scalars['String']['output'];
  /** The affiliation name */
  name: Scalars['String']['output'];
  /** The affiliation type */
  type: AffiliationType;
};

export type AffiliationCollection = {
  /** The collection of affiliations for a given page */
  entries: Array<Affiliation>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type AffiliationDeleteInput = {
  /** The ID of an existing affiliation. */
  id: Scalars['ID']['input'];
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
};

/** The result of the delete affiliation mutation for an authenticated innkeeper */
export type AffiliationDeleteResult =
  | Affiliation
  | NotFoundError
  | UnauthenticatedError;

export type AffiliationFindOrCreateInput = {
  /** The ID of an existing affiliation. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
  /** The name of a new affiliation. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of affiliation. */
  type?: InputMaybe<AffiliationType>;
};

/** The result of the find or create affiliation mutation for an authenticated innkeeper */
export type AffiliationFindOrCreateResult =
  | Affiliation
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Response for searching for affiliations when authenticated as an innkeeper */
export type AffiliationSearchResponse =
  | AffiliationCollection
  | UnauthenticatedError;

/** The affiliation type enum */
export enum AffiliationType {
  /** The affiliation associations type enum value */
  Associations = 'ASSOCIATIONS',
  /** The affiliation awards type enum value */
  Awards = 'AWARDS',
  /** The affiliation inspections type enum value */
  Inspections = 'INSPECTIONS',
}

/** The affiliation type enum */
export enum AffiliationTypeFilter {
  /** All the affiliations */
  All = 'ALL',
  /** The affiliation associations type enum value */
  Associations = 'ASSOCIATIONS',
  /** The affiliation awards type enum value */
  Awards = 'AWARDS',
  /** The affiliation inspections type enum value */
  Inspections = 'INSPECTIONS',
}

/** Availability object */
export type Availability = {
  /** Availability status */
  available: Scalars['Boolean']['output'];
  /** Check in allowed status */
  checkInAllowed: Scalars['Boolean']['output'];
  /** Check out allowed status */
  checkOutAllowed: Scalars['Boolean']['output'];
  /** Datetime the min stay date starts on */
  date: Scalars['Date']['output'];
  /** Number of days the max stay is. */
  maxNights?: Maybe<Scalars['Int']['output']>;
  /** Number of days the min stay is. */
  minNights?: Maybe<Scalars['Int']['output']>;
};

export type BarefootPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** Bed object embedded in a room */
export type Bed = {
  /** The number of beds of this type in the room */
  count: Scalars['Int']['output'];
  /** The type of bed (e.g., king, queen, twin, etc.) */
  type: BedType;
};

export enum BedType {
  /** Air mattress */
  AirMattress = 'AIR_MATTRESS',
  /** Bunk bed */
  Bunk = 'BUNK',
  /** Child bed */
  ChildBed = 'CHILD_BED',
  /** Double bed */
  Double = 'DOUBLE',
  /** King bed */
  King = 'KING',
  /** Pull-out bed */
  PullOut = 'PULL_OUT',
  /** Queen bed */
  Queen = 'QUEEN',
  /** Single bed */
  Single = 'SINGLE',
  /** Sofa bed */
  SofaBed = 'SOFA_BED',
  /** Twin bed */
  Twin = 'TWIN',
}

/** Billing subscription object for listings */
export type BillingSubscription = {
  currentPeriodEnd: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** An error encountered when the user account has been blocked */
export type BlockedError = {
  message: Scalars['String']['output'];
};

/** Blog post object */
export type BlogPost = {
  /** The blog post ID */
  id: Scalars['ID']['output'];
  /** The blog post image URL */
  imageUrl: Scalars['String']['output'];
  /** The blog post published at time */
  publishedAt: Scalars['DateTime']['output'];
  /** The blog post title */
  title: Scalars['String']['output'];
  /** The blog post URL */
  url: Scalars['String']['output'];
};

export type BookDirectWebsiteUrlParamsTemplateInput = {
  /** The adult count to be used in the book direct URL */
  adultCount: Scalars['Int']['input'];
  /** The check in date to be used in the book direct URL */
  checkInDate: Scalars['Date']['input'];
  /** The check out date to be used in the book direct URL */
  checkOutDate: Scalars['Date']['input'];
  /** The child count to be used in the book direct URL */
  childCount: Scalars['Int']['input'];
  /** The infant count to be used in the book direct URL */
  infantCount: Scalars['Int']['input'];
  /** The pet count to be used in the book direct URL */
  petCount: Scalars['Int']['input'];
};

/** Listing Quote object */
export type BookingQuote = {
  /** Datetime the quote requested for check-in */
  checkInDate?: Maybe<Scalars['Date']['output']>;
  /** Datetime the quote requested for checkout */
  checkOutDate?: Maybe<Scalars['Date']['output']>;
  /** The id of the quote */
  id: Scalars['String']['output'];
  /** The PMS checkout URL for this quote, for PMSs that take the booking themselves. Null otherwise */
  iframeBookingUrl?: Maybe<Scalars['String']['output']>;
  /** The listing the quote is for */
  listing: Listing;
  /** The id of the listing */
  listingId?: Maybe<Scalars['String']['output']>;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfInfants?: Maybe<Scalars['Int']['output']>;
  numberOfPets?: Maybe<Scalars['Int']['output']>;
  /** The payment schedule for the quote */
  paymentSchedule: Array<PaymentItem>;
  /** The items that make up the quote */
  quoteItems: Array<QuoteItems>;
  /** The total cost of the quote */
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  /** The total recoverable cost of the quote */
  totalRecoverableCostCents?: Maybe<Scalars['Int']['output']>;
  /** The total cost of the quote without taxes. Only available for itemized quotes */
  totalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

/** Response for getting the booking quotes on a listing */
export type BookingQuoteResponse =
  | BookingQuote
  | BookingQuoteUnavailable
  | BookingQuoteUnsupported
  | NotFoundError
  | ServiceUnavailableError
  | ValidationError;

/** A booking quote is not available */
export type BookingQuoteUnavailable = {
  message: Scalars['String']['output'];
};

/** A booking quote is not supported */
export type BookingQuoteUnsupported = {
  message: Scalars['String']['output'];
};

export type BooksterPmsConnectionCreateInput = {
  password: Scalars['String']['input'];
};

export type BoostPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type CancelReservationInput = {
  reservationId: Scalars['ID']['input'];
};

export type CancelReservationResult =
  | NotFoundError
  | Reservation
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Card object */
export type Card = {
  /** The zip code for the card */
  addressZip?: Maybe<Scalars['String']['output']>;
  /** The card brand */
  brand: Scalars['String']['output'];
  /** The month the card expires */
  expMonth: Scalars['Int']['output'];
  /** The year the card expires */
  expYear: Scalars['Int']['output'];
  /** The last four digits of the card */
  last4: Scalars['String']['output'];
};

export type CardCollection = {
  /** The collection of cards for a given page */
  entries: Array<Card>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** A Stripe-hosted Checkout Session (setup mode) URL for autopay enrollment */
export type CardSetupSession = {
  url: Scalars['String']['output'];
};

/** Response for getting cards */
export type CardsListAllResponse =
  | CardCollection
  | ServiceUnavailableError
  | UnauthenticatedError;

export type CiirusPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** Collection info object */
export type CollectionInfo = {
  /** The current page value in the collection */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** The next page value in the collection */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** The previous page value in the collection */
  previousPage?: Maybe<Scalars['Int']['output']>;
  /** The number of entries for the whole collection */
  totalEntries?: Maybe<Scalars['Int']['output']>;
  /** The number of pages for the whole collection */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** A comparison quote */
export type ComparisonQuote = {
  /** Datetime the quote requested for check-in */
  checkInDate: Scalars['Date']['output'];
  /** Datetime the quote requested for checkout */
  checkOutDate: Scalars['Date']['output'];
  externalListingId: Scalars['String']['output'];
  externalSource: Scalars['String']['output'];
  numberOfAdults: Scalars['Int']['output'];
  numberOfChildren: Scalars['Int']['output'];
  numberOfInfants: Scalars['Int']['output'];
  numberOfPets: Scalars['Int']['output'];
  /** The total cost of the quote at some point depending on the price_type field */
  priceCents: Scalars['Int']['output'];
};

/** Response for getting the comparison quote on a listing */
export type ComparisonQuoteResponse =
  | ComparisonQuote
  | ComparisonQuoteUnsupported
  | NotFoundError
  | UnprocessableContentError
  | ValidationError;

/** A comparison quote is not supported */
export type ComparisonQuoteUnsupported = {
  message: Scalars['String']['output'];
};

export type ConfigItem = {
  fieldName: Scalars['String']['output'];
  options: Array<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** An error encountered with out of date data */
export type ConflictError = {
  message: Scalars['String']['output'];
};

/** Coupon object */
export type Coupon = {
  amountOffCents?: Maybe<Scalars['Int']['output']>;
  applicableSubscriptions?: Maybe<Array<Maybe<SubscriptionType>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated This will be deprecated soon use 'applicable_subscriptions' instead */
  subscriptionTypes?: Maybe<Array<Maybe<SubscriptionType>>>;
};

/** Response for looking up a coupon by its promo code */
export type CouponFindByPromoCodeResponse = Coupon | NotFoundError;

/** Response for fetching an active accounts coupon */
export type CouponFindForAccountResponse =
  | Coupon
  | NotFoundError
  | UnauthenticatedError;

/** The result of starting an autopay-enrollment card setup session */
export type CreateCardSetupSessionResult =
  | CardSetupSession
  | NotFoundError
  | ServiceUnavailableError
  | UnauthenticatedError
  | UnauthorizedError;

/** The result of creating a gift card */
export type CreateGiftCardResponse = GiftCard | ValidationErrorCollection;

export type CreateLeadInput = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  numberOfListings: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  pmsSoftware: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadResult = LeadCreatedMessage | ValidationErrorCollection;

export type CreateReservationInput = {
  /** The card address city for the reservation */
  cardAddressCity: Scalars['String']['input'];
  /** The card address country for the reservation */
  cardAddressCountry: Scalars['String']['input'];
  /** The card address line 1 for the reservation */
  cardAddressLine1: Scalars['String']['input'];
  /** The card address line 2 for the reservation */
  cardAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The card address state for the reservation */
  cardAddressState: Scalars['String']['input'];
  /** The card address zip for the reservation */
  cardAddressZip: Scalars['String']['input'];
  /** The card cvc for the reservation */
  cardCvc: Scalars['String']['input'];
  /** The card expiration month for the reservation */
  cardExpMonth: Scalars['String']['input'];
  /** The card expiration year for the reservation */
  cardExpYear: Scalars['String']['input'];
  /** The card name for the reservation */
  cardName: Scalars['String']['input'];
  /** The card number for the reservation */
  cardNumber: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
};

export type CreateReservationResult =
  | NotFoundError
  | Reservation
  | ReservationCreationUnknown
  | ReservationUnavailable
  | UnauthenticatedError
  | ValidationErrorCollection;

export type CreateSubscriptionInput = {
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The tokenized card given by Stripe */
  stripeTokenId: Scalars['String']['input'];
};

/** The result of creating a subscription mutation for an authenticated host */
export type CreateSubscriptionResult =
  | Account
  | ConflictError
  | NotFoundError
  | ServiceUnavailableError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** The result of creating a user referral campaign */
export type CreateUserReferralCampaignResponse =
  | UnauthenticatedError
  | UserReferralCampaign
  | ValidationErrorCollection;

/** Response for getting the current authenticated innkeeper */
export type CurrentInnkeeperResponse = Innkeeper | UnauthenticatedError;

/** Response for getting the current authenticated user */
export type CurrentUserResponse = UnauthenticatedError | User;

export type CursorCollectionMetadata = {
  cursorAfter?: Maybe<Scalars['String']['output']>;
  cursorBefore?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DemoPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

/** The result of creating an email verification for an authenticated innkeeper */
export type EmailVerificationCreateResult =
  | EmailVerificationMessage
  | UnauthenticatedError
  | ValidationErrorCollection;

export type EmailVerificationMessage = {
  message: Scalars['String']['output'];
};

/** The result of the set card mutation for an authenticated innkeeper */
export type EmailVerificationUpdateResult =
  | EmailVerificationMessage
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type EscapiaPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export enum ExternalSource {
  Barefoot = 'BAREFOOT',
  Bnbfinder = 'BNBFINDER',
  Bookster = 'BOOKSTER',
  Boost = 'BOOST',
  Ciirus = 'CIIRUS',
  Csv = 'CSV',
  Demo = 'DEMO',
  Escapia = 'ESCAPIA',
  Guesty = 'GUESTY',
  GuestyDh = 'GUESTY_DH',
  Hospitable = 'HOSPITABLE',
  Hostaway = 'HOSTAWAY',
  Hostfully = 'HOSTFULLY',
  LiveList = 'LIVE_LIST',
  Lodgify = 'LODGIFY',
  Lodgix = 'LODGIX',
  NextPax = 'NEXT_PAX',
  OwnerRez = 'OWNER_REZ',
  RedAwning = 'RED_AWNING',
  RentalsUnited = 'RENTALS_UNITED',
  Streamline = 'STREAMLINE',
  StreamlinePartner = 'STREAMLINE_PARTNER',
  Track = 'TRACK',
  VacayHome = 'VACAY_HOME',
}

/** Feature object used for filtering listings and providing additional meta data about a listing */
export type Feature = {
  /** The feature category name */
  categoryName: Scalars['String']['output'];
  /** The feature display name */
  displayName: Scalars['String']['output'];
  /** The feature key */
  key: FeatureKey;
  /**
   * The legacy feature key
   * @deprecated This will be deprecated soon use 'key' instead
   */
  legacyKey: Scalars['String']['output'];
  /** A boolean indicating whether or not the feature is promoted */
  promoted: Scalars['Boolean']['output'];
};

/** Feature key enums are guaranteed to be unique */
export enum FeatureKey {
  AcceptsGiftCard = 'ACCEPTS_GIFT_CARD',
  AdaCompliant = 'ADA_COMPLIANT',
  AdultsOnly = 'ADULTS_ONLY',
  AfternoonTea = 'AFTERNOON_TEA',
  AirConditioning = 'AIR_CONDITIONING',
  AllowsChildren = 'ALLOWS_CHILDREN',
  Apartment = 'APARTMENT',
  BabysitterRecommendations = 'BABYSITTER_RECOMMENDATIONS',
  BabyBath = 'BABY_BATH',
  BabyMonitor = 'BABY_MONITOR',
  BabySafetyGates = 'BABY_SAFETY_GATES',
  Backyard = 'BACKYARD',
  BakingSheet = 'BAKING_SHEET',
  Balcony = 'BALCONY',
  Bar = 'BAR',
  BarbecueUtensils = 'BARBECUE_UTENSILS',
  Bathrobes = 'BATHROBES',
  Bathtub = 'BATHTUB',
  BathtubShowerCombo = 'BATHTUB_SHOWER_COMBO',
  BayView = 'BAY_VIEW',
  BbqGrills = 'BBQ_GRILLS',
  Beachfront = 'BEACHFRONT',
  BeachView = 'BEACH_VIEW',
  BedLinens = 'BED_LINENS',
  Bidet = 'BIDET',
  BlackoutCurtains = 'BLACKOUT_CURTAINS',
  Blender = 'BLENDER',
  BoardGames = 'BOARD_GAMES',
  BoatFriendly = 'BOAT_FRIENDLY',
  BodySoap = 'BODY_SOAP',
  BooksAndReadingMaterial = 'BOOKS_AND_READING_MATERIAL',
  BreadMaker = 'BREAD_MAKER',
  BreakfastIncluded = 'BREAKFAST_INCLUDED',
  Budget = 'BUDGET',
  Bungalows = 'BUNGALOWS',
  BusinessTravel = 'BUSINESS_TRAVEL',
  CanalView = 'CANAL_VIEW',
  CarbonMonoxideAlarm = 'CARBON_MONOXIDE_ALARM',
  CeilingFan = 'CEILING_FAN',
  ChangingTable = 'CHANGING_TABLE',
  CheckInCheckOutOnlinePhone = 'CHECK_IN_CHECK_OUT_ONLINE_PHONE',
  ChildrensBooksAndToys = 'CHILDRENS_BOOKS_AND_TOYS',
  ChildrensDinnerware = 'CHILDRENS_DINNERWARE',
  CitySkylineView = 'CITY_SKYLINE_VIEW',
  CleaningProducts = 'CLEANING_PRODUCTS',
  ClothingStorage = 'CLOTHING_STORAGE',
  Coffee = 'COFFEE',
  CoffeeMaker = 'COFFEE_MAKER',
  CoffeeService = 'COFFEE_SERVICE',
  ComplimentaryBeveragePantries = 'COMPLIMENTARY_BEVERAGE_PANTRIES',
  Concierge = 'CONCIERGE',
  Conditioner = 'CONDITIONER',
  Condominium = 'CONDOMINIUM',
  ConnectingRooms = 'CONNECTING_ROOMS',
  ContactlessCheckIn = 'CONTACTLESS_CHECK_IN',
  ContactlessCheckOut = 'CONTACTLESS_CHECK_OUT',
  Contemporary = 'CONTEMPORARY',
  ContinentalBreakfast = 'CONTINENTAL_BREAKFAST',
  CookingBasics = 'COOKING_BASICS',
  CountryInn = 'COUNTRY_INN',
  CourtyardView = 'COURTYARD_VIEW',
  Crib = 'CRIB',
  DailyHousekeeping = 'DAILY_HOUSEKEEPING',
  DesertView = 'DESERT_VIEW',
  DesignatedSmokingAreas = 'DESIGNATED_SMOKING_AREAS',
  DiningArea = 'DINING_AREA',
  DiningTable = 'DINING_TABLE',
  DinnerAvailableForAdditionalCost = 'DINNER_AVAILABLE_FOR_ADDITIONAL_COST',
  DinnerIncludedInRoomRate = 'DINNER_INCLUDED_IN_ROOM_RATE',
  DishesAndSilverware = 'DISHES_AND_SILVERWARE',
  Dishwasher = 'DISHWASHER',
  Downtown = 'DOWNTOWN',
  Dryer = 'DRYER',
  DryerRackForClothing = 'DRYER_RACK_FOR_CLOTHING',
  ElectricVehicleChargingStation = 'ELECTRIC_VEHICLE_CHARGING_STATION',
  Elevator = 'ELEVATOR',
  Elliptical = 'ELLIPTICAL',
  EthernetConnection = 'ETHERNET_CONNECTION',
  EveningTurndown = 'EVENING_TURNDOWN',
  ExtraPillowsAndBlankets = 'EXTRA_PILLOWS_AND_BLANKETS',
  FamilyTravel = 'FAMILY_TRAVEL',
  FencedBackyard = 'FENCED_BACKYARD',
  Firepit = 'FIREPIT',
  FireplaceGuards = 'FIREPLACE_GUARDS',
  FireExtinguisher = 'FIRE_EXTINGUISHER',
  FirePlaceInRooms = 'FIRE_PLACE_IN_ROOMS',
  FirstAidKit = 'FIRST_AID_KIT',
  Freezer = 'FREEZER',
  FreeCancellation = 'FREE_CANCELLATION',
  FreeParking = 'FREE_PARKING',
  FreeStreetParking = 'FREE_STREET_PARKING',
  FreeUseOfBeachChairsAndTowels = 'FREE_USE_OF_BEACH_CHAIRS_AND_TOWELS',
  FreeUseOfBicycles = 'FREE_USE_OF_BICYCLES',
  FreeWeights = 'FREE_WEIGHTS',
  FreeWiFi = 'FREE_WI_FI',
  FullBreakfast = 'FULL_BREAKFAST',
  GameConsole = 'GAME_CONSOLE',
  GameRoom = 'GAME_ROOM',
  Garden = 'GARDEN',
  GardenView = 'GARDEN_VIEW',
  GayLesbianTravel = 'GAY_LESBIAN_TRAVEL',
  GiftShop = 'GIFT_SHOP',
  GrandVistas = 'GRAND_VISTAS',
  GroupFacilities = 'GROUP_FACILITIES',
  Guesthouse = 'GUESTHOUSE',
  GuestCottage = 'GUEST_COTTAGE',
  Gym = 'GYM',
  HairDryer = 'HAIR_DRYER',
  Hammock = 'HAMMOCK',
  Hangers = 'HANGERS',
  HarborView = 'HARBOR_VIEW',
  Heater = 'HEATER',
  HeavyContinentalBreakfast = 'HEAVY_CONTINENTAL_BREAKFAST',
  HighChair = 'HIGH_CHAIR',
  HighQualityBedding = 'HIGH_QUALITY_BEDDING',
  HistoricHotel = 'HISTORIC_HOTEL',
  HistoricProperty = 'HISTORIC_PROPERTY',
  Homestay = 'HOMESTAY',
  HotTub = 'HOT_TUB',
  HotWater = 'HOT_WATER',
  HotWaterKettle = 'HOT_WATER_KETTLE',
  HypoallergenicBedding = 'HYPOALLERGENIC_BEDDING',
  Igloo = 'IGLOO',
  InRoomBreakfast = 'IN_ROOM_BREAKFAST',
  InRoomBreakfastAvailable = 'IN_ROOM_BREAKFAST_AVAILABLE',
  InRoomClimateControl = 'IN_ROOM_CLIMATE_CONTROL',
  IronIroningBoard = 'IRON_IRONING_BOARD',
  Island = 'ISLAND',
  JacuzziInRoom = 'JACUZZI_IN_ROOM',
  Kayak = 'KAYAK',
  KingBedsOnsite = 'KING_BEDS_ONSITE',
  Lakefront = 'LAKEFRONT',
  LakeView = 'LAKE_VIEW',
  LaundromatNearby = 'LAUNDROMAT_NEARBY',
  LaundryFacilities = 'LAUNDRY_FACILITIES',
  Loft = 'LOFT',
  LongTermStaysAllowed = 'LONG_TERM_STAYS_ALLOWED',
  LuggageDropoffAllowed = 'LUGGAGE_DROPOFF_ALLOWED',
  Luxury = 'LUXURY',
  Mansion = 'MANSION',
  MarinaView = 'MARINA_VIEW',
  MeetingsEvents = 'MEETINGS_EVENTS',
  MeetingRooms = 'MEETING_ROOMS',
  Microwave = 'MICROWAVE',
  MidRange = 'MID_RANGE',
  Minibar = 'MINIBAR',
  MiniFridge = 'MINI_FRIDGE',
  MosquitoNet = 'MOSQUITO_NET',
  MountainView = 'MOUNTAIN_VIEW',
  MultilingualStaff = 'MULTILINGUAL_STAFF',
  NearAGolfCourse = 'NEAR_A_GOLF_COURSE',
  NearNightlife = 'NEAR_NIGHTLIFE',
  NearPublicTransportation = 'NEAR_PUBLIC_TRANSPORTATION',
  NonSmoking = 'NON_SMOKING',
  Oceanfront = 'OCEANFRONT',
  OceanView = 'OCEAN_VIEW',
  OutdoorDiningArea = 'OUTDOOR_DINING_AREA',
  OutdoorFirePit = 'OUTDOOR_FIRE_PIT',
  OutdoorFurniture = 'OUTDOOR_FURNITURE',
  OutdoorKitchen = 'OUTDOOR_KITCHEN',
  OutdoorMovieTheater = 'OUTDOOR_MOVIE_THEATER',
  OutdoorShower = 'OUTDOOR_SHOWER',
  OutletCovers = 'OUTLET_COVERS',
  Oven = 'OVEN',
  PaidParkingOffPremises = 'PAID_PARKING_OFF_PREMISES',
  PaidParkingOnPremises = 'PAID_PARKING_ON_PREMISES',
  ParkView = 'PARK_VIEW',
  PetsNotAllowed = 'PETS_NOT_ALLOWED',
  PetFriendly = 'PET_FRIENDLY',
  Piano = 'PIANO',
  PingPongTable = 'PING_PONG_TABLE',
  Pool = 'POOL',
  PoolTable = 'POOL_TABLE',
  PortableFans = 'PORTABLE_FANS',
  PrivateBathrooms = 'PRIVATE_BATHROOMS',
  PrivateEntrances = 'PRIVATE_ENTRANCES',
  PrivateHome = 'PRIVATE_HOME',
  ProfessionalBedAndBreakfast = 'PROFESSIONAL_BED_AND_BREAKFAST',
  RecordPlayer = 'RECORD_PLAYER',
  Refrigerator = 'REFRIGERATOR',
  ResortView = 'RESORT_VIEW',
  Riverfront = 'RIVERFRONT',
  RiverView = 'RIVER_VIEW',
  RollawayAvailable = 'ROLLAWAY_AVAILABLE',
  RollInShower = 'ROLL_IN_SHOWER',
  Romantic = 'ROMANTIC',
  RoomDarkeningShades = 'ROOM_DARKENING_SHADES',
  RoomHasKitchen = 'ROOM_HAS_KITCHEN',
  RyokanJapan = 'RYOKAN_JAPAN',
  Safe = 'SAFE',
  Sauna = 'SAUNA',
  SeaView = 'SEA_VIEW',
  Shampoo = 'SHAMPOO',
  ShowerGel = 'SHOWER_GEL',
  SingleLevelHome = 'SINGLE_LEVEL_HOME',
  SittingArea = 'SITTING_AREA',
  SkiInSkiOut = 'SKI_IN_SKI_OUT',
  Slippers = 'SLIPPERS',
  SmokeAlarm = 'SMOKE_ALARM',
  SmokingPermitted = 'SMOKING_PERMITTED',
  Sofabed = 'SOFABED',
  SoundSystem = 'SOUND_SYSTEM',
  Spa = 'SPA',
  StationaryBike = 'STATIONARY_BIKE',
  Stove = 'STOVE',
  StrictDailyCleaningRegimen = 'STRICT_DAILY_CLEANING_REGIMEN',
  SuitableForChildren = 'SUITABLE_FOR_CHILDREN',
  SuitableForInfants = 'SUITABLE_FOR_INFANTS',
  TableCornerGuards = 'TABLE_CORNER_GUARDS',
  Tent = 'TENT',
  Toaster = 'TOASTER',
  Train = 'TRAIN',
  TrashCompactor = 'TRASH_COMPACTOR',
  TravelCrib = 'TRAVEL_CRIB',
  Treadmill = 'TREADMILL',
  Tv = 'TV',
  TwoBedsInRoom = 'TWO_BEDS_IN_ROOM',
  UrbanInn = 'URBAN_INN',
  ValleyView = 'VALLEY_VIEW',
  VegetarianMeals = 'VEGETARIAN_MEALS',
  VineyardView = 'VINEYARD_VIEW',
  Washer = 'WASHER',
  WasherAndDryer = 'WASHER_AND_DRYER',
  Waterfront = 'WATERFRONT',
  Weddings = 'WEDDINGS',
  WheelchairFriendly = 'WHEELCHAIR_FRIENDLY',
  WhirlpoolTubAllRooms = 'WHIRLPOOL_TUB_ALL_ROOMS',
  WhirlpoolTubSomeRooms = 'WHIRLPOOL_TUB_SOME_ROOMS',
  WholeHouseBuildingRental = 'WHOLE_HOUSE_BUILDING_RENTAL',
  WindowGuards = 'WINDOW_GUARDS',
  Winery = 'WINERY',
  WineGlasses = 'WINE_GLASSES',
  Workspace = 'WORKSPACE',
  YogaMat = 'YOGA_MAT',
}

export enum FieldNames {
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  BookDirectWebsiteUrl = 'BOOK_DIRECT_WEBSITE_URL',
  Checkout = 'CHECKOUT',
  CheckIn = 'CHECK_IN',
  City = 'CITY',
  Country = 'COUNTRY',
  Description = 'DESCRIPTION',
  ExternalId = 'EXTERNAL_ID',
  FacebookPageUrl = 'FACEBOOK_PAGE_URL',
  FilterAcceptsGiftCard = 'FILTER_ACCEPTS_GIFT_CARD',
  FilterAdaCompliant = 'FILTER_ADA_COMPLIANT',
  FilterAdultsOnly = 'FILTER_ADULTS_ONLY',
  FilterAfternoonTea = 'FILTER_AFTERNOON_TEA',
  FilterAirConditioning = 'FILTER_AIR_CONDITIONING',
  FilterAllowsChildren = 'FILTER_ALLOWS_CHILDREN',
  FilterApartment = 'FILTER_APARTMENT',
  FilterBabysitterRecommendations = 'FILTER_BABYSITTER_RECOMMENDATIONS',
  FilterBabyBath = 'FILTER_BABY_BATH',
  FilterBabyMonitor = 'FILTER_BABY_MONITOR',
  FilterBabySafetyGates = 'FILTER_BABY_SAFETY_GATES',
  FilterBackyard = 'FILTER_BACKYARD',
  FilterBakingSheet = 'FILTER_BAKING_SHEET',
  FilterBalcony = 'FILTER_BALCONY',
  FilterBar = 'FILTER_BAR',
  FilterBarbecueUtensils = 'FILTER_BARBECUE_UTENSILS',
  FilterBathrobes = 'FILTER_BATHROBES',
  FilterBathtub = 'FILTER_BATHTUB',
  FilterBathtubShowerCombo = 'FILTER_BATHTUB_SHOWER_COMBO',
  FilterBayView = 'FILTER_BAY_VIEW',
  FilterBbqGrills = 'FILTER_BBQ_GRILLS',
  FilterBeachfront = 'FILTER_BEACHFRONT',
  FilterBeachView = 'FILTER_BEACH_VIEW',
  FilterBedLinens = 'FILTER_BED_LINENS',
  FilterBidet = 'FILTER_BIDET',
  FilterBlackoutCurtains = 'FILTER_BLACKOUT_CURTAINS',
  FilterBlender = 'FILTER_BLENDER',
  FilterBoardGames = 'FILTER_BOARD_GAMES',
  FilterBoatFriendly = 'FILTER_BOAT_FRIENDLY',
  FilterBodySoap = 'FILTER_BODY_SOAP',
  FilterBooksAndReadingMaterial = 'FILTER_BOOKS_AND_READING_MATERIAL',
  FilterBreadMaker = 'FILTER_BREAD_MAKER',
  FilterBreakfastIncluded = 'FILTER_BREAKFAST_INCLUDED',
  FilterBudget = 'FILTER_BUDGET',
  FilterBusinessTravel = 'FILTER_BUSINESS_TRAVEL',
  FilterCanalView = 'FILTER_CANAL_VIEW',
  FilterCarbonMonoxideAlarm = 'FILTER_CARBON_MONOXIDE_ALARM',
  FilterCeilingFan = 'FILTER_CEILING_FAN',
  FilterChangingTable = 'FILTER_CHANGING_TABLE',
  FilterCheckInCheckOutOnlinePhone = 'FILTER_CHECK_IN_CHECK_OUT_ONLINE_PHONE',
  FilterChildrensBooksAndToys = 'FILTER_CHILDRENS_BOOKS_AND_TOYS',
  FilterChildrensDinnerware = 'FILTER_CHILDRENS_DINNERWARE',
  FilterCitySkylineView = 'FILTER_CITY_SKYLINE_VIEW',
  FilterCleaningProducts = 'FILTER_CLEANING_PRODUCTS',
  FilterClothingStorage = 'FILTER_CLOTHING_STORAGE',
  FilterCoffee = 'FILTER_COFFEE',
  FilterCoffeeMaker = 'FILTER_COFFEE_MAKER',
  FilterCoffeeService = 'FILTER_COFFEE_SERVICE',
  FilterComplimentaryBeveragePantries = 'FILTER_COMPLIMENTARY_BEVERAGE_PANTRIES',
  FilterConcierge = 'FILTER_CONCIERGE',
  FilterConditioner = 'FILTER_CONDITIONER',
  FilterCondominium = 'FILTER_CONDOMINIUM',
  FilterConnectingRooms = 'FILTER_CONNECTING_ROOMS',
  FilterContactlessCheckIn = 'FILTER_CONTACTLESS_CHECK_IN',
  FilterContactlessCheckOut = 'FILTER_CONTACTLESS_CHECK_OUT',
  FilterContemporary = 'FILTER_CONTEMPORARY',
  FilterContinentalBreakfast = 'FILTER_CONTINENTAL_BREAKFAST',
  FilterCookingBasics = 'FILTER_COOKING_BASICS',
  FilterCountryInn = 'FILTER_COUNTRY_INN',
  FilterCourtyardView = 'FILTER_COURTYARD_VIEW',
  FilterCrib = 'FILTER_CRIB',
  FilterDailyHousekeeping = 'FILTER_DAILY_HOUSEKEEPING',
  FilterDesertView = 'FILTER_DESERT_VIEW',
  FilterDesignatedSmokingAreas = 'FILTER_DESIGNATED_SMOKING_AREAS',
  FilterDiningArea = 'FILTER_DINING_AREA',
  FilterDiningTable = 'FILTER_DINING_TABLE',
  FilterDinnerAvailableForAdditionalCost = 'FILTER_DINNER_AVAILABLE_FOR_ADDITIONAL_COST',
  FilterDinnerIncludedInRoomRate = 'FILTER_DINNER_INCLUDED_IN_ROOM_RATE',
  FilterDishesAndSilverware = 'FILTER_DISHES_AND_SILVERWARE',
  FilterDishwasher = 'FILTER_DISHWASHER',
  FilterDowntown = 'FILTER_DOWNTOWN',
  FilterDryer = 'FILTER_DRYER',
  FilterDryerRackForClothing = 'FILTER_DRYER_RACK_FOR_CLOTHING',
  FilterElectricVehicleChargingStation = 'FILTER_ELECTRIC_VEHICLE_CHARGING_STATION',
  FilterElevator = 'FILTER_ELEVATOR',
  FilterElliptical = 'FILTER_ELLIPTICAL',
  FilterEthernetConnection = 'FILTER_ETHERNET_CONNECTION',
  FilterEveningTurndown = 'FILTER_EVENING_TURNDOWN',
  FilterExtraPillowsAndBlankets = 'FILTER_EXTRA_PILLOWS_AND_BLANKETS',
  FilterFamilyTravel = 'FILTER_FAMILY_TRAVEL',
  FilterFencedBackyard = 'FILTER_FENCED_BACKYARD',
  FilterFirepit = 'FILTER_FIREPIT',
  FilterFireplaceGuards = 'FILTER_FIREPLACE_GUARDS',
  FilterFireExtinguisher = 'FILTER_FIRE_EXTINGUISHER',
  FilterFirePlaceInRooms = 'FILTER_FIRE_PLACE_IN_ROOMS',
  FilterFirstAidKit = 'FILTER_FIRST_AID_KIT',
  FilterFreezer = 'FILTER_FREEZER',
  FilterFreeCancellation = 'FILTER_FREE_CANCELLATION',
  FilterFreeParking = 'FILTER_FREE_PARKING',
  FilterFreeStreetParking = 'FILTER_FREE_STREET_PARKING',
  FilterFreeUseOfBeachChairsAndTowels = 'FILTER_FREE_USE_OF_BEACH_CHAIRS_AND_TOWELS',
  FilterFreeUseOfBicycles = 'FILTER_FREE_USE_OF_BICYCLES',
  FilterFreeWeights = 'FILTER_FREE_WEIGHTS',
  FilterFreeWiFi = 'FILTER_FREE_WI_FI',
  FilterFullBreakfast = 'FILTER_FULL_BREAKFAST',
  FilterGameConsole = 'FILTER_GAME_CONSOLE',
  FilterGameRoom = 'FILTER_GAME_ROOM',
  FilterGarden = 'FILTER_GARDEN',
  FilterGardenView = 'FILTER_GARDEN_VIEW',
  FilterGayLesbianTravel = 'FILTER_GAY_LESBIAN_TRAVEL',
  FilterGiftShop = 'FILTER_GIFT_SHOP',
  FilterGrandVistas = 'FILTER_GRAND_VISTAS',
  FilterGroupFacilities = 'FILTER_GROUP_FACILITIES',
  FilterGuesthouse = 'FILTER_GUESTHOUSE',
  FilterGuestCottage = 'FILTER_GUEST_COTTAGE',
  FilterGym = 'FILTER_GYM',
  FilterHairDryer = 'FILTER_HAIR_DRYER',
  FilterHammock = 'FILTER_HAMMOCK',
  FilterHangers = 'FILTER_HANGERS',
  FilterHarborView = 'FILTER_HARBOR_VIEW',
  FilterHeater = 'FILTER_HEATER',
  FilterHeavyContinentalBreakfast = 'FILTER_HEAVY_CONTINENTAL_BREAKFAST',
  FilterHighChair = 'FILTER_HIGH_CHAIR',
  FilterHighQualityBedding = 'FILTER_HIGH_QUALITY_BEDDING',
  FilterHistoricProperty = 'FILTER_HISTORIC_PROPERTY',
  FilterHomestay = 'FILTER_HOMESTAY',
  FilterHotTub = 'FILTER_HOT_TUB',
  FilterHotWater = 'FILTER_HOT_WATER',
  FilterHotWaterKettle = 'FILTER_HOT_WATER_KETTLE',
  FilterHypoallergenicBedding = 'FILTER_HYPOALLERGENIC_BEDDING',
  FilterIgloo = 'FILTER_IGLOO',
  FilterInRoomBreakfast = 'FILTER_IN_ROOM_BREAKFAST',
  FilterInRoomBreakfastAvailable = 'FILTER_IN_ROOM_BREAKFAST_AVAILABLE',
  FilterInRoomClimateControl = 'FILTER_IN_ROOM_CLIMATE_CONTROL',
  FilterIronIroningBoard = 'FILTER_IRON_IRONING_BOARD',
  FilterIsland = 'FILTER_ISLAND',
  FilterJacuzziInRoom = 'FILTER_JACUZZI_IN_ROOM',
  FilterKayak = 'FILTER_KAYAK',
  FilterKingBedsOnsite = 'FILTER_KING_BEDS_ONSITE',
  FilterLakefront = 'FILTER_LAKEFRONT',
  FilterLakeView = 'FILTER_LAKE_VIEW',
  FilterLaundromatNearby = 'FILTER_LAUNDROMAT_NEARBY',
  FilterLaundryFacilities = 'FILTER_LAUNDRY_FACILITIES',
  FilterLoft = 'FILTER_LOFT',
  FilterLongTermStaysAllowed = 'FILTER_LONG_TERM_STAYS_ALLOWED',
  FilterLuggageDropoffAllowed = 'FILTER_LUGGAGE_DROPOFF_ALLOWED',
  FilterLuxury = 'FILTER_LUXURY',
  FilterMansion = 'FILTER_MANSION',
  FilterMarinaView = 'FILTER_MARINA_VIEW',
  FilterMeetingsEvents = 'FILTER_MEETINGS_EVENTS',
  FilterMeetingRooms = 'FILTER_MEETING_ROOMS',
  FilterMicrowave = 'FILTER_MICROWAVE',
  FilterMidRange = 'FILTER_MID_RANGE',
  FilterMinibar = 'FILTER_MINIBAR',
  FilterMiniFridge = 'FILTER_MINI_FRIDGE',
  FilterMosquitoNet = 'FILTER_MOSQUITO_NET',
  FilterMountainView = 'FILTER_MOUNTAIN_VIEW',
  FilterMultilingualStaff = 'FILTER_MULTILINGUAL_STAFF',
  FilterNearAGolfCourse = 'FILTER_NEAR_A_GOLF_COURSE',
  FilterNearNightlife = 'FILTER_NEAR_NIGHTLIFE',
  FilterNearPublicTransportation = 'FILTER_NEAR_PUBLIC_TRANSPORTATION',
  FilterNonSmoking = 'FILTER_NON_SMOKING',
  FilterOceanfront = 'FILTER_OCEANFRONT',
  FilterOceanView = 'FILTER_OCEAN_VIEW',
  FilterOutdoorDiningArea = 'FILTER_OUTDOOR_DINING_AREA',
  FilterOutdoorFirePit = 'FILTER_OUTDOOR_FIRE_PIT',
  FilterOutdoorFurniture = 'FILTER_OUTDOOR_FURNITURE',
  FilterOutdoorKitchen = 'FILTER_OUTDOOR_KITCHEN',
  FilterOutdoorMovieTheater = 'FILTER_OUTDOOR_MOVIE_THEATER',
  FilterOutdoorShower = 'FILTER_OUTDOOR_SHOWER',
  FilterOutletCovers = 'FILTER_OUTLET_COVERS',
  FilterOven = 'FILTER_OVEN',
  FilterPaidParkingOffPremises = 'FILTER_PAID_PARKING_OFF_PREMISES',
  FilterPaidParkingOnPremises = 'FILTER_PAID_PARKING_ON_PREMISES',
  FilterParkView = 'FILTER_PARK_VIEW',
  FilterPetsNotAllowed = 'FILTER_PETS_NOT_ALLOWED',
  FilterPetFriendly = 'FILTER_PET_FRIENDLY',
  FilterPiano = 'FILTER_PIANO',
  FilterPingPongTable = 'FILTER_PING_PONG_TABLE',
  FilterPool = 'FILTER_POOL',
  FilterPoolTable = 'FILTER_POOL_TABLE',
  FilterPortableFans = 'FILTER_PORTABLE_FANS',
  FilterPrivateBathrooms = 'FILTER_PRIVATE_BATHROOMS',
  FilterPrivateEntrances = 'FILTER_PRIVATE_ENTRANCES',
  FilterPrivateHome = 'FILTER_PRIVATE_HOME',
  FilterProfessionalBedAndBreakfast = 'FILTER_PROFESSIONAL_BED_AND_BREAKFAST',
  FilterRecordPlayer = 'FILTER_RECORD_PLAYER',
  FilterRefrigerator = 'FILTER_REFRIGERATOR',
  FilterResortView = 'FILTER_RESORT_VIEW',
  FilterRiverfront = 'FILTER_RIVERFRONT',
  FilterRiverView = 'FILTER_RIVER_VIEW',
  FilterRollawayAvailable = 'FILTER_ROLLAWAY_AVAILABLE',
  FilterRollInShower = 'FILTER_ROLL_IN_SHOWER',
  FilterRomantic = 'FILTER_ROMANTIC',
  FilterRoomDarkeningShades = 'FILTER_ROOM_DARKENING_SHADES',
  FilterRoomHasKitchen = 'FILTER_ROOM_HAS_KITCHEN',
  FilterRyokanJapan = 'FILTER_RYOKAN_JAPAN',
  FilterSafe = 'FILTER_SAFE',
  FilterSauna = 'FILTER_SAUNA',
  FilterSeaView = 'FILTER_SEA_VIEW',
  FilterShampoo = 'FILTER_SHAMPOO',
  FilterShowerGel = 'FILTER_SHOWER_GEL',
  FilterSingleLevelHome = 'FILTER_SINGLE_LEVEL_HOME',
  FilterSittingArea = 'FILTER_SITTING_AREA',
  FilterSkiInSkiOut = 'FILTER_SKI_IN_SKI_OUT',
  FilterSlippers = 'FILTER_SLIPPERS',
  FilterSmokeAlarm = 'FILTER_SMOKE_ALARM',
  FilterSmokingPermitted = 'FILTER_SMOKING_PERMITTED',
  FilterSofabed = 'FILTER_SOFABED',
  FilterSoundSystem = 'FILTER_SOUND_SYSTEM',
  FilterSpa = 'FILTER_SPA',
  FilterStationaryBike = 'FILTER_STATIONARY_BIKE',
  FilterStove = 'FILTER_STOVE',
  FilterStrictDailyCleaningRegimen = 'FILTER_STRICT_DAILY_CLEANING_REGIMEN',
  FilterSuitableForChildren = 'FILTER_SUITABLE_FOR_CHILDREN',
  FilterSuitableForInfants = 'FILTER_SUITABLE_FOR_INFANTS',
  FilterTableCornerGuards = 'FILTER_TABLE_CORNER_GUARDS',
  FilterTent = 'FILTER_TENT',
  FilterToaster = 'FILTER_TOASTER',
  FilterTrain = 'FILTER_TRAIN',
  FilterTrashCompactor = 'FILTER_TRASH_COMPACTOR',
  FilterTravelCrib = 'FILTER_TRAVEL_CRIB',
  FilterTreadmill = 'FILTER_TREADMILL',
  FilterTv = 'FILTER_TV',
  FilterTwoBedsInRoom = 'FILTER_TWO_BEDS_IN_ROOM',
  FilterUrbanInn = 'FILTER_URBAN_INN',
  FilterValleyView = 'FILTER_VALLEY_VIEW',
  FilterVegetarianMeals = 'FILTER_VEGETARIAN_MEALS',
  FilterVineyardView = 'FILTER_VINEYARD_VIEW',
  FilterWasher = 'FILTER_WASHER',
  FilterWasherAndDryer = 'FILTER_WASHER_AND_DRYER',
  FilterWaterfront = 'FILTER_WATERFRONT',
  FilterWeddings = 'FILTER_WEDDINGS',
  FilterWheelchairFriendly = 'FILTER_WHEELCHAIR_FRIENDLY',
  FilterWhirlpoolTubAllRooms = 'FILTER_WHIRLPOOL_TUB_ALL_ROOMS',
  FilterWhirlpoolTubSomeRooms = 'FILTER_WHIRLPOOL_TUB_SOME_ROOMS',
  FilterWholeHouseBuildingRental = 'FILTER_WHOLE_HOUSE_BUILDING_RENTAL',
  FilterWindowGuards = 'FILTER_WINDOW_GUARDS',
  FilterWinery = 'FILTER_WINERY',
  FilterWineGlasses = 'FILTER_WINE_GLASSES',
  FilterWorkspace = 'FILTER_WORKSPACE',
  FilterYogaMat = 'FILTER_YOGA_MAT',
  GuestCapacity = 'GUEST_CAPACITY',
  HostBio = 'HOST_BIO',
  HostDisplayName = 'HOST_DISPLAY_NAME',
  Images = 'IMAGES',
  InstagramUsername = 'INSTAGRAM_USERNAME',
  Lat = 'LAT',
  Lng = 'LNG',
  LocationObfuscated = 'LOCATION_OBFUSCATED',
  MarketingWebsiteUrl = 'MARKETING_WEBSITE_URL',
  Name = 'NAME',
  NumberOfBathrooms = 'NUMBER_OF_BATHROOMS',
  NumberOfBeds = 'NUMBER_OF_BEDS',
  NumberOfFloors = 'NUMBER_OF_FLOORS',
  NumberOfRooms = 'NUMBER_OF_ROOMS',
  PinterestUsername = 'PINTEREST_USERNAME',
  PlaceId = 'PLACE_ID',
  PlaceName = 'PLACE_NAME',
  PostalCode = 'POSTAL_CODE',
  PropertyType = 'PROPERTY_TYPE',
  PublicEmail = 'PUBLIC_EMAIL',
  PublicPhoneNumber = 'PUBLIC_PHONE_NUMBER',
  State = 'STATE',
  TwitterHandle = 'TWITTER_HANDLE',
  UniquePropertyType = 'UNIQUE_PROPERTY_TYPE',
}

export type FreePromoCreateReservationInput = {
  orderId: Scalars['ID']['input'];
  /** The promo code for the free reservation */
  promoCode: Scalars['String']['input'];
};

export type FreePromoCreateReservationResult =
  | InvalidPromoCodeError
  | NotFoundError
  | Reservation
  | ReservationUnavailable
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Gallery asset object */
export type GalleryAsset = {
  /** The gallery asset description */
  description?: Maybe<Scalars['String']['output']>;
  /** The endpoint of the image host */
  endpoint?: Maybe<Scalars['String']['output']>;
  /** The gallery asset ID */
  id: Scalars['String']['output'];
  /** The path for the image, relative to the endpoint */
  path?: Maybe<Scalars['String']['output']>;
  /** The position of the gallery asset */
  position: Scalars['Float']['output'];
  /** The gallery asset processing flag */
  processing: Scalars['Boolean']['output'];
  /** The gallery asset raw URL (no-cache) */
  rawUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The gallery asset thumb URL
   * @deprecated Use path and endpoint fields with media CDN for image variants
   */
  thumbUrl?: Maybe<Scalars['String']['output']>;
  /** The gallery asset URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** Response for getting an innkeepers gallery asset by its ID */
export type GalleryAssetByIdResponse =
  | GalleryAsset
  | NotFoundError
  | UnauthenticatedError;

export type GalleryAssetCreateInput = {
  /** The listing id. */
  listingId: Scalars['ID']['input'];
  /** The gallery asset position. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** The gallery asset raw upload url. */
  rawUploadUrl: Scalars['String']['input'];
};

/** The result of the gallery asset create */
export type GalleryAssetCreateResponse =
  | GalleryAsset
  | UnauthenticatedError
  | ValidationErrorCollection;

export type GalleryAssetDeleteInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
};

/** The result of the gallery asset update image */
export type GalleryAssetDeleteResponse =
  | GalleryAsset
  | NotFoundError
  | UnauthenticatedError;

export type GalleryAssetOrderInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The Listing ID of an existing listing. */
  listingId: Scalars['ID']['input'];
  /** The ID of the previous gallery asset. */
  previousGalleryAssetId: Scalars['ID']['input'];
};

/** The result of the gallery asset order */
export type GalleryAssetOrderResponse =
  | GalleryAsset
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type GalleryAssetUpdateImageInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
  /** The upload url for the gallery asset. */
  uploadUrl: Scalars['String']['input'];
};

/** The result of the gallery asset update image */
export type GalleryAssetUpdateImageResponse =
  | GalleryAsset
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type GalleryAssetUpdateInput = {
  /** The ID of an existing gallery asset. */
  id: Scalars['ID']['input'];
  /** The listing ID. */
  listingId: Scalars['ID']['input'];
  /** The position for the gallery asset. */
  position: Scalars['Int']['input'];
};

/** The result of the gallery asset update */
export type GalleryAssetUpdateResponse =
  | GalleryAsset
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Geometric data for the place */
export type Geometry = {
  /** The center point for the given place */
  centerPoint?: Maybe<Point>;
  /** The north east point for the given place */
  northEastPoint?: Maybe<Point>;
  /** The south west point for the given place */
  southWestPoint?: Maybe<Point>;
};

/** Gift card object */
export type GiftCard = {
  /** The gift card certificate number */
  certificateNumber?: Maybe<Scalars['String']['output']>;
  /** The time the gift card was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The gift card current balance in cents */
  currentBalanceCents: Scalars['Int']['output'];
  /** The admin that deactivated the gift card */
  deactivatedByAdmin?: Maybe<Admin>;
  /** The reason the gift card was deactivated */
  deactivationDescription?: Maybe<Scalars['String']['output']>;
  /** The gift card ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  imageUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The gift card image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The time that the gift card was issued */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin that issued the gift card */
  issuedByAdmin?: Maybe<Admin>;
  /** The gift card notes array */
  notes: Array<GiftCardNote>;
  /** The gift card order amount in cents */
  orderAmountCents: Scalars['Int']['output'];
  /** The gift card order number */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The client secret for completing payment intents */
  paymentServiceTransactionClientSecret?: Maybe<Scalars['String']['output']>;
  /** The promo that was applied to the gift card when it was created */
  promo?: Maybe<GiftCardPromos>;
  /** The parent gift card that qualified for the promotion */
  qualifiedPromotionalGiftCard?: Maybe<GiftCard>;
  /** The parent gift card that qualified for the promotion */
  qualifiedPromotionalGiftCards: Array<Maybe<GiftCard>>;
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address city */
  recipientCity?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's email */
  recipientEmail?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's first name */
  recipientFirstName: Scalars['String']['output'];
  /** The gift card recipient's last name */
  recipientLastName?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address lat */
  recipientLat?: Maybe<Scalars['Float']['output']>;
  /** The gift card recipient's address lng */
  recipientLng?: Maybe<Scalars['Float']['output']>;
  /** The gift card recipient's address postal code */
  recipientPostalCode?: Maybe<Scalars['String']['output']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address line one */
  senderAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address line two */
  senderAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address city */
  senderCity?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's country name */
  senderCountryShortName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's email */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's frist name */
  senderFirstName: Scalars['String']['output'];
  /** The gift card sender's last name */
  senderLastName?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's message to the recipient */
  senderMessage?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's phone number */
  senderPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's postal code */
  senderPostalCode?: Maybe<Scalars['String']['output']>;
  /** The gift card sender's address state or province long name */
  senderStateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The gift card shipping fee in cents */
  shippingFeeCents: Scalars['Int']['output'];
  /** The shipping provider for a physical card */
  shippingProvider?: Maybe<ShippingProviderType>;
  /** The gift card shipping type */
  shippingType?: Maybe<GiftCardShippingType>;
  /** The gift card status */
  status: GiftCardStatus;
  /** The tracking number for a physical card */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** The gift card transactions array */
  transactions: Array<Transaction>;
  /** The gift card type */
  type: GiftCardType;
  /** The time that the gift card was verified */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin that verified the gift card */
  verifiedByAdmin?: Maybe<Admin>;
};

/** Response for fetching a gift card by cert number */
export type GiftCardByCertificateNumberResponse = GiftCard | NotFoundError;

/** Response for fetching a gift card by cert number */
export type GiftCardByIdResponse = GiftCard | NotFoundError;

export type GiftCardByPaymentServiceTransactionClientSecretResponse =
  | GiftCard
  | NotFoundError;

export type GiftCardCreateInput = {
  imageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The gift card order amount in cents */
  orderAmountCents: Scalars['Int']['input'];
  promo?: InputMaybe<GiftCardPromos>;
  /** The gift card recipient's address line one */
  recipientAddressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address line two */
  recipientAddressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address city */
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address country */
  recipientCountryShortName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's email */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's first name */
  recipientFirstName: Scalars['String']['input'];
  /** The gift card recipient's address postal code */
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** The gift card recipient's address state or province long name */
  recipientStateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The gift card sender's first name */
  senderFirstName: Scalars['String']['input'];
  /** The gift card sender's message to the recipient */
  senderMessage?: InputMaybe<Scalars['String']['input']>;
  /** The gift card shipping type */
  shippingType?: InputMaybe<GiftCardShippingType>;
  /** The gift card type */
  type: GiftCardType;
};

/** The gift card image object */
export type GiftCardImage = {
  /** The gift card image active flag */
  active: Scalars['Boolean']['output'];
  /** The gift card image ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The gift card image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  /** The gift card image name */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

/** Response for getting a gift card image by its ID when authenticated as an admin */
export type GiftCardImageByIdResponse =
  | GiftCardImage
  | NotFoundError
  | UnauthenticatedError;

export type GiftCardImageCollection = {
  /** The collection of gift card images for a given page */
  entries: Array<GiftCardImage>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** Transaction recorded when a gift card is create by an admin */
export type GiftCardInitialBalanceTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the gift card was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the recipient of the transaction */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Transaction recorded when a gift card journal entry is created */
export type GiftCardJournalTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the transaction was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the recipient of the amount */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The gift card note object */
export type GiftCardNote = {
  /** The body text on the note */
  body: Scalars['String']['output'];
  /** The time the gift card note was created */
  createdAt: Scalars['DateTime']['output'];
  /** The admin that created the gift card note */
  createdByAdmin: Admin;
  /** The gift card note ID */
  id: Scalars['ID']['output'];
  /** Datetime the gift card note was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export enum GiftCardPromos {
  BigHolidayTwentyTwo = 'BIG_HOLIDAY_TWENTY_TWO',
  FreePriorityExpressShipping = 'FREE_PRIORITY_EXPRESS_SHIPPING',
  FreePriorityShipping = 'FREE_PRIORITY_SHIPPING',
  HolidayTwentyTwo = 'HOLIDAY_TWENTY_TWO',
}

/** Transaction recorded when a gift card is purchased */
export type GiftCardPurchasedTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card payment source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The gift card payment source brand e.g. Visa etc. */
  paymentSourceBrand: Scalars['String']['output'];
  /** The gift card payment source ID (last 4 of CC, payment account id, etc) */
  paymentSourceId: Scalars['String']['output'];
  /** The gift card payment source type */
  paymentSourceType: TransactionPaymentSourceType;
  /** The gift card that was the recipient of the amount */
  recipient: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type GiftCardRedeemInput = {
  /** The amount to redeem from the gift card balance */
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** Reason for the redemption */
  redemptionTransactionDescription: Scalars['String']['input'];
};

/** The result of redeeming a gift card */
export type GiftCardRedeemResponse =
  | GiftCard
  | NotFoundError
  | UnauthenticatedError
  | UnverifiedError
  | ValidationErrorCollection;

/** Transaction recorded when a gift card has an amount redeemed */
export type GiftCardRedemptionTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was used to pay the amount */
  payor: GiftCard;
  /** The listing that redeemed the gift card amount */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Transaction recorded when a gift card is refunded to the purchasor */
export type GiftCardRefundTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The payment refund source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The payment refund source type */
  paymentServiceTransactionType: PaymentServiceTransactionType;
  /** The gift card that was the payor of the transaction */
  payor: GiftCard;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** The gift card shipping type */
export enum GiftCardShippingType {
  /** Free shipping */
  Free = 'FREE',
  /** USPS Priority Mail */
  Priority = 'PRIORITY',
  /** USPS Next Day */
  PriorityExpress = 'PRIORITY_EXPRESS',
}

/** The gift card status */
export enum GiftCardStatus {
  /** The gift card is currently active */
  Active = 'ACTIVE',
  /** The gift card has been deactivated */
  Deactivated = 'DEACTIVATED',
  /** The gift card is waiting to be issued to the recipient */
  Unissued = 'UNISSUED',
  /** The gift card is waiting for the purchase to be confirmed */
  Unpurchased = 'UNPURCHASED',
  /** The gift card is waiting for verification */
  Unverified = 'UNVERIFIED',
}

/** The gift card type */
export enum GiftCardType {
  /** Digital gift card that is sent via email */
  Digital = 'DIGITAL',
  /** Physical gift card that is sent in the mail */
  Physical = 'PHYSICAL',
}

export type GiftCardUpdateUnpurchasedInput = {
  /** The gift card ID */
  id: Scalars['ID']['input'];
  /** The gift card order amount in cents */
  orderAmountCents?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<GiftCardPromos>;
  /** The senders email */
  senderEmail: Scalars['String']['input'];
  /** The gift card shipping type */
  shippingType?: InputMaybe<GiftCardShippingType>;
};

/** The result of redeeming a gift card */
export type GiftCardUpdateUnpurchasedResponse =
  | GiftCard
  | NotFoundError
  | ValidationErrorCollection;

export type GuestyDhPmsConnectionCreateInput = {
  username: Scalars['String']['input'];
};

export type GuestyPmsConnectionCreateInput = {
  accessToken: Scalars['String']['input'];
};

/** Homepage listing sections object */
export type HomePageListingSections = {
  /** The featured listings for the homepage */
  featured: Array<Listing>;
  /** The highly rated listings for the homepage */
  highlyRated: Array<Listing>;
  /** The trending listings for the homepage */
  trending: Array<Listing>;
};

export type HospitablePmsConnectionCreateInput = {
  code: Scalars['String']['input'];
};

export type HostawayPmsConnectionCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
};

export type HostfullyPmsConnectionCreateInput = {
  agencyUid?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentityProvider {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
}

/** The result of creating an identity verification inquiry */
export type IdentityVerificationCreateResult =
  | IdentityVerificationInquiryResult
  | UnauthenticatedError
  | ValidationErrorCollection;

export type IdentityVerificationInquiryResult = {
  personaInquiryId: Scalars['String']['output'];
  sessionToken?: Maybe<Scalars['String']['output']>;
};

/** The result of creating a traveler government-ID inquiry */
export type TravelerIdentityVerificationCreateResult =
  | TravelerIdentityVerificationInquiryResult
  | UnauthenticatedError
  | ValidationErrorCollection;

export type TravelerIdentityVerificationInquiryResult = {
  personaInquiryId: Scalars['String']['output'];
  sessionToken?: Maybe<Scalars['String']['output']>;
};

/** Innkeeper object */
export type Innkeeper = {
  /** The innkeeper access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** The role this user has for the host-side account */
  accountRole?: Maybe<AccountRole>;
  /** Flag indicating if the account has been claimed */
  claimable: Scalars['Boolean']['output'];
  /** The innkeeper email */
  email: Scalars['String']['output'];
  /** The innkeeper first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The innkeeper ID */
  id: Scalars['ID']['output'];
  /** Flag indicating if the account identity has been verified */
  identityVerified: Scalars['Boolean']['output'];
  /** The last time the innkeeper authenticated themselves on the platform */
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The innkeeper last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The innkeeper payment service ID */
  paymentServiceUserId: Scalars['String']['output'];
  /** The innkeeper phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The innkeeper account that referred this innkeeper */
  referredByUser?: Maybe<Innkeeper>;
  /** The innkeeper account ID that referred this innkeeper */
  referredByUserId?: Maybe<Scalars['String']['output']>;
  /** The innkeeper refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The date time the account was registered */
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A booking quote is not available */
export type InternalBookingQuoteUnavailable = {
  message: Scalars['String']['output'];
};

export type InvalidPromoCodeError = {
  message: Scalars['String']['output'];
};

export type IosWaitlistSubscription = {
  /** User's email */
  email: Scalars['String']['output'];
};

export type LeadCreatedMessage = {
  message: Scalars['String']['output'];
};

/** Response for getting the listings favorited by the current authenticated user */
export type ListAllFavoritedResponse = ListingCollection | UnauthenticatedError;

/** Listing object */
export type Listing = {
  /** The account that the listing belongs to */
  account: Account;
  /** The listing address line one */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The listing address line two */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The listing affiliations array */
  affiliations: Array<Affiliation>;
  /** The listing Airbnb URL */
  airbnbUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing has been archived */
  archived: Scalars['Boolean']['output'];
  /** Datetime the listing was archived */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Average savings percentage compared to OTAs (positive = cheaper). Materialized from the pricing-stats columns (pricing_stats_sum / pricing_stats_count); nil when there is no data. */
  averageSavings?: Maybe<Scalars['Float']['output']>;
  /** The listing book direct website URL */
  bookDirectWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The template for additional listing book direct website URL parameters. Details:
   * - Template engine: Handlebars
   * - Expected helper functions: registerHelper, compile, add
   * - Input object shape: BookDirectWebsiteUrlParamsTemplateInput
   */
  bookDirectWebsiteUrlParamsTemplate?: Maybe<Scalars['String']['output']>;
  /** The listing cancellation policy */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** The check in time for a listing */
  checkIn?: Maybe<SupportedCheckInAndOutTimes>;
  /** The checkout time for a listing */
  checkout?: Maybe<SupportedCheckInAndOutTimes>;
  /** The listing city */
  city?: Maybe<Scalars['String']['output']>;
  /** The listing country or region long name */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /** The current account balance for the listing */
  currentBalanceCents: Scalars['Int']['output'];
  /** The listing text description */
  description?: Maybe<Scalars['String']['output']>;
  /** The listing's distance from the center point of a search */
  distanceFromSearchPoint?: Maybe<Scalars['Float']['output']>;
  /** The external id of the listing */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The external source of the listing */
  externalSource?: Maybe<ExternalSource>;
  /** The listing FaceBook page URL */
  facebookPageUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the listing has been featured by the property owner */
  featuredByOwner: Scalars['Boolean']['output'];
  /** The listing features array */
  features: Array<Feature>;
  /** Datetime the listing was first published */
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing gallery assets array */
  galleryAssets: Array<GalleryAsset>;
  /** The gust capacity */
  guestCapacity?: Maybe<Scalars['Int']['output']>;
  /** The listing host bio/description */
  hostBio?: Maybe<Scalars['String']['output']>;
  /** The listing host display name */
  hostDisplayName?: Maybe<Scalars['String']['output']>;
  /** The endpoint of the listing host image */
  hostImageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The listing host image path, relative to the endpoint */
  hostImagePath?: Maybe<Scalars['String']['output']>;
  /** The listing host image processing flag */
  hostImageProcessing: Scalars['Boolean']['output'];
  /** The listing host image URL */
  hostImageUrl?: Maybe<Scalars['String']['output']>;
  /** The listing ID */
  id: Scalars['ID']['output'];
  /** Flag indicating if the listing can be dynamically indexed by Google */
  indexable: Scalars['Boolean']['output'];
  /** Datetime the listing was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Instagram username */
  instagramUsername?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing is part of the diamond collection */
  isDiamondCollection: Scalars['Boolean']['output'];
  /** Flag indicating if the listing is favorited or not */
  isFavorited: Scalars['Boolean']['output'];
  /** Datetime the listing was last published */
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing location latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** The listing license number */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  /** The floor the listing exists on */
  listedFloor?: Maybe<Scalars['Int']['output']>;
  /** The listing level */
  listingLevel: SubscriptionType;
  /** The listing location longitude */
  lng?: Maybe<Scalars['Float']['output']>;
  /** Exact location not given */
  locationObfuscated: Scalars['Boolean']['output'];
  /** Flag indicating if the location was manually set by an admin */
  locationSetManually: Scalars['Boolean']['output'];
  /** The listing marketing website URL */
  marketingWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** The maximum stay price in cents */
  maxPrice?: Maybe<Scalars['Int']['output']>;
  /** The minimum stay price in cents */
  minPrice?: Maybe<Scalars['Int']['output']>;
  /** The listing name */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of bathrroms */
  numberOfBathrooms?: Maybe<Scalars['Float']['output']>;
  /** The number of beds */
  numberOfBeds?: Maybe<Scalars['Int']['output']>;
  /** The number of floors */
  numberOfFloors?: Maybe<Scalars['Int']['output']>;
  /** The number of rooms */
  numberOfRooms?: Maybe<Scalars['Int']['output']>;
  /** Flag indicating the listing is an NYC short-term rental that needs NYC OSE verification before it can be booked on Savvy */
  ose: Scalars['Boolean']['output'];
  /** The user identity that owns the listing */
  owner: User;
  /** The fee to payout with check in cents */
  payoutCheckFeeCents?: Maybe<Scalars['Int']['output']>;
  /** The payout commission percentage on the listing */
  payoutCommissionPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** The listing Pinterest URL */
  pinterestUrl?: Maybe<Scalars['String']['output']>;
  /** The listing Pinterest username */
  pinterestUsername?: Maybe<Scalars['String']['output']>;
  /** The listing google place ID */
  placeId?: Maybe<Scalars['String']['output']>;
  /** The listing google place name */
  placeName?: Maybe<Scalars['String']['output']>;
  /** The listing policies array */
  policies: Array<PolicyUnion>;
  /** The listing postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The precise listing address line one */
  preciseAddressLineOne?: Maybe<Scalars['String']['output']>;
  /** The precise listing address line two */
  preciseAddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The precise listing location latitude */
  preciseLat?: Maybe<Scalars['Float']['output']>;
  /** The precise listing location longitude */
  preciseLng?: Maybe<Scalars['Float']['output']>;
  /** Flag indicating the listing page loads by slug while unpublished */
  previewable: Scalars['Boolean']['output'];
  /** The listing price object */
  priceDisplay?: Maybe<PriceDisplay>;
  /** The property type for the listing */
  propertyType?: Maybe<PropertyType>;
  /** The listing public email */
  publicEmail?: Maybe<Scalars['String']['output']>;
  /** The listing public phone number */
  publicPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** The ip address at the time the listing was published */
  publishIpAddress?: Maybe<Scalars['String']['output']>;
  /** Flag indicating if the listing is published or not */
  published: Scalars['Boolean']['output'];
  /** The regions that the listing belongs to */
  regions: Array<Region>;
  /** The listing review summary */
  reviewSummary?: Maybe<Scalars['String']['output']>;
  /** The listing reviews array */
  reviews?: Maybe<Array<ListingReview>>;
  /** The listing reviews average rating */
  reviewsAverageRating?: Maybe<Scalars['Float']['output']>;
  /** The listing reviews count */
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  /** The listing rooms */
  rooms: Array<Room>;
  /** The search promotion type for the listing */
  searchPromotionType?: Maybe<SearchPromotionType>;
  /** Whether or not the listing's availability is capable of displaying in search results */
  searchableAvailability: Scalars['Boolean']['output'];
  /** Whether or not the listing's real-time rates are capable of displaying in search results */
  searchableRates?: Maybe<Scalars['Boolean']['output']>;
  /** The listing SEO friendly url slug */
  slug: Scalars['String']['output'];
  /** The listing state or province long name */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The listing level */
  subscriptionType: SubscriptionType;
  /** Flag indicating if the listing supports bookings or not */
  supportsBookings: Scalars['Boolean']['output'];
  /** True when the guest books through the PMS's own checkout, opened in an iframe from the booking quote's iframeBookingUrl */
  supportsIframeBooking: Scalars['Boolean']['output'];
  /** Flag indicating if the listing supports booking quotes or not */
  supportsQuotes: Scalars['Boolean']['output'];
  /** The listing terms and conditions link */
  termsAndConditionsLink?: Maybe<Scalars['String']['output']>;
  /** The listing terms and conditions text */
  termsAndConditionsText?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter handle */
  twitterHandle?: Maybe<Scalars['String']['output']>;
  /** The listing Twitter URL */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** The unique property type for the listing */
  uniquePropertyType?: Maybe<UniquePropertyType>;
  /** The errors preventing auto-publish */
  unpublishableErrors: Array<ListingValidationError>;
  /** Datetime the listing was unpublished published. Will be null if published regardless of past history. */
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Datetime the listing was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The external source of the listing */
  userConfig: Array<ConfigItem>;
  /** The listing vrbo URL */
  vrboUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating a W9 on file for the listing */
  wNineOnFile: Scalars['Boolean']['output'];
  /** The listing YouTube page URL */
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

/** Listing object */
export type ListingBookDirectWebsiteUrlParamsTemplateArgs = {
  bookDirectWebsiteUrlParamsTemplateInput?: InputMaybe<BookDirectWebsiteUrlParamsTemplateInput>;
};

/** Listing object */
export type ListingGalleryAssetsArgs = {
  numberOfAssets?: InputMaybe<Scalars['Int']['input']>;
  processing?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Listing object */
export type ListingPriceDisplayArgs = {
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  guests?: InputMaybe<Scalars['Int']['input']>;
  pets?: InputMaybe<Scalars['Int']['input']>;
};

/** Listing object */
export type ListingReviewsArgs = {
  numberOfReviews?: InputMaybe<Scalars['Int']['input']>;
};

/** The statuses for private listing access records */
export enum ListingAccessStatuses {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Requested = 'REQUESTED',
}

export type ListingApproveAccessForUserInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The User ID for the user whose access is being approved */
  userId: Scalars['ID']['input'];
};

/** The result of the listing approve access mutation for an authenticated user */
export type ListingApproveAccessForUserResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** An error encountered when the listing is archived */
export type ListingArchivedError = {
  message: Scalars['String']['output'];
};

/** Booking Info object */
export type ListingBookingInfo = {
  /** The array containing availability details for a listing */
  availabilityDates: Array<Availability>;
};

/** Response for fetching booking info on a listing */
export type ListingBookingInfoResponse = ListingBookingInfo | NotFoundError;

/** Response for fetching an active listing by its external_id */
export type ListingByExternalIdAndSourceResponse = Listing | NotFoundError;

/** Response for fetching an active listing by its id and account */
export type ListingByIdAndUserResponse = Listing | NotFoundError;

/** Response for fetching an active listing by its slug */
export type ListingBySlugResponse =
  | Listing
  | ListingArchivedError
  | ListingUnpublishedError
  | NotFoundError
  | UnauthenticatedError
  | UnauthorizedError;

/** Listing cancellation policy record */
export type ListingCancellationPolicy = Policy & {
  /** The cancellation policy description */
  cancellationPolicy: Scalars['String']['output'];
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** Listings collection object contains a paginated collection of listings and meta data about the collection */
export type ListingCollection = {
  /** The collection of listings for a given page */
  entries: Array<Listing>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type ListingCreateInput = {
  /** The listing address line one */
  addressLineOne: Scalars['String']['input'];
  /** The listing address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The listing city */
  city: Scalars['String']['input'];
  /** The listing country or region long name */
  countryOrRegionLongName: Scalars['String']['input'];
  /** The listing location latitude */
  lat: Scalars['Float']['input'];
  /** The listing license_number policy */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** The listing location longitude */
  lng: Scalars['Float']['input'];
  /** The location provided will be obfuscated. */
  locationObfuscated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing google place ID */
  placeId: Scalars['String']['input'];
  /** The listing google place name */
  placeName: Scalars['String']['input'];
  /** The listing postal code */
  postalCode: Scalars['String']['input'];
  /** The property type for the listing that is being created */
  propertyType: PropertyType;
  /** The listing state or province long name */
  stateOrProvinceLongName: Scalars['String']['input'];
  /** The unique property type for the listing that is being created */
  uniquePropertyType?: InputMaybe<UniquePropertyType>;
};

/** The result of the listing create mutation for an authenticated user */
export type ListingCreateResult =
  | Listing
  | UnauthenticatedError
  | ValidationErrorCollection;

export type ListingDeleteInput = {
  /** The ID of the listing id. */
  listingId: Scalars['ID']['input'];
};

/** The result of the delete listing mutation for an authenticated innkeeper */
export type ListingDeleteResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError;

export type ListingDenyAccessForUserInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The User ID for the user whose access is being approved */
  userId: Scalars['ID']['input'];
};

/** The result of the listing deny access mutation for an authenticated user */
export type ListingDenyAccessForUserResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type ListingFavoriteCreateInput = {
  /** The favorited listing's distance from the current search point */
  distanceFromSearchPoint?: InputMaybe<Scalars['Float']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
};

/** The result of the listing favorite create mutation for an authenticated user */
export type ListingFavoriteCreateResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type ListingFavoriteDeleteInput = {
  /** The (un)favorited listing's distance from the current search point */
  distanceFromSearchPoint?: InputMaybe<Scalars['Float']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
};

/** The result of the listing favorite create mutation for an authenticated user */
export type ListingFavoriteDeleteResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** The sort options supported for listings */
export enum ListingFavoriteSortOptions {
  /** The created at time with the newest favorites appearing first */
  FavoritedAtNewestFirst = 'FAVORITED_AT_NEWEST_FIRST',
  /** The created at time with the oldest favorites appearing first */
  FavoritedAtOldestFirst = 'FAVORITED_AT_OLDEST_FIRST',
}

/** Transaction recorded when a listing journal entry is created */
export type ListingJournalTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description as to why the transaction was created */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The transaction that paid out this journal transaction */
  payoutTransaction?: Maybe<ListingPayoutTransaction>;
  /** The listing that was the recipient of the transaction */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ListingLevels = {
  /** The number of listings at bronze */
  bronze: Scalars['Int']['output'];
  /** The number of listings at free */
  free: Scalars['Int']['output'];
  /** The number of listings at gold */
  gold: Scalars['Int']['output'];
  /** The number of listings at silver */
  silver: Scalars['Int']['output'];
};

/** Transaction recorded when a listing balance is paid out */
export type ListingPayoutTransaction = Transaction & {
  /** The admin that created the transaction */
  admin?: Maybe<Admin>;
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The bnbfinder commission amount in cents */
  commissionAmountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The listing payment source ID */
  paymentServiceTransactionId: Scalars['String']['output'];
  /** The listing payment source type */
  paymentServiceTransactionType: PaymentServiceTransactionType;
  /** The listing that was the payor of the transaction */
  payor: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response for getting the listing for the current authenticated innkeeper */
export type ListingPrivateAccessForUserResponse =
  | AccessStatus
  | NotFoundError
  | ValidationErrorCollection;

export type ListingPublishInput = {
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The IP address that is publishing the listing */
  publishIpAddress?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the listing publish mutation for an authenticated user */
export type ListingPublishResult =
  | Listing
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Transaction recorded when a listing redeems an amount from a gift card */
export type ListingRedemptionTransaction = Transaction & {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** A short description about the redmption */
  description: Scalars['String']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The gift card that was the payor of the transaction */
  payor: GiftCard;
  /** The transaction that paid out this redemption */
  payoutTransaction?: Maybe<ListingPayoutTransaction>;
  /** The listing that was the recipient of the transaction */
  recipient: Listing;
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ListingRequestAccessForUserInput = {
  /** The Listing slug */
  listingSlug: Scalars['String']['input'];
};

/** The result of the listing request access mutation for an authenticated user */
export type ListingRequestAccessForUserResult =
  | AccessStatus
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Listing Review object */
export type ListingReview = {
  /** The author for the review */
  authorName?: Maybe<Scalars['String']['output']>;
  /** The body for the review */
  body?: Maybe<Scalars['String']['output']>;
  /** The date for the review */
  date?: Maybe<Scalars['Date']['output']>;
  /** The Listing Review ID */
  id: Scalars['ID']['output'];
  /** The rating for the review */
  rating?: Maybe<Scalars['Float']['output']>;
};

export type ListingReviewCollection = {
  /** The collection of reviews for a given listing */
  entries: Array<ListingReview>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The sort options supported for listing reviews */
export enum ListingReviewSortOptions {
  /** The review date in descending order (newest -> oldest) */
  DateNewestFirst = 'DATE_NEWEST_FIRST',
  /** The review date in ascending order (oldest -> newest) */
  DateOldestFirst = 'DATE_OLDEST_FIRST',
  /** The review rating in descending order (highest -> lowest) */
  RatingHighestFirst = 'RATING_HIGHEST_FIRST',
  /** The review rating in ascending order (lowest -> highest) */
  RatingLowestFirst = 'RATING_LOWEST_FIRST',
}

/** Response for fetching review summaries on a listing */
export type ListingReviewSummariesListAllForListingResponse =
  | ListingReviewSummaryCollection
  | NotFoundError;

/** Listing review summary object */
export type ListingReviewSummary = {
  /** The average rating for the review summary */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** The total number of reviews */
  count?: Maybe<Scalars['Int']['output']>;
  /** The review summary ID */
  id: Scalars['String']['output'];
  /** The timestamp when the review summary was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The listing ID */
  listingId: Scalars['String']['output'];
  /** The review summary source */
  source: ListingReviewSummarySource;
  /** The AI-generated summary text (only for :savvy source) */
  summary?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the review summary was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ListingReviewSummaryCollection = {
  /** The collection of review summaries for a given listing */
  entries: Array<ListingReviewSummary>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The listing review summary source enum */
export enum ListingReviewSummarySource {
  /** The review summary source airbnb enum value */
  Airbnb = 'AIRBNB',
  /** The review summary source bnbfinder enum value */
  Bnbfinder = 'BNBFINDER',
  /** The review summary source google enum value */
  Google = 'GOOGLE',
  /** The review summary source pms enum value */
  Pms = 'PMS',
  /** The review summary source tripadvisor enum value */
  Tripadvisor = 'TRIPADVISOR',
  /** The review summary source vrbo enum value */
  Vrbo = 'VRBO',
}

/** Response for fetching reviews on a listing */
export type ListingReviewsListAllForListingResponse =
  | ListingReviewCollection
  | NotFoundError;

export type ListingSearchCursorCollection = {
  /** The collection of listings for the given search */
  entries: Array<Listing>;
  metadata: CursorCollectionMetadata;
  /** Information about the region being searched */
  searchPlace?: Maybe<SearchPlace>;
};

/** The sort options supported for listings */
export enum ListingSortOptions {
  /** Random value (changes periodically) */
  Random = 'RANDOM',
  /** Search relevance score (highest quality first) */
  Relevance = 'RELEVANCE',
  /** Highest average savings vs OTAs first (cache-backed; nil savings sort last) */
  SavingsDesc = 'SAVINGS_DESC',
  /** The state or province long name value in ascending order (A -> Z) */
  StateOrProvinceLongNameAsc = 'STATE_OR_PROVINCE_LONG_NAME_ASC',
  /** The state or province long name value in descending order (Z -> A) */
  StateOrProvinceLongNameDesc = 'STATE_OR_PROVINCE_LONG_NAME_DESC',
}

/** Listing terms and conditions policy record */
export type ListingTermsAndConditions = Policy & {
  /** The terms and conditions description */
  description?: Maybe<Scalars['String']['output']>;
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The terms and conditions link */
  termsLink?: Maybe<Scalars['String']['output']>;
  /** The terms and conditions upload url */
  termsUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The policy type */
  type: PolicyType;
};

/** The result of the listing unpublish mutation for an authenticated user */
export type ListingUnpublishResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** An error encountered when the listing is unpublished */
export type ListingUnpublishedError = {
  message: Scalars['String']['output'];
};

export type ListingUpdateInput = {
  /** The listing address line one */
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  /** The listing address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The listing book direct website URL */
  bookDirectWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  checkIn?: InputMaybe<SupportedCheckInAndOutTimes>;
  checkout?: InputMaybe<SupportedCheckInAndOutTimes>;
  /** The listing city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The listing country or region long name */
  countryOrRegionLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The URL for a listings facebook page */
  facebookPageUrl?: InputMaybe<Scalars['String']['input']>;
  featureKeys?: InputMaybe<Array<FeatureKey>>;
  guestCapacity?: InputMaybe<Scalars['Int']['input']>;
  /** The listing's host bio */
  hostBio?: InputMaybe<Scalars['String']['input']>;
  /** The listing's host display name */
  hostDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** The listing's host image upload URL */
  hostImageUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The listing's instagram username */
  instagramUsername?: InputMaybe<Scalars['String']['input']>;
  /** The listing location latitude */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** The listing license number */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  listedFloor?: InputMaybe<Scalars['Int']['input']>;
  /** The Listing ID */
  listingId: Scalars['ID']['input'];
  /** The listing location longitude */
  lng?: InputMaybe<Scalars['Float']['input']>;
  locationObfuscated?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing marketing website URL */
  marketingWebsiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** The maximum stay price in cents */
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum stay price in cents */
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  /** The listing name */
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfBathrooms?: InputMaybe<Scalars['Float']['input']>;
  numberOfFloors?: InputMaybe<Scalars['Int']['input']>;
  numberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  /** The listing's pinterest username */
  pinterestUsername?: InputMaybe<Scalars['String']['input']>;
  /** The listing google place ID */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** The listing google place name */
  placeName?: InputMaybe<Scalars['String']['input']>;
  /** The listing postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The property type for the listing that is being updated */
  propertyType?: InputMaybe<PropertyType>;
  /** The listing public email */
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  /** The listing public phone number */
  publicPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The listing state or province long name */
  stateOrProvinceLongName?: InputMaybe<Scalars['String']['input']>;
  /** The listing's twitter handle */
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  /** The unique property type for the listing that is being updated */
  uniquePropertyType?: InputMaybe<UniquePropertyType>;
  /** The listing's YouTube URL */
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the listing update mutation for an authenticated user */
export type ListingUpdateResult =
  | Listing
  | UnauthenticatedError
  | ValidationErrorCollection;

/** An error encountered when attempting to publish a listing */
export type ListingValidationError = {
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** Response for getting the listings for the current authenticated user's account */
export type ListingsSearchResponse =
  | ListingSearchCursorCollection
  | ValidationErrorCollection;

export enum ListingsSearchType {
  Map = 'MAP',
  Region = 'REGION',
}

export type LiveListPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type LodgifyPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

export type LodgixPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

export enum MobileType {
  Android = 'ANDROID',
  Ios = 'IOS',
}

/** Response for checking if the mobile version is valid */
export type MobileVersionResponse = UpgradeRequiredError | Version;

export type NewsletterSubscription = {
  /** User's email */
  email: Scalars['String']['output'];
};

export type NextPaxPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

/** An error encountered when the resource is not found */
export type NotFoundError = {
  message: Scalars['String']['output'];
};

/** Listing Quote object */
export type Order = {
  /** The order id */
  id: Scalars['String']['output'];
  /** The booking quote for the order */
  quote: BookingQuote;
};

export type OrderLoadInput = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  /** The start time for the listing */
  checkInDate: Scalars['Date']['input'];
  /** The end time for the listing */
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  /** The order id. If not provided a new order will be created. If order does not belong to current user a new order will be created. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  /** The slug for the listing */
  slug: Scalars['String']['input'];
};

/** Response for updating order */
export type OrderLoadResponse =
  | NotFoundError
  | Order
  | OrderUnavailable
  | OrderUnsupported
  | UnauthenticatedError
  | ValidationError;

/** A order is not available */
export type OrderUnavailable = {
  message: Scalars['String']['output'];
};

/** A booking order is not supported */
export type OrderUnsupported = {
  message: Scalars['String']['output'];
};

export type OwnerRezPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
};

export type PasswordResetMessage = {
  message: Scalars['String']['output'];
};

export type PaymentItem = {
  /** The amount of the payment in cents */
  amountCents: Scalars['Int']['output'];
  /** The description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** The date the payment is due */
  dueDate: Scalars['Date']['output'];
  /** The type of payment item */
  paymentItemType: PaymentItemType;
};

export enum PaymentItemType {
  /** Payment item is a deposit */
  Deposit = 'DEPOSIT',
  /** Payment item is an installment toward the total price. */
  Installment = 'INSTALLMENT',
}

export enum PaymentServiceTransactionType {
  Check = 'CHECK',
  Stripe = 'STRIPE',
}

export type PhoneVerificationCheckInput = {
  /** The OTP code received via SMS */
  code: Scalars['String']['input'];
  /** Phone number being verified, in E.164 format */
  phoneNumber: Scalars['String']['input'];
};

/** The result of checking a phone verification code */
export type PhoneVerificationCheckResult =
  | ServiceUnavailableError
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

export type PhoneVerificationStartInput = {
  /** Phone number to verify, in E.164 format (e.g. +15125551212) */
  phoneNumber: Scalars['String']['input'];
};

/** The result of starting a phone verification */
export type PhoneVerificationStartResult =
  | ServiceUnavailableError
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

/** Place object */
export type Place = {
  /** The place address line one */
  addressLineOne?: Maybe<Scalars['String']['output']>;
  /** The place address line two */
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  /** The place city */
  city?: Maybe<Scalars['String']['output']>;
  /** The place country or region long name */
  countryOrRegionLongName?: Maybe<Scalars['String']['output']>;
  /** The place country or region short name */
  countryOrRegionShortName?: Maybe<Scalars['String']['output']>;
  /** Geometric data for the place */
  geometry?: Maybe<Geometry>;
  /** The Google place ID */
  id: Scalars['ID']['output'];
  /** The place name */
  name: Scalars['String']['output'];
  /** The place postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The place rating value */
  ratingValue?: Maybe<Scalars['Float']['output']>;
  /** The place maximum potential rating value */
  ratingValueMax?: Maybe<Scalars['Int']['output']>;
  /** The place raw address components from the Google place API */
  rawAddressComponents?: Maybe<Array<RawAddressComponent>>;
  /** The place raw Google place geocoding types */
  rawTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** The place state or province long name */
  stateOrProvinceLongName?: Maybe<Scalars['String']['output']>;
  /** The place state or province short name */
  stateOrProvinceShortName?: Maybe<Scalars['String']['output']>;
};

/** Place autocomplete object */
export type PlaceAutocompletePrediction = {
  /** The Google place ID */
  id: Scalars['ID']['output'];
  /** The place name */
  name: Scalars['String']['output'];
  /** The place raw Google place geocoding types */
  rawTypes?: Maybe<Array<Scalars['String']['output']>>;
};

/** Response for fetching a place by its address */
export type PlaceByAddressResponse = NotFoundError | Place;

/** Response for fetching a place by its ID */
export type PlaceByIdResponse = NotFoundError | Place;

/** The place type that should be returned */
export enum PlaceTypeFilter {
  /** Address specific place types */
  Address = 'ADDRESS',
  /** All place types */
  All = 'ALL',
  /** Establishment specific place types */
  Establishment = 'ESTABLISHMENT',
  /** Geocode specific place types */
  Geocode = 'GEOCODE',
  /** Region specific place types */
  Regions = 'REGIONS',
}

/** Plan object that belongs to products and subscriptions */
export type Plan = {
  /** The amount that the plan cost in cents */
  amount: Scalars['Int']['output'];
  /** The plan ID */
  id: Scalars['ID']['output'];
  /** The plan billing interval */
  interval: PlanInterval;
  /** The plan name */
  name: Scalars['String']['output'];
  /** The product ID that the plan belongs to */
  productId: Scalars['String']['output'];
};

export type PlanCollection = {
  /** The collection of plans for a given page */
  entries: Array<Plan>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The plan interval specifies billing frequency */
export enum PlanInterval {
  /** Bill for plan every day */
  Day = 'DAY',
  /** Bill for plan once per month */
  Month = 'MONTH',
  /** Bill for plan once per week */
  Week = 'WEEK',
  /** Bill for plan once per year */
  Year = 'YEAR',
}

/** Response for getting plans */
export type PlansListAllResponse =
  | PlanCollection
  | ServiceUnavailableError
  | UnauthenticatedError;

export type PmAccountCreateInput = {
  /** The account address line one */
  addressLineOne: Scalars['String']['input'];
  /** The account address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** The account city */
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  /** The account country or region long name */
  countryOrRegionLongName: Scalars['String']['input'];
  homeownerMarketingUrl?: InputMaybe<Scalars['String']['input']>;
  marketingWebsiteUrl: Scalars['String']['input'];
  numberOfListings: Scalars['Int']['input'];
  pmsSoftware: Scalars['String']['input'];
  /** The account postal code */
  postalCode: Scalars['String']['input'];
  /** The account state or province long name */
  stateOrProvinceLongName: Scalars['String']['input'];
};

/** The result of the account create mutation for an authenticated user */
export type PmAccountCreateResult =
  | Account
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PmOnboardingCompleteStepInput = {
  sessionId: Scalars['ID']['input'];
  stepKey: PmOnboardingStepKey;
};

/** An onboarding flow definition */
export type PmOnboardingFlow = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Display name for the flow */
  name: Scalars['String']['output'];
  sessionCount: Scalars['Int']['output'];
  steps: Array<PmOnboardingFlowStep>;
  totalSteps: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Version identifier (e.g., 'v1', 'v2') */
  version: Scalars['String']['output'];
};

/** A step definition in an onboarding flow */
export type PmOnboardingFlowStep = {
  /** Display label for the step */
  label: Scalars['String']['output'];
  /** Order position in the flow */
  position: Scalars['Int']['output'];
  /** Whether this step is required */
  required: Scalars['Boolean']['output'];
  /** Unique identifier for the step */
  stepKey: PmOnboardingStepKey;
};

export enum PmOnboardingReviewReason {
  UnsupportedCountry = 'UNSUPPORTED_COUNTRY',
  UnsupportedPms = 'UNSUPPORTED_PMS',
}

/** An onboarding session */
export type PmOnboardingSession = {
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['ID']['output']>;
  canAdvance: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedStepKeys: Array<PmOnboardingStepKey>;
  currentStepIndex: Scalars['Int']['output'];
  currentStepKey: PmOnboardingStepKey;
  flow: PmOnboardingFlow;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  pmsType?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewReason?: Maybe<PmOnboardingReviewReason>;
  startedAt: Scalars['DateTime']['output'];
  status: PmOnboardingSessionStatus;
  stepCompletions: Array<PmOnboardingStepCompletion>;
  totalSteps: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PmOnboardingSessionMutationResult =
  | NotFoundError
  | PmOnboardingSession
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PmOnboardingSessionResult =
  | NotFoundError
  | PmOnboardingSession
  | UnauthenticatedError;

export enum PmOnboardingSessionStatus {
  Completed = 'COMPLETED',
  Ineligible = 'INELIGIBLE',
  InProgress = 'IN_PROGRESS',
}

/** A step completion record */
export type PmOnboardingStepCompletion = {
  completedAt: Scalars['DateTime']['output'];
  stepKey: PmOnboardingStepKey;
};

/** Valid step keys for PM onboarding flows */
export enum PmOnboardingStepKey {
  /** Code of conduct acceptance */
  CodeOfConduct = 'CODE_OF_CONDUCT',
  /** Import listings step */
  Import = 'IMPORT',
  /** Initial signup step */
  Join = 'JOIN',
  /** Final review step */
  Review = 'REVIEW',
  /** Subscription/payment step */
  Subscribe = 'SUBSCRIBE',
}

export type PmsConnection = {
  failed: Scalars['Boolean']['output'];
  failingSince?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  maskedCredentials?: Maybe<Scalars['String']['output']>;
  supportsBookings: Scalars['Boolean']['output'];
  supportsQuotes: Scalars['Boolean']['output'];
  type: PmsName;
  userConfig: Array<ConfigItem>;
};

export type PmsConnectionCreateResult =
  | PmsConnection
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PmsConnectionForCurrentUserResponse =
  | NotFoundError
  | PmsConnection
  | UnauthenticatedError;

/** PMS Integration object */
export type PmsIntegration = {
  authType: Scalars['String']['output'];
  availabilitySync?: Maybe<Scalars['String']['output']>;
  contentSync?: Maybe<Scalars['String']['output']>;
  docsUrl: Scalars['String']['output'];
  fields: Array<PmsIntegrationField>;
  jiraTicketUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ratesSync?: Maybe<Scalars['String']['output']>;
  status: PmsIntegrationStatus;
  /** @deprecated This will be deprecated soon use 'fields' instead */
  supportedFields: Array<PmsIntegrationField>;
  supportsBookings?: Maybe<Scalars['Boolean']['output']>;
  supportsPricing?: Maybe<Scalars['Boolean']['output']>;
  supportsQuotes?: Maybe<Scalars['Boolean']['output']>;
  supportsReviews?: Maybe<Scalars['Boolean']['output']>;
};

export type PmsIntegrationField = {
  description?: Maybe<Scalars['String']['output']>;
  fieldName: FieldNames;
  supported: PmsIntegrationFieldSupported;
};

export enum PmsIntegrationFieldSupported {
  No = 'NO',
  Partially = 'PARTIALLY',
  Yes = 'YES',
}

export enum PmsIntegrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS',
  ReadyForDev = 'READY_FOR_DEV',
  WaitingOnPartnership = 'WAITING_ON_PARTNERSHIP',
  WaitingOnTestAccount = 'WAITING_ON_TEST_ACCOUNT',
}

export enum PmsName {
  Barefoot = 'BAREFOOT',
  Bnbfinder = 'BNBFINDER',
  Bookster = 'BOOKSTER',
  Boost = 'BOOST',
  Ciirus = 'CIIRUS',
  Demo = 'DEMO',
  Escapia = 'ESCAPIA',
  Guesty = 'GUESTY',
  GuestyDh = 'GUESTY_DH',
  Hospitable = 'HOSPITABLE',
  Hostaway = 'HOSTAWAY',
  Hostfully = 'HOSTFULLY',
  LiveList = 'LIVE_LIST',
  Lodgify = 'LODGIFY',
  Lodgix = 'LODGIX',
  NextPax = 'NEXT_PAX',
  OwnerRez = 'OWNER_REZ',
  RedAwning = 'RED_AWNING',
  RentalsUnited = 'RENTALS_UNITED',
  Streamline = 'STREAMLINE',
  StreamlinePartner = 'STREAMLINE_PARTNER',
  Track = 'TRACK',
  VacayHome = 'VACAY_HOME',
}

/** Point with the given lat and lng coordinate values */
export type Point = {
  /** The lat value for the point */
  lat: Scalars['Float']['output'];
  /** The lng value for the point */
  lng: Scalars['Float']['output'];
};

/** Policy object */
export type Policy = {
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** The policy type */
  type: PolicyType;
};

/** The types for policy records */
export enum PolicyType {
  AccountCancellationPolicy = 'ACCOUNT_CANCELLATION_POLICY',
  AccountTermsAndConditions = 'ACCOUNT_TERMS_AND_CONDITIONS',
  ListingCancellationPolicy = 'LISTING_CANCELLATION_POLICY',
  ListingTermsAndConditions = 'LISTING_TERMS_AND_CONDITIONS',
}

export type PolicyUnion =
  | AccountCancellationPolicy
  | AccountTermsAndConditions
  | ListingCancellationPolicy
  | ListingTermsAndConditions;

export type PolicyUpsertAccountCancellationPolicyInput = {
  /** The description for the account's cancellation policy */
  description: Scalars['String']['input'];
};

export type PolicyUpsertAccountCancellationPolicyResult =
  | AccountCancellationPolicy
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PolicyUpsertAccountTermsAndConditionsInput = {
  /** The link for the account's terms and conditions policy */
  termsLink?: InputMaybe<Scalars['String']['input']>;
  /** The upload URL for the account's terms and conditions policy */
  termsUploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyUpsertAccountTermsAndConditionsResult =
  | AccountTermsAndConditions
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PolicyUpsertListingCancellationPolicyInput = {
  /** The description for the listing's cancellation policy */
  description: Scalars['String']['input'];
  /** The ID of the listing to add the cancellation policy to */
  listingId: Scalars['ID']['input'];
};

export type PolicyUpsertListingCancellationPolicyResult =
  | ListingCancellationPolicy
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PolicyUpsertListingTermsAndConditionsInput = {
  /** The ID of the listing to add the terms and conditions policy to */
  listingId: Scalars['ID']['input'];
  /** The link for the listing's terms and conditions policy */
  termsLink?: InputMaybe<Scalars['String']['input']>;
  /** The upload URL for the listing's terms and conditions policy */
  termsUploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyUpsertListingTermsAndConditionsResult =
  | ListingTermsAndConditions
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

export type PriceByOtaUrl = {
  savvyStayUrl?: Maybe<Scalars['String']['output']>;
  totalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

/** Response for getting the quote on a listing given an external OTA URL */
export type PriceByOtaUrlResponse =
  | InternalBookingQuoteUnavailable
  | NotFoundError
  | PriceByOtaUrl;

/** Listing Price display object */
export type PriceDisplay = {
  /**
   * The base price before fees
   * @deprecated deprecated in favor of base_amount_cents, this will be removed soon
   */
  amountCents: Scalars['Int']['output'];
  /** The base price before fees */
  baseAmountCents: Scalars['Int']['output'];
  /** The check in date */
  checkInDate: Scalars['Date']['output'];
  /** The check out date */
  checkOutDate: Scalars['Date']['output'];
  /** The number of nights */
  nights: Scalars['Int']['output'];
  /** The subtotal after fees, without taxes */
  subtotalWithoutTaxesCents?: Maybe<Scalars['Int']['output']>;
};

export enum PriceType {
  /** The price includes taxes and all fees (total cost) */
  TotalCost = 'TOTAL_COST',
  /** The price includes fees but excludes taxes */
  TotalWithoutTax = 'TOTAL_WITHOUT_TAX',
}

export enum PropertyType {
  Apartment = 'APARTMENT',
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  BoutiqueHotel = 'BOUTIQUE_HOTEL',
  GuestHouse = 'GUEST_HOUSE',
  House = 'HOUSE',
}

export enum QuoteItemizedType {
  /** The base cost for the quote */
  Base = 'BASE',
  /** The discount for the quote */
  Discount = 'DISCOUNT',
  /** The fee for the quote */
  Fee = 'FEE',
  /** The other quote item for the quote */
  Other = 'OTHER',
  /** The recoverable for the quote */
  Recoverable = 'RECOVERABLE',
  /** The tax for the quote */
  Tax = 'TAX',
}

export type QuoteItems = {
  /** The total cost of the item in cents */
  costCents: Scalars['Int']['output'];
  /** The description of the item */
  description: Scalars['String']['output'];
  /** The type of the item */
  type: QuoteItemizedType;
};

/** Raw address component from the Google place API */
export type RawAddressComponent = {
  /** The raw address component long name */
  longName: Scalars['String']['output'];
  /** The raw address component short name */
  shortName: Scalars['String']['output'];
  /** The raw address component Google place geocoding types */
  types: Array<Scalars['String']['output']>;
};

export type RedAwningPmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
};

/** The available referral campaign types */
export enum ReferralCampaignType {
  /** Referral program that rewards the referred user and $50 gift card. */
  Friendly_50IncentiveProgram = 'FRIENDLY_50_INCENTIVE_PROGRAM',
  /** Partner referral program that rewards referred investors with a $100 gift card on signup. */
  InvestorReward_100 = 'INVESTOR_REWARD_100',
  /** NerdWallet newsletter sponsorship program that rewards the referred user a $50 gift card. */
  Nerdwallet_50IncentiveProgram = 'NERDWALLET_50_INCENTIVE_PROGRAM',
  /** Referral program that rewards both the referred user and referring user a $50 gift card. The referring user receives rewards for up to 5 referrals. */
  ReferredUserBonus = 'REFERRED_USER_BONUS',
  /** Standard referral program that rewards the referred user a $50 gift card. */
  SavvyIncentiveProgram = 'SAVVY_INCENTIVE_PROGRAM',
  /** WSU referral program that rewards the referred user and $50 gift card. */
  Wsu_50IncentiveProgram = 'WSU_50_INCENTIVE_PROGRAM',
}

/** Details about a referral code for new users */
export type ReferralCodeDetails = {
  /** The description of the campaign */
  campaignDescription: Scalars['String']['output'];
  /** The display name of the campaign */
  campaignName: Scalars['String']['output'];
  /** The type of referral campaign */
  campaignType: ReferralCampaignType;
  /** The referral code */
  code: Scalars['String']['output'];
  /** The reward amount in cents that the new user will receive */
  referredUserRewardAmountCents: Scalars['Int']['output'];
};

/** Response for looking up a referral code */
export type ReferralCodeFindByCodeResponse =
  | NotFoundError
  | ReferralCodeDetails;

/** A reward issued from a referral */
export type ReferralReward = {
  /** The reward amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The gift card associated with this reward */
  giftCard?: Maybe<GiftCard>;
  /** The reward ID */
  id: Scalars['ID']['output'];
  /** When the reward was created */
  insertedAt: Scalars['DateTime']['output'];
  /** The user who received this reward */
  recipient: RewardRecipient;
  /** The reward status (pending or claimed) */
  status: Scalars['String']['output'];
};

/** Region object */
export type Region = {
  /** The region city's slug */
  citySlug?: Maybe<Scalars['String']['output']>;
  /** The region country's slug */
  countrySlug?: Maybe<Scalars['String']['output']>;
  /** The region long name */
  description: Scalars['String']['output'];
  /** The featured flag */
  featured: Scalars['Boolean']['output'];
  /** The region ID */
  id: Scalars['ID']['output'];
  /** The endpoint of the image host */
  imageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The image path, relative to the endpoint */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  imageProcessing: Scalars['Boolean']['output'];
  /** The region image */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** The region level_one's slug */
  levelOneSlug?: Maybe<Scalars['String']['output']>;
  /** The region long name */
  name: Scalars['String']['output'];
  /** The hierarchical URL path for the region */
  path?: Maybe<Scalars['String']['output']>;
  /** The region Google place ID */
  placeId: Scalars['String']['output'];
  /** The region search page content array */
  searchPageContents: Array<SearchPageContent>;
  /** The region slug */
  slug: Scalars['String']['output'];
};

/** Region collection object contains a paginated collection of regions and meta data about the collection */
export type RegionCollection = {
  /** The collection of regions for a given page */
  entries: Array<Region>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type RentalsUnitedPmsConnectionCreateInput = {
  username: Scalars['String']['input'];
};

/** Reservation object */
export type Reservation = {
  /** The cancellation policy for the reservation */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** The end date for the reservation */
  endDate: Scalars['Date']['output'];
  /** The Reservation ID for the external system */
  externalReservationId?: Maybe<Scalars['String']['output']>;
  /** The Reservation ID */
  id: Scalars['ID']['output'];
  /** The created at date for the reservation */
  insertedAt: Scalars['String']['output'];
  /** The listing that the reservation belongs to */
  listing: Listing;
  /** The note for the reservation */
  note?: Maybe<Scalars['String']['output']>;
  numberOfAdults?: Maybe<Scalars['Int']['output']>;
  numberOfChildren?: Maybe<Scalars['Int']['output']>;
  numberOfInfants?: Maybe<Scalars['Int']['output']>;
  numberOfPets?: Maybe<Scalars['Int']['output']>;
  /** The order that the reservation belongs to */
  order: Order;
  /**
   * The payment schedule for the quote
   * @deprecated This will be deprecated soon use 'order.quote.payment_schedule' instead
   */
  paymentSchedule: Array<PaymentItem>;
  /** The start date for the reservation */
  startDate: Scalars['Date']['output'];
  /** The status for the reservation */
  status: ReservationStatuses;
  /** Flag indicating if the reservation supports cancellations or not */
  supportsCancellations: Scalars['Boolean']['output'];
  /** The total price for the reservation */
  totalCostCents?: Maybe<Scalars['Int']['output']>;
  /** The guest's first name */
  travelerFirstName?: Maybe<Scalars['String']['output']>;
  /** The guest's last name */
  travelerLastName?: Maybe<Scalars['String']['output']>;
  /** The updated at date for the reservation */
  updatedAt: Scalars['String']['output'];
};

/** Response for getting a reservation by an reservation ID when authenticated as a user */
export type ReservationByIdResponse = NotFoundError | Reservation;

/** Reservations collection object contains a paginated collection of reservations and meta data about the collection */
export type ReservationCollection = {
  /** The collection of reservations for a given page */
  entries: Array<Reservation>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** The commission a property manager owes for a confirmed booking */
export type ReservationCommission = {
  /** Why this row deviates from normal billing, when it does */
  adjustmentReason?: Maybe<ReservationCommissionAdjustmentReasons>;
  /** The commission owed in cents; negative on an adjustment */
  commissionCents: Scalars['Int']['output'];
  /** The commission rate as a percent (e.g. 5.00 for 5%), snapshotted when the commission accrued */
  commissionRate: Scalars['Decimal']['output'];
  /** The portion of the booking the commission was charged on, in cents */
  commissionableCents: Scalars['Int']['output'];
  /** When the booking was confirmed. Null on an adjustment, which is not anchored to a booking month */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The time the commission was created */
  createdAt: Scalars['DateTime']['output'];
  /** The commission ID */
  id: Scalars['ID']['output'];
  /** The commission kind */
  kind: ReservationCommissionKind;
  /** When the commission was paid */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** The booking this commission was accrued for */
  reservation: Reservation;
  /** The commission status */
  status: ReservationCommissionStatuses;
};

export type ReservationCommissionActivityExport = {
  /** The UTF-8 RFC 4180 CSV content for the matching commission activity */
  content: Scalars['String']['output'];
  /** The suggested filename for the generated commission activity CSV */
  filename: Scalars['String']['output'];
};

export type ReservationCommissionActivityExportForAccountResponse =
  | ReservationCommissionActivityExport
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Why a commission row deviates from normal billing */
export enum ReservationCommissionAdjustmentReasons {
  FailedPayment = 'FAILED_PAYMENT',
  Fraud = 'FRAUD',
  GuestCancellation = 'GUEST_CANCELLATION',
  Refund = 'REFUND',
}

export type ReservationCommissionCollection = {
  /** The collection of commissions for a given page */
  entries: Array<ReservationCommission>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
  /** The summed commission in cents for every row matching the filters, across all pages */
  totalCommissionCents: Scalars['Int']['output'];
};

/** Whether the row is an original commission or a later correction */
export enum ReservationCommissionKind {
  /** A post-invoice correction reversing an already-billed commission */
  Adjustment = 'ADJUSTMENT',
  /** The commission accrued for a confirmed booking */
  Commission = 'COMMISSION',
}

export type ReservationCommissionListAllForAccountResponse =
  | ReservationCommissionCollection
  | UnauthenticatedError
  | ValidationErrorCollection;

export type ReservationCommissionStatement = {
  /** Stripe's current direct-download URL for the statement PDF */
  url: Scalars['String']['output'];
};

export type ReservationCommissionStatementForAccountResponse =
  | NotFoundError
  | ReservationCommissionStatement
  | ServiceUnavailableError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** The statuses for reservation commission records */
export enum ReservationCommissionStatuses {
  /** An adjustment issued to Stripe as a credit note */
  Credited = 'CREDITED',
  /** Frozen onto an issued invoice, awaiting payment */
  Invoiced = 'INVOICED',
  /** The invoice carrying this commission has been paid */
  Paid = 'PAID',
  /** Accrued, not yet attached to an invoice */
  Pending = 'PENDING',
  /** Removed from billing, e.g. a cancelled booking */
  Void = 'VOID',
}

export type ReservationCommissionSummary = {
  /** Signed adjustments recognized during the period, including Stripe-originated credits */
  adjustmentCents: Scalars['Int']['output'];
  /** The selected billing month in YYYY-MM format */
  billingMonth: Scalars['String']['output'];
  /** The number of non-voided commissionable bookings in the period */
  bookingCount: Scalars['Int']['output'];
  /** The booking value on which commissions were calculated */
  commissionableBookingValueCents: Scalars['Int']['output'];
  /** The estimated invoice total for non-voided bookings before credits */
  grossCommissionCents: Scalars['Int']['output'];
  /** The last day covered by the period */
  periodEnd: Scalars['Date']['output'];
  /** The first day covered by the period */
  periodStart: Scalars['Date']['output'];
  /** Whether Stripe has a finalized statement for the selected billing period */
  statementAvailable: Scalars['Boolean']['output'];
};

export type ReservationCommissionSummaryForAccountResponse =
  | ReservationCommissionSummary
  | UnauthenticatedError
  | ValidationErrorCollection;

export type ReservationCreationUnknown = {
  message: Scalars['String']['output'];
  orderId: Scalars['ID']['output'];
  reservationId: Scalars['ID']['output'];
};

/** Response for looking up an accepted reservation by order ID when authenticated as a user */
export type ReservationForOrderResponse = NotFoundError | Reservation;

/** The statuses for reservation records */
export enum ReservationStatuses {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Processing = 'PROCESSING',
}

export type ReservationUnavailable = {
  message: Scalars['String']['output'];
};

/** Response for getting the reservations by the current authenticated user */
export type ReservationsListAllForUserResponse =
  | ReservationCollection
  | UnauthenticatedError;

export type ResetPasswordForTokenInput = {
  /** The user's new password */
  password: Scalars['String']['input'];
  /** The user's account email */
  token: Scalars['String']['input'];
};

/** The result of the user password reset for token mutation */
export type ResetPasswordForTokenResponse =
  | NotFoundError
  | PasswordResetMessage
  | ValidationErrorCollection;

export type ResetPasswordInput = {
  /** The user's new password */
  password: Scalars['String']['input'];
};

/** The result of the user password reset mutation */
export type ResetPasswordResponse =
  | PasswordResetMessage
  | UnauthenticatedError
  | ValidationErrorCollection;

/** Rewards collection object contains a paginated collection of rewards and meta data about the collection */
export type RewardCollection = {
  /** The collection of rewards for a given page */
  entries: Array<ReferralReward>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

/** A reward recipient with basic information */
export type RewardRecipient = {
  /** The recipient's email */
  email: Scalars['String']['output'];
  /** The recipient's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The recipient's user ID */
  id: Scalars['ID']['output'];
};

/** Response for getting the rewards for the current authenticated user */
export type RewardsForCurrentUserResponse =
  | RewardCollection
  | UnauthenticatedError;

/** Room object embedded in a listing */
export type Room = {
  /** The beds in the room */
  beds: Array<Bed>;
  /** The index of the room (1-based) */
  index: Scalars['Int']['output'];
  /** The name of the room */
  name: Scalars['String']['output'];
};

export type RootMutationType = {
  /** Record the current user's acceptance of the updated Terms of Use for their account */
  accountAcceptTermsOfUse: AccountUpdateResult;
  /** Accept the current Terms of Use for the link's account and record who accepted */
  accountActionLinkAcceptTermsOfUse: AccountActionLinkAcceptTermsOfUseResult;
  /** Start a Stripe card setup session for the link's account */
  accountActionLinkCreateCardSetupSession: AccountActionLinkCreateCardSetupSessionResult;
  /**
   * Email a new link to the contact an expired link was sent to. Repeat requests
   * within a few minutes report success without sending another email.
   */
  accountActionLinkRequestNewLink: AccountActionLinkRequestNewLinkResult;
  /** Bulk update location_obfuscated for all listings on the current user's account */
  accountBulkUpdateLocationObfuscated: AccountBulkUpdateLocationObfuscatedResult;
  /** Create a review summary when authenticated innkeeper */
  accountReviewSummaryCreate: AccountReviewSummaryCreateResult;
  /** Update the default listing level for the current authenticated user's account */
  accountSetDefaultListingLevel: AccountUpdateResult;
  /** Update the account for the current authenticated user */
  accountUpdate: AccountUpdateResult;
  /** Update all listing subscriptions for account */
  accountUpdateAllListingSubscriptions: AccountUpdateAllListingSubscriptionsResult;
  /** Delete an affiliation for a listing */
  affiliationDelete: AffiliationDeleteResult;
  /** Find or create an affiliation for an innkeeper */
  affiliationFindOrCreate: AffiliationFindOrCreateResult;
  barefootPmsConnectionCreate: PmsConnectionCreateResult;
  booksterPmsConnectionCreate: PmsConnectionCreateResult;
  boostPmsConnectionCreate: PmsConnectionCreateResult;
  /** Cancel a reservation */
  cancelReservation: CancelReservationResult;
  ciirusPmsConnectionCreate: PmsConnectionCreateResult;
  /** Start autopay enrollment — returns a Stripe-hosted card setup session URL */
  createCardSetupSession: CreateCardSetupSessionResult;
  createLead: CreateLeadResult;
  /** Create a reservation */
  createReservation: CreateReservationResult;
  /** Create a subscription */
  createSubscription: CreateSubscriptionResult;
  demoPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create an email verification for an authenticated innkeeper */
  emailVerificationCreate: EmailVerificationCreateResult;
  /** Verify email when authenticated as innkeeper */
  emailVerificationUpdate: EmailVerificationUpdateResult;
  escapiaPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create a reservation using a promo code */
  freePromoCreateReservation: FreePromoCreateReservationResult;
  /** Gallery Asset Create mutation */
  galleryAssetCreate: GalleryAssetCreateResponse;
  /** Gallery Asset Delete mutation */
  galleryAssetDelete: GalleryAssetDeleteResponse;
  /** Gallery Asset Order mutation */
  galleryAssetOrder: GalleryAssetOrderResponse;
  /** Gallery Asset Update mutation */
  galleryAssetUpdate: GalleryAssetUpdateResponse;
  /** Gallery Asset Update image mutation */
  galleryAssetUpdateImage: GalleryAssetUpdateImageResponse;
  /** Create a gift card */
  giftCardCreate: CreateGiftCardResponse;
  /** Redeem a balance from a gift card */
  giftCardRedeem: GiftCardRedeemResponse;
  /** Update an unpurchased gift card */
  giftCardUpdateUnpurchased: GiftCardUpdateUnpurchasedResponse;
  guestyDhPmsConnectionCreate: PmsConnectionCreateResult;
  guestyPmsConnectionCreate: PmsConnectionCreateResult;
  hospitablePmsConnectionCreate: PmsConnectionCreateResult;
  hostawayPmsConnectionCreate: PmsConnectionCreateResult;
  hostfullyPmsConnectionCreate: PmsConnectionCreateResult;
  /** Create a Persona identity verification inquiry */
  identityVerificationCreate: IdentityVerificationCreateResult;
  travelerIdentityVerificationCreate: TravelerIdentityVerificationCreateResult;
  /** Approve access to the private listing for the given user */
  listingApproveAccessForUser: ListingApproveAccessForUserResult;
  /** Create a listing for the current authenticated user's account */
  listingCreate: ListingCreateResult;
  /** Delete a listing */
  listingDelete: ListingDeleteResult;
  /** Deny access to the private listing for the given user */
  listingDenyAccessForUser: ListingDenyAccessForUserResult;
  /** Favorite the listing for the current authenticated user */
  listingFavoriteCreate: ListingFavoriteCreateResult;
  /** Unfavorite the listing for the current authenticated user */
  listingFavoriteDelete: ListingFavoriteDeleteResult;
  /** Publish the listing for the current authenticated user */
  listingPublish: ListingPublishResult;
  /** Request access to the private listing for the given user */
  listingRequestAccessForUser: ListingRequestAccessForUserResult;
  /** Toggle listing featured flag */
  listingToggleFeaturedByOwner: ListingUpdateResult;
  /** Unpublish the listing for the current authenticated user */
  listingUnpublish: ListingUnpublishResult;
  /** Update the listing for the current authenticated user */
  listingUpdate: ListingUpdateResult;
  liveListPmsConnectionCreate: PmsConnectionCreateResult;
  lodgifyPmsConnectionCreate: PmsConnectionCreateResult;
  lodgixPmsConnectionCreate: PmsConnectionCreateResult;
  nextPaxPmsConnectionCreate: PmsConnectionCreateResult;
  /** Load an order when authenticated as a user */
  orderLoad: OrderLoadResponse;
  ownerRezPmsConnectionCreate: PmsConnectionCreateResult;
  /** Submit an OTP code to complete phone verification. */
  phoneVerificationCheck: PhoneVerificationCheckResult;
  /** Send an SMS OTP to the given phone number after Lookup classification. */
  phoneVerificationStart: PhoneVerificationStartResult;
  /** Create the PM account for the current authenticated user */
  pmAccountCreate: PmAccountCreateResult;
  /** Complete a step in the onboarding flow */
  pmOnboardingCompleteStep: PmOnboardingSessionMutationResult;
  /** Navigate to a specific step (for going back) */
  pmOnboardingNavigateToStep: PmOnboardingSessionMutationResult;
  /** Add a cancellation policy to an account */
  policyUpsertAccountCancellationPolicy: PolicyUpsertAccountCancellationPolicyResult;
  /** Add a terms and conditions policy to an account */
  policyUpsertAccountTermsAndConditions: PolicyUpsertAccountTermsAndConditionsResult;
  /** Add a cancellation policy to an listing */
  policyUpsertListingCancellationPolicy: PolicyUpsertListingCancellationPolicyResult;
  /** Add a terms and conditions policy to a listing */
  policyUpsertListingTermsAndConditions: PolicyUpsertListingTermsAndConditionsResult;
  redAwningPmsConnectionCreate: PmsConnectionCreateResult;
  rentalsUnitedPmsConnectionCreate: PmsConnectionCreateResult;
  /** Reset user password mutation */
  resetPassword: ResetPasswordResponse;
  /** Reset user password for token mutation */
  resetPasswordForToken: ResetPasswordForTokenResponse;
  /** Send password reset email mutation */
  sendPasswordResetEmail: SendPasswordResetEmailResponse;
  /** Set a card for an user's account */
  setAccountCard: SetAccountCardResult;
  /** Set a subscription for an innkeeper */
  setSubscription: SetSubscriptionResult;
  /** Set a coupon for a host subscription */
  setSubscriptionCoupon: SetSubscriptionCouponResult;
  streamlinePartnerPmsConnectionCreate: PmsConnectionCreateResult;
  streamlinePmsConnectionCreate: PmsConnectionCreateResult;
  /** Subscribe an email to the iOS app waitlist */
  subscribeEmailToIosWaitlist: SubscribeEmailToIosWaitlistResult;
  /** Subscribe an email to the newsletter */
  subscribeEmailToNewsletter: SubscribeEmailToNewsletterResult;
  trackPmsConnectionCreate: PmsConnectionCreateResult;
  travelerSurveyResponseCreate: TravelerSurveyResponseCreateResult;
  /** User account add mutation */
  userAccountAdd: UserAccountAddResponse;
  /** User account remove mutation */
  userAccountRemove: UserAccountRemoveResponse;
  /** Add a referral code to the current user */
  userAddReferralCode: UserAddReferralCodeResponse;
  /** Create a user and PM account in a single request */
  userAndPmAccountCreate: UserAndPmAccountCreateResponse;
  /** User Apple social session mutation */
  userAppleSocialSession: UserSessionResponse;
  /** User create mutation */
  userCreate: UserCreateResponse;
  /** User Facebook social session mutation */
  userFacebookSocialSession: UserFacebookSocialSessionResponse;
  /** User Google social session mutation */
  userGoogleSocialSession: UserSessionResponse;
  /** User account mark for deletion mutation */
  userMarkForDeletion: UserMarkForDeletionResponse;
  /** Create a user referral campaign. Users can only have one campaign per campaign type. */
  userReferralCampaignCreate: CreateUserReferralCampaignResponse;
  /** User session mutation */
  userSession: UserSessionResponse;
  /** User session refresh mutation */
  userSessionRefresh: UserSessionRefreshResponse;
  /** Upadate a current user */
  userUpdate: UserUpdateResult;
  vacayHomePmsConnectionCreate: PmsConnectionCreateResult;
};

export type RootMutationTypeAccountActionLinkAcceptTermsOfUseArgs = {
  isAuthorized: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  termsOfUseVersion: Scalars['String']['input'];
  title: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootMutationTypeAccountActionLinkCreateCardSetupSessionArgs = {
  token: Scalars['String']['input'];
};

export type RootMutationTypeAccountActionLinkRequestNewLinkArgs = {
  token: Scalars['String']['input'];
};

export type RootMutationTypeAccountBulkUpdateLocationObfuscatedArgs = {
  input: AccountBulkUpdateLocationObfuscatedInput;
};

export type RootMutationTypeAccountReviewSummaryCreateArgs = {
  input: AccountReviewSummaryCreateInput;
};

export type RootMutationTypeAccountSetDefaultListingLevelArgs = {
  defaultListingLevel: SubscriptionType;
};

export type RootMutationTypeAccountUpdateArgs = {
  input: AccountUpdateInput;
};

export type RootMutationTypeAccountUpdateAllListingSubscriptionsArgs = {
  input: AccountUpdateAllListingSubscriptionsInput;
};

export type RootMutationTypeAffiliationDeleteArgs = {
  input: AffiliationDeleteInput;
};

export type RootMutationTypeAffiliationFindOrCreateArgs = {
  input: AffiliationFindOrCreateInput;
};

export type RootMutationTypeBarefootPmsConnectionCreateArgs = {
  input: BarefootPmsConnectionCreateInput;
};

export type RootMutationTypeBooksterPmsConnectionCreateArgs = {
  input: BooksterPmsConnectionCreateInput;
};

export type RootMutationTypeBoostPmsConnectionCreateArgs = {
  input: BoostPmsConnectionCreateInput;
};

export type RootMutationTypeCancelReservationArgs = {
  input: CancelReservationInput;
};

export type RootMutationTypeCiirusPmsConnectionCreateArgs = {
  input: CiirusPmsConnectionCreateInput;
};

export type RootMutationTypeCreateLeadArgs = {
  input: CreateLeadInput;
};

export type RootMutationTypeCreateReservationArgs = {
  input: CreateReservationInput;
};

export type RootMutationTypeCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};

export type RootMutationTypeDemoPmsConnectionCreateArgs = {
  input: DemoPmsConnectionCreateInput;
};

export type RootMutationTypeEmailVerificationUpdateArgs = {
  token: Scalars['String']['input'];
};

export type RootMutationTypeEscapiaPmsConnectionCreateArgs = {
  input: EscapiaPmsConnectionCreateInput;
};

export type RootMutationTypeFreePromoCreateReservationArgs = {
  input: FreePromoCreateReservationInput;
};

export type RootMutationTypeGalleryAssetCreateArgs = {
  input: GalleryAssetCreateInput;
};

export type RootMutationTypeGalleryAssetDeleteArgs = {
  input: GalleryAssetDeleteInput;
};

export type RootMutationTypeGalleryAssetOrderArgs = {
  input: GalleryAssetOrderInput;
};

export type RootMutationTypeGalleryAssetUpdateArgs = {
  input: GalleryAssetUpdateInput;
};

export type RootMutationTypeGalleryAssetUpdateImageArgs = {
  input: GalleryAssetUpdateImageInput;
};

export type RootMutationTypeGiftCardCreateArgs = {
  input: GiftCardCreateInput;
};

export type RootMutationTypeGiftCardRedeemArgs = {
  certificateNumber: Scalars['String']['input'];
  input: GiftCardRedeemInput;
};

export type RootMutationTypeGiftCardUpdateUnpurchasedArgs = {
  input: GiftCardUpdateUnpurchasedInput;
};

export type RootMutationTypeGuestyDhPmsConnectionCreateArgs = {
  input: GuestyDhPmsConnectionCreateInput;
};

export type RootMutationTypeGuestyPmsConnectionCreateArgs = {
  input: GuestyPmsConnectionCreateInput;
};

export type RootMutationTypeHospitablePmsConnectionCreateArgs = {
  input: HospitablePmsConnectionCreateInput;
};

export type RootMutationTypeHostawayPmsConnectionCreateArgs = {
  input: HostawayPmsConnectionCreateInput;
};

export type RootMutationTypeHostfullyPmsConnectionCreateArgs = {
  input: HostfullyPmsConnectionCreateInput;
};

export type RootMutationTypeListingApproveAccessForUserArgs = {
  input: ListingApproveAccessForUserInput;
};

export type RootMutationTypeListingCreateArgs = {
  input: ListingCreateInput;
};

export type RootMutationTypeListingDeleteArgs = {
  input: ListingDeleteInput;
};

export type RootMutationTypeListingDenyAccessForUserArgs = {
  input: ListingDenyAccessForUserInput;
};

export type RootMutationTypeListingFavoriteCreateArgs = {
  input: ListingFavoriteCreateInput;
};

export type RootMutationTypeListingFavoriteDeleteArgs = {
  input: ListingFavoriteDeleteInput;
};

export type RootMutationTypeListingPublishArgs = {
  input: ListingPublishInput;
};

export type RootMutationTypeListingRequestAccessForUserArgs = {
  input: ListingRequestAccessForUserInput;
};

export type RootMutationTypeListingToggleFeaturedByOwnerArgs = {
  listingId: Scalars['ID']['input'];
};

export type RootMutationTypeListingUnpublishArgs = {
  listingId: Scalars['ID']['input'];
};

export type RootMutationTypeListingUpdateArgs = {
  input: ListingUpdateInput;
};

export type RootMutationTypeLiveListPmsConnectionCreateArgs = {
  input: LiveListPmsConnectionCreateInput;
};

export type RootMutationTypeLodgifyPmsConnectionCreateArgs = {
  input: LodgifyPmsConnectionCreateInput;
};

export type RootMutationTypeLodgixPmsConnectionCreateArgs = {
  input: LodgixPmsConnectionCreateInput;
};

export type RootMutationTypeNextPaxPmsConnectionCreateArgs = {
  input: NextPaxPmsConnectionCreateInput;
};

export type RootMutationTypeOrderLoadArgs = {
  input: OrderLoadInput;
};

export type RootMutationTypeOwnerRezPmsConnectionCreateArgs = {
  input: OwnerRezPmsConnectionCreateInput;
};

export type RootMutationTypePhoneVerificationCheckArgs = {
  input: PhoneVerificationCheckInput;
};

export type RootMutationTypePhoneVerificationStartArgs = {
  input: PhoneVerificationStartInput;
};

export type RootMutationTypePmAccountCreateArgs = {
  input: PmAccountCreateInput;
};

export type RootMutationTypePmOnboardingCompleteStepArgs = {
  input: PmOnboardingCompleteStepInput;
};

export type RootMutationTypePmOnboardingNavigateToStepArgs = {
  sessionId: Scalars['ID']['input'];
  stepKey: PmOnboardingStepKey;
};

export type RootMutationTypePolicyUpsertAccountCancellationPolicyArgs = {
  input: PolicyUpsertAccountCancellationPolicyInput;
};

export type RootMutationTypePolicyUpsertAccountTermsAndConditionsArgs = {
  input: PolicyUpsertAccountTermsAndConditionsInput;
};

export type RootMutationTypePolicyUpsertListingCancellationPolicyArgs = {
  input: PolicyUpsertListingCancellationPolicyInput;
};

export type RootMutationTypePolicyUpsertListingTermsAndConditionsArgs = {
  input: PolicyUpsertListingTermsAndConditionsInput;
};

export type RootMutationTypeRedAwningPmsConnectionCreateArgs = {
  input: RedAwningPmsConnectionCreateInput;
};

export type RootMutationTypeRentalsUnitedPmsConnectionCreateArgs = {
  input: RentalsUnitedPmsConnectionCreateInput;
};

export type RootMutationTypeResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type RootMutationTypeResetPasswordForTokenArgs = {
  input: ResetPasswordForTokenInput;
};

export type RootMutationTypeSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};

export type RootMutationTypeSetAccountCardArgs = {
  stripeTokenId: Scalars['String']['input'];
};

export type RootMutationTypeSetSubscriptionArgs = {
  input: SetSubscriptionInput;
};

export type RootMutationTypeSetSubscriptionCouponArgs = {
  input: SetSubscriptionCouponInput;
};

export type RootMutationTypeStreamlinePartnerPmsConnectionCreateArgs = {
  input: StreamlinePartnerPmsConnectionCreateInput;
};

export type RootMutationTypeStreamlinePmsConnectionCreateArgs = {
  input: StreamlinePmsConnectionCreateInput;
};

export type RootMutationTypeSubscribeEmailToIosWaitlistArgs = {
  email: Scalars['String']['input'];
};

export type RootMutationTypeSubscribeEmailToNewsletterArgs = {
  email: Scalars['String']['input'];
};

export type RootMutationTypeTrackPmsConnectionCreateArgs = {
  input: TrackPmsConnectionCreateInput;
};

export type RootMutationTypeTravelerSurveyResponseCreateArgs = {
  input: TravelerSurveyResponseCreateInput;
};

export type RootMutationTypeUserAccountAddArgs = {
  input: UserAccountAddInput;
};

export type RootMutationTypeUserAccountRemoveArgs = {
  input: UserAccountRemoveInput;
};

export type RootMutationTypeUserAddReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};

export type RootMutationTypeUserAndPmAccountCreateArgs = {
  input: UserAndPmAccountCreateInput;
};

export type RootMutationTypeUserAppleSocialSessionArgs = {
  input: UserAppleSocialSessionInput;
};

export type RootMutationTypeUserCreateArgs = {
  input: UserCreateInput;
};

export type RootMutationTypeUserFacebookSocialSessionArgs = {
  input: UserFacebookSocialSessionInput;
};

export type RootMutationTypeUserGoogleSocialSessionArgs = {
  input: UserGoogleSocialSessionInput;
};

export type RootMutationTypeUserReferralCampaignCreateArgs = {
  input: UserReferralCampaignCreateInput;
};

export type RootMutationTypeUserSessionArgs = {
  input: UserSessionInput;
};

export type RootMutationTypeUserSessionRefreshArgs = {
  input: UserSessionRefreshInput;
};

export type RootMutationTypeUserUpdateArgs = {
  input: UserUpdateInput;
};

export type RootMutationTypeVacayHomePmsConnectionCreateArgs = {
  input: VacayHomePmsConnectionCreateInput;
};

export type RootQueryType = {
  /** Read an account action link from an email. Public: the token is the credential. */
  accountActionLink: AccountActionLinkResult;
  /** Get an account by its id */
  accountById: AccountByIdResponse;
  /** Get an account by its url friendly slug */
  accountBySlug: AccountBySlugResponse;
  /** Get the cards belonging to the current user's account */
  accountCardsListAll: AccountCardsListAllResponse;
  /** Get the account for the current user */
  accountForCurrentUser: AccountForCurrentUserResponse;
  /** Get the listings for the current authenticated user's account */
  accountListings: AccountListingsResponse;
  /** Get the active accounts */
  accountsListAllActive: AccountsResponse;
  /** Get the random accounts */
  accountsListRandom: AccountsResponse;
  /** Get the current authenticated innkeeper */
  affiliationSearch: AffiliationSearchResponse;
  /** List all featured blog post */
  blogPostsListAllFeatured: Array<BlogPost>;
  /** Get the booking quote for a listing within date range */
  bookingQuoteByListingAndDates: BookingQuoteResponse;
  /** Get the cards belonging to the current user */
  cardsListAll: CardsListAllResponse;
  /** Get the comparison quotes for a listing within date range */
  comparisonQuoteByListingAndDates: ComparisonQuoteResponse;
  /** Fetch available coupons for current account */
  couponFindAvailableForAccount: CouponFindForAccountResponse;
  /** Find coupon by code */
  couponFindByPromoCode: CouponFindByPromoCodeResponse;
  /** Get coupon applied to current account */
  couponFindForAccount: CouponFindForAccountResponse;
  /** Get the current authenticated innkeeper */
  currentInnkeeper: CurrentInnkeeperResponse;
  /** Get the current authenticated user */
  currentUser: CurrentUserResponse;
  /** List all features */
  featuresListAll: Array<Feature>;
  /** List all features for search filters */
  featuresListAllForSearchFilters: Array<Feature>;
  /** Get the current authenticated innkeeper's gallery asset */
  galleryAssetById: GalleryAssetByIdResponse;
  /** Get gift card by its cert number */
  giftCardByCertificateNumber: GiftCardByCertificateNumberResponse;
  /** Get gift card by its ID */
  giftCardById: GiftCardByIdResponse;
  giftCardByPaymentServiceTransactionClientSecret: GiftCardByPaymentServiceTransactionClientSecretResponse;
  /** Get gift card image by its ID when authenticated as an admin */
  giftCardImageById: GiftCardImageByIdResponse;
  /** List all gift card images */
  giftCardImageListAllActive: GiftCardImageCollection;
  listSupportedByOtaUrls?: Maybe<ListingCollection>;
  /** Booking Info for listing */
  listingBookingInfo: ListingBookingInfoResponse;
  /** Get a listing by its external id */
  listingByExternalIdAndSource: ListingByExternalIdAndSourceResponse;
  /** Get a listing by its id */
  listingByIdAndUser: ListingByIdAndUserResponse;
  /** Get a listing by its url friendly slug */
  listingBySlug: ListingBySlugResponse;
  listingPrivateAccessForUser: ListingPrivateAccessForUserResponse;
  /** Listing review summaries collection for listing */
  listingReviewSummariesListAllForListing: ListingReviewSummariesListAllForListingResponse;
  /** Reviews for listing */
  listingReviewsListAllForListing: ListingReviewsListAllForListingResponse;
  /** Fetch homepage listing sections with exclusive membership across sections */
  listingsHomePage: HomePageListingSections;
  /** List all active listings */
  listingsListAllActive: ListingCollection;
  /** List all favorited listings */
  listingsListAllFavorited: ListAllFavoritedResponse;
  /** List all featured listings */
  listingsListAllFeatured: ListingCollection;
  /** List all highly rated listings (5.0 rating with at least 20 reviews) */
  listingsListAllHighlyRated: ListingCollection;
  /** List all indexable listings (can be dynamically indexed by Google) */
  listingsListAllIndexable: ListingCollection;
  /** List all trending listings (have the waterfront feature) */
  listingsListAllTrending: ListingCollection;
  /** Search listings */
  listingsSearch: ListingsSearchResponse;
  /** Search for all active listings for the given place */
  listingsSearchAllActiveForPlace: ListingSearchCursorCollection;
  /** Find the current user's active onboarding session */
  myPmOnboardingSession: PmOnboardingSessionResult;
  /** Get place by address */
  placeByAddress: PlaceByAddressResponse;
  /** Get place by its ID */
  placeById: PlaceByIdResponse;
  /** Get the initial geometry to use for a destination search */
  placeSearchGeometry?: Maybe<Geometry>;
  /** List places for a given autocomplete query string */
  placesAutocomplete: Array<PlaceAutocompletePrediction>;
  /** List all plans */
  plansListAll: PlansListAllResponse;
  /** List all PMS connections */
  pmsConnectionForCurrentUser: PmsConnectionForCurrentUserResponse;
  /** List all PMS integrations */
  pmsIntegrationListAll: Array<PmsIntegration>;
  /** Get the external quote for a listing within date range */
  priceByOtaUrlListingAndDates: PriceByOtaUrlResponse;
  /** Validate a referral code and get details about the rewards */
  referralCodeFindByCode: ReferralCodeFindByCodeResponse;
  /** List all regions */
  regionsListAll: RegionCollection;
  /** List all featured regions */
  regionsListAllFeatured: RegionCollection;
  /** List all regions with active search page contents */
  regionsListAllWithActiveSearchPageContents: RegionCollection;
  /** Get reservation by its ID when authenticated as the user */
  reservationById: ReservationByIdResponse;
  /** Export the filtered commission activity for the current property-owner account as CSV */
  reservationCommissionActivityExportForAccount: ReservationCommissionActivityExportForAccountResponse;
  /** List the commissions for the current user's account when authenticated as a property owner */
  reservationCommissionListAllForAccount: ReservationCommissionListAllForAccountResponse;
  /** Get the current Stripe PDF URL for the current account's commission statement */
  reservationCommissionStatementForAccount: ReservationCommissionStatementForAccountResponse;
  /** Summarize one commission billing period for the current property-owner account */
  reservationCommissionSummaryForAccount: ReservationCommissionSummaryForAccountResponse;
  /** Look up an accepted reservation by order ID for the current user */
  reservationForOrder: ReservationForOrderResponse;
  /** List all reservations for the current authenticated user */
  reservationsListAllForUser: ReservationsListAllForUserResponse;
  /** List all rewards for the current authenticated user */
  rewardsForCurrentUser: RewardsForCurrentUserResponse;
  /** An active search page content for the given place */
  searchPageContentForUrlPathAndType: SearchPageContentActiveForPlaceResponse;
  /** List all search page contents */
  searchPageContentListAll: SearchPageContentCollection;
  testConsent: Scalars['Int']['output'];
  /** Test an unhandled error */
  testUnhandledError: Scalars['Int']['output'];
  /** List all listing transactions for a given account when authenticated as an property owner */
  transactionListAllForAccount: TransactionListAllForAccountResponse;
  travelerSurveyPrompt: TravelerSurveyPromptResponse;
  /** Get all referral campaigns for the current user */
  userReferralCampaignsForCurrentUser: UserReferralCampaignsForCurrentUserResponse;
  /** List all users with access records to listing */
  usersListAllWithAccessOnListingByStatus: UsersListAllWithAccessOnListingByStatusResponse;
  /** Minimum version supported by mobile */
  validateVersion: MobileVersionResponse;
};

export type RootQueryTypeAccountActionLinkArgs = {
  token: Scalars['String']['input'];
};

export type RootQueryTypeAccountByIdArgs = {
  id: Scalars['String']['input'];
};

export type RootQueryTypeAccountBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type RootQueryTypeAccountListingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type RootQueryTypeAccountsListAllActiveArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongNameFilter?: InputMaybe<Scalars['String']['input']>;
};

export type RootQueryTypeAccountsListRandomArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeAffiliationSearchArgs = {
  listingId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  type?: AffiliationTypeFilter;
};

export type RootQueryTypeBookingQuoteByListingAndDatesArgs = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type RootQueryTypeComparisonQuoteByListingAndDatesArgs = {
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  externalListingUrl: Scalars['String']['input'];
  numberOfAdults?: Scalars['Int']['input'];
  numberOfChildren?: Scalars['Int']['input'];
  numberOfInfants?: Scalars['Int']['input'];
  numberOfPets?: Scalars['Int']['input'];
  priceType?: PriceType;
  quoteId: Scalars['ID']['input'];
};

export type RootQueryTypeCouponFindByPromoCodeArgs = {
  promoCode: Scalars['String']['input'];
};

export type RootQueryTypeFeaturesListAllArgs = {
  propertyType?: InputMaybe<PropertyType>;
};

export type RootQueryTypeGalleryAssetByIdArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeGiftCardByCertificateNumberArgs = {
  certificateNumber: Scalars['String']['input'];
};

export type RootQueryTypeGiftCardByIdArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeGiftCardByPaymentServiceTransactionClientSecretArgs = {
  clientSecret: Scalars['String']['input'];
};

export type RootQueryTypeGiftCardImageByIdArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeGiftCardImageListAllActiveArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListSupportedByOtaUrlsArgs = {
  otaUrls: Array<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingBookingInfoArgs = {
  slug: Scalars['String']['input'];
};

export type RootQueryTypeListingByExternalIdAndSourceArgs = {
  externalId: Scalars['String']['input'];
  externalSource: ExternalSource;
};

export type RootQueryTypeListingByIdAndUserArgs = {
  id: Scalars['String']['input'];
};

export type RootQueryTypeListingBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type RootQueryTypeListingPrivateAccessForUserArgs = {
  listingId: Scalars['ID']['input'];
};

export type RootQueryTypeListingReviewSummariesListAllForListingArgs = {
  id: Scalars['String']['input'];
};

export type RootQueryTypeListingReviewsListAllForListingArgs = {
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ListingReviewSortOptions>;
};

export type RootQueryTypeListingsHomePageArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingsListAllActiveArgs = {
  acceptsGiftCardsFilter?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  accountId?: InputMaybe<Scalars['String']['input']>;
  applyFeaturedByOwnerFilter?: InputMaybe<Scalars['Boolean']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  featuresFilterAny?: InputMaybe<Array<FeatureKey>>;
  maxAverageSavings?: InputMaybe<Scalars['Float']['input']>;
  minAverageSavings?: InputMaybe<Scalars['Float']['input']>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minPricingStatsCount?: InputMaybe<Scalars['Int']['input']>;
  onlyDiamondCollection?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  requireBookable?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ListingSortOptions>;
  stateOrProvinceLongNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};

export type RootQueryTypeListingsListAllFavoritedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListingFavoriteSortOptions>;
};

export type RootQueryTypeListingsListAllFeaturedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingsListAllHighlyRatedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingsListAllIndexableArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingsListAllTrendingArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListingsSearchArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  centerLat?: InputMaybe<Scalars['Float']['input']>;
  centerLng?: InputMaybe<Scalars['Float']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  maxPriceCents?: InputMaybe<Scalars['Int']['input']>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minPriceCents?: InputMaybe<Scalars['Int']['input']>;
  northEastLat?: InputMaybe<Scalars['Float']['input']>;
  northEastLng?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  searchType: ListingsSearchType;
  sort?: InputMaybe<ListingSortOptions>;
  southWestLat?: InputMaybe<Scalars['Float']['input']>;
  southWestLng?: InputMaybe<Scalars['Float']['input']>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};

export type RootQueryTypeListingsSearchAllActiveForPlaceArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey>>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeName?: InputMaybe<Scalars['String']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType>>;
  regionPath?: InputMaybe<Scalars['String']['input']>;
  uniquePropertyTypes?: InputMaybe<Array<InputMaybe<UniquePropertyType>>>;
};

export type RootQueryTypePlaceByAddressArgs = {
  address: Scalars['String']['input'];
};

export type RootQueryTypePlaceByIdArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypePlaceSearchGeometryArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypePlacesAutocompleteArgs = {
  name: Scalars['String']['input'];
  placeTypeFilter?: InputMaybe<PlaceTypeFilter>;
};

export type RootQueryTypePriceByOtaUrlListingAndDatesArgs = {
  adultCount?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  childCount?: InputMaybe<Scalars['Int']['input']>;
  externalOtaUrl: Scalars['String']['input'];
  infantCount?: InputMaybe<Scalars['Int']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeReferralCodeFindByCodeArgs = {
  code: Scalars['String']['input'];
};

export type RootQueryTypeRegionsListAllArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeRegionsListAllFeaturedArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeRegionsListAllWithActiveSearchPageContentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchType?: InputMaybe<SearchPageContentType>;
};

export type RootQueryTypeReservationByIdArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeReservationCommissionActivityExportForAccountArgs = {
  billingMonth: Scalars['String']['input'];
  kind?: InputMaybe<ReservationCommissionKind>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReservationCommissionStatuses>;
};

export type RootQueryTypeReservationCommissionListAllForAccountArgs = {
  billingMonth?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ReservationCommissionKind>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReservationCommissionStatuses>;
};

export type RootQueryTypeReservationCommissionStatementForAccountArgs = {
  billingMonth: Scalars['String']['input'];
};

export type RootQueryTypeReservationCommissionSummaryForAccountArgs = {
  billingMonth: Scalars['String']['input'];
};

export type RootQueryTypeReservationForOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type RootQueryTypeReservationsListAllForUserArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<InputMaybe<ReservationStatuses>>>;
};

export type RootQueryTypeRewardsForCurrentUserArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeSearchPageContentForUrlPathAndTypeArgs = {
  searchType: SearchPageContentType;
  urlPath: Scalars['String']['input'];
};

export type RootQueryTypeSearchPageContentListAllArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  h1Query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SearchPageContentType>;
};

export type RootQueryTypeTransactionListAllForAccountArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeUserReferralCampaignsForCurrentUserArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootQueryTypeUsersListAllWithAccessOnListingByStatusArgs = {
  listingId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: ListingAccessStatuses;
};

export type RootQueryTypeValidateVersionArgs = {
  platform: MobileType;
  version: Scalars['String']['input'];
};

/** Search Page Content object */
export type SearchPageContent = {
  /** The title for the about items for the search page */
  aboutItemsTitle?: Maybe<Scalars['String']['output']>;
  /** Flag indiciating if search page content is currently searchable/active */
  active: Scalars['Boolean']['output'];
  /** List of cities associated w/ this search page content */
  cities: Array<SearchPageContent>;
  /** The title for the faqs for the search page */
  faqsTitle?: Maybe<Scalars['String']['output']>;
  /** Pre-defined listing filter feature keys (from topic) */
  features: Array<FeatureKey>;
  /** The main heading for the page */
  h1: Scalars['String']['output'];
  /** The main paragraph accompanying the h1 for the page in raw Draft.js format */
  h1ParagraphRaw?: Maybe<Scalars['String']['output']>;
  /** The secondary heading for the page */
  h2?: Maybe<Scalars['String']['output']>;
  /** The secondary paragraph accompanying the h2 for the page in raw Draft.js format */
  h2ParagraphRaw?: Maybe<Scalars['String']['output']>;
  /** True if topic bounds should override region bounds */
  hasTopicBounds: Scalars['Boolean']['output'];
  /** The endpoint of the hero image host */
  heroImageEndpoint?: Maybe<Scalars['String']['output']>;
  /** The alt description for the main hero image */
  heroImageHtmlAlt?: Maybe<Scalars['String']['output']>;
  /** The hero image path, relative to the endpoint */
  heroImagePath?: Maybe<Scalars['String']['output']>;
  /** The image processing flag */
  heroImageProcessing: Scalars['Boolean']['output'];
  /** The upload location for the hero image */
  heroImageUploadUrl?: Maybe<Scalars['String']['output']>;
  /** The main hero image for the page */
  heroImageUrl: Scalars['String']['output'];
  /** The HTML description for the search page */
  htmlMetaDescription?: Maybe<Scalars['String']['output']>;
  /** The HTML meta title for the search page */
  htmlMetaTitle?: Maybe<Scalars['String']['output']>;
  /** The search page content ID */
  id: Scalars['ID']['output'];
  /** Minimum guest capacity filter (from topic) */
  minGuestCapacity?: Maybe<Scalars['Int']['output']>;
  /** Minimum bathrooms filter (from topic) */
  minNumberOfBathrooms?: Maybe<Scalars['Int']['output']>;
  /** Minimum bedrooms filter (from topic) */
  minNumberOfBedrooms?: Maybe<Scalars['Int']['output']>;
  /** Minimum beds filter (from topic) */
  minNumberOfBeds?: Maybe<Scalars['Int']['output']>;
  /** North-east latitude for topic bounds override */
  northEastLat?: Maybe<Scalars['Float']['output']>;
  /** North-east longitude for topic bounds override */
  northEastLng?: Maybe<Scalars['Float']['output']>;
  /** The canonical URL path for this search page (e.g. /vacation-rentals/usa/texas/austin or /vacation-rentals/usa/texas/austin/bbq), including the topic suffix when present */
  path?: Maybe<Scalars['String']['output']>;
  /** The region associated w/ this search page content */
  region?: Maybe<Region>;
  /** List of links associated w/ this search page content */
  searchPageLinks: Array<SearchPageLink>;
  /** List of paragraphs associated w/ this search page content */
  searchPageParagraphs: Array<SearchPageParagraph>;
  /** The topic associated with this search page content */
  searchPageTopic?: Maybe<SearchPageTopic>;
  /** The search type for the content */
  searchType: SearchPageContentType;
  /** South-west latitude for topic bounds override */
  southWestLat?: Maybe<Scalars['Float']['output']>;
  /** South-west longitude for topic bounds override */
  southWestLng?: Maybe<Scalars['Float']['output']>;
  /** The topic slug for this search page content, null for standard region pages */
  topicSlug?: Maybe<Scalars['String']['output']>;
  /** The time the search page content was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Response for a search page content by a given place name */
export type SearchPageContentActiveForPlaceResponse =
  | NotFoundError
  | SearchPageContent
  | ValidationErrorCollection;

/** Search page content collection object contains a paginated collection of search page contents and meta data about the collection */
export type SearchPageContentCollection = {
  /** The collection of search page content for a given page */
  entries: Array<SearchPageContent>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export enum SearchPageContentType {
  BedAndBreakfast = 'BED_AND_BREAKFAST',
  VacationRental = 'VACATION_RENTAL',
}

/** Search Page Link object */
export type SearchPageLink = {
  /** The category grouping for the custom link */
  customLinkCategory?: Maybe<Scalars['String']['output']>;
  /** The href for the link */
  href: Scalars['String']['output'];
  /** The link ID */
  id: Scalars['ID']['output'];
  /** The title for the link */
  title: Scalars['String']['output'];
  /** The type of link */
  type: SearchPageLinkType;
};

/** The search page link type enum */
export enum SearchPageLinkType {
  /** Link to a nearby attraction */
  Attraction = 'ATTRACTION',
  /** Link to a blog */
  Blog = 'BLOG',
  /** Link to a custom section */
  CustomLinks = 'CUSTOM_LINKS',
  /** Link to a similar area */
  SimilarArea = 'SIMILAR_AREA',
}

/** Search Page Paragraph object */
export type SearchPageParagraph = {
  /** The paragraph body in raw Draft.js format */
  bodyRaw: Scalars['String']['output'];
  /** The Paragraph ID */
  id: Scalars['ID']['output'];
  /** The position of the gallery asset */
  position?: Maybe<Scalars['Float']['output']>;
  /** The title for the Paragraph */
  title: Scalars['String']['output'];
  /** The type of paragraph */
  type: SearchPageParagraphType;
};

/** The search page paragraph type enum */
export enum SearchPageParagraphType {
  /** Paragraph about the search page */
  About = 'ABOUT',
  /** Paragraph w/ frequently asked question info */
  Faq = 'FAQ',
}

/** Search Page Topic object - defines filter settings for topic-based search pages */
export type SearchPageTopic = {
  /** Topic description */
  description?: Maybe<Scalars['String']['output']>;
  /** Pre-defined listing filter feature keys for this topic */
  features: Array<FeatureKey>;
  /** True if the topic has custom bounds configured */
  hasBounds: Scalars['Boolean']['output'];
  /** The topic ID */
  id: Scalars['ID']['output'];
  /** Minimum guest capacity filter for listings */
  minGuestCapacity?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of bathrooms filter for listings */
  minNumberOfBathrooms?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of bedrooms filter for listings */
  minNumberOfBedrooms?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of beds filter for listings */
  minNumberOfBeds?: Maybe<Scalars['Int']['output']>;
  /** Display name for the topic */
  name: Scalars['String']['output'];
  /** North-east latitude for bounds override */
  northEastLat?: Maybe<Scalars['Float']['output']>;
  /** North-east longitude for bounds override */
  northEastLng?: Maybe<Scalars['Float']['output']>;
  /** URL slug for the topic */
  slug: Scalars['String']['output'];
  /** South-west latitude for bounds override */
  southWestLat?: Maybe<Scalars['Float']['output']>;
  /** South-west longitude for bounds override */
  southWestLng?: Maybe<Scalars['Float']['output']>;
  /** The time the topic was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type SearchPlace = {
  /** The geometry for the given place */
  geometry?: Maybe<Geometry>;
  /** The name for the given place */
  name?: Maybe<Scalars['String']['output']>;
  /** The place type for the given place */
  placeType?: Maybe<Scalars['String']['output']>;
};

export enum SearchPromotionType {
  Featured = 'FEATURED',
}

export type SendPasswordResetEmailInput = {
  /** The user's account email */
  email: Scalars['String']['input'];
};

/** The result of the send password reset email mutation */
export type SendPasswordResetEmailResponse =
  | NotFoundError
  | PasswordResetMessage;

/** An error encountered when a service required to fulfill the request is unavailable */
export type ServiceUnavailableError = {
  message: Scalars['String']['output'];
};

/** The result of the set account card mutation */
export type SetAccountCardResult =
  | Card
  | NotFoundError
  | ServiceUnavailableError
  | UnauthenticatedError
  | UnauthorizedError
  | ValidationErrorCollection;

export type SetSubscriptionCouponInput = {
  /** The promo code for the subscription */
  promoCode: Scalars['String']['input'];
};

/** The result of the set subscription coupon mutation for an authenticated account */
export type SetSubscriptionCouponResult =
  | Account
  | NotFoundError
  | UnauthenticatedError;

export type SetSubscriptionInput = {
  listingId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  /** The promo code for the subscription */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  referredByListingId?: InputMaybe<Scalars['ID']['input']>;
};

/** The result of the set subscription mutation for an authenticated innkeeper */
export type SetSubscriptionResult =
  | Listing
  | NotFoundError
  | UnauthenticatedError
  | ValidationErrorCollection;

/** The gift card shipping provider type */
export enum ShippingProviderType {
  /** https://www.usps.com/ */
  Usps = 'USPS',
}

export type StreamlinePartnerPmsConnectionCreateInput = {
  accountId: Scalars['String']['input'];
  tokenKey: Scalars['String']['input'];
  tokenSecret: Scalars['String']['input'];
};

export type StreamlinePmsConnectionCreateInput = {
  tokenKey: Scalars['String']['input'];
  tokenSecret: Scalars['String']['input'];
};

/** The result of subscribing an email to the iOS app waitlist */
export type SubscribeEmailToIosWaitlistResult =
  | IosWaitlistSubscription
  | ServiceUnavailableError
  | ValidationErrorCollection;

/** The result of subscribing an email to the newsletter */
export type SubscribeEmailToNewsletterResult =
  | NewsletterSubscription
  | ServiceUnavailableError
  | ValidationErrorCollection;

/** The subscription types */
export enum SubscriptionType {
  Bronze = 'BRONZE',
  Free = 'FREE',
  Gold = 'GOLD',
  Private = 'PRIVATE',
  Silver = 'SILVER',
}

/** The supported check in and checkout times */
export enum SupportedCheckInAndOutTimes {
  Am0100 = 'AM0100',
  Am0130 = 'AM0130',
  Am0200 = 'AM0200',
  Am0230 = 'AM0230',
  Am0300 = 'AM0300',
  Am0330 = 'AM0330',
  Am0400 = 'AM0400',
  Am0430 = 'AM0430',
  Am0500 = 'AM0500',
  Am0530 = 'AM0530',
  Am0600 = 'AM0600',
  Am0630 = 'AM0630',
  Am0700 = 'AM0700',
  Am0730 = 'AM0730',
  Am0800 = 'AM0800',
  Am0830 = 'AM0830',
  Am0900 = 'AM0900',
  Am0930 = 'AM0930',
  Am1000 = 'AM1000',
  Am1030 = 'AM1030',
  Am1100 = 'AM1100',
  Am1130 = 'AM1130',
  Am1200 = 'AM1200',
  Am1230 = 'AM1230',
  Flexible = 'FLEXIBLE',
  Pm0100 = 'PM0100',
  Pm0130 = 'PM0130',
  Pm0200 = 'PM0200',
  Pm0230 = 'PM0230',
  Pm0300 = 'PM0300',
  Pm0330 = 'PM0330',
  Pm0400 = 'PM0400',
  Pm0430 = 'PM0430',
  Pm0500 = 'PM0500',
  Pm0530 = 'PM0530',
  Pm0600 = 'PM0600',
  Pm0630 = 'PM0630',
  Pm0700 = 'PM0700',
  Pm0730 = 'PM0730',
  Pm0800 = 'PM0800',
  Pm0830 = 'PM0830',
  Pm0900 = 'PM0900',
  Pm0930 = 'PM0930',
  Pm1000 = 'PM1000',
  Pm1030 = 'PM1030',
  Pm1100 = 'PM1100',
  Pm1130 = 'PM1130',
  Pm1200 = 'PM1200',
  Pm1230 = 'PM1230',
}

/** Task object for async processes */
export type Task = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  finalizedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  importCount?: Maybe<Scalars['Int']['output']>;
  importSuccessCount?: Maybe<Scalars['Int']['output']>;
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: TaskStatus;
};

/** The task status */
export enum TaskStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export type TrackPmsConnectionCreateInput = {
  endpointUrl: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Transaction object */
export type Transaction = {
  /** The transaction amount in cents */
  amountCents: Scalars['Int']['output'];
  /** The time the transaction was created */
  createdAt: Scalars['DateTime']['output'];
  /** The transaction ID */
  id: Scalars['ID']['output'];
  /** The transaction type */
  type: TransactionType;
  /** The last time the transaction was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type TransactionCollection = {
  /** The collection of transactions for a given page */
  entries: Array<Transaction>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type TransactionListAllForAccountResponse =
  | TransactionCollection
  | UnauthenticatedError
  | ValidationErrorCollection;

/**
 * The gift card payment source type
 * https://stripe.com/docs/api/sources/object
 */
export enum TransactionPaymentSourceType {
  AchCreditDebit = 'ACH_CREDIT_DEBIT',
  AchCreditTransfer = 'ACH_CREDIT_TRANSFER',
  Affirm = 'AFFIRM',
  Apple = 'APPLE',
  Card = 'CARD',
  Google = 'GOOGLE',
  Link = 'LINK',
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Withdrawal = 'WITHDRAWAL',
}

export enum TravelerSurveyChoice {
  ArticleOrNews = 'ARTICLE_OR_NEWS',
  BookedBefore = 'BOOKED_BEFORE',
  FriendOrFamily = 'FRIEND_OR_FAMILY',
  Influencer = 'INFLUENCER',
  Other = 'OTHER',
  Podcast = 'PODCAST',
  PropertyRecommended = 'PROPERTY_RECOMMENDED',
  SavvyEmail = 'SAVVY_EMAIL',
  SearchEngine = 'SEARCH_ENGINE',
  SocialMedia = 'SOCIAL_MEDIA',
}

export type TravelerSurveyChoiceOption = {
  label: Scalars['String']['output'];
  value: TravelerSurveyChoice;
};

export type TravelerSurveyPromptResponse =
  | TravelerSurveyQuestion
  | TravelerSurveyResponse
  | UnauthenticatedError;

export type TravelerSurveyQuestion = {
  choices: Array<TravelerSurveyChoiceOption>;
};

export type TravelerSurveyResponse = {
  choice: TravelerSurveyChoice;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type TravelerSurveyResponseCreateInput = {
  choice: TravelerSurveyChoice;
  promptingReservationId: Scalars['ID']['input'];
};

export type TravelerSurveyResponseCreateResult =
  | NotFoundError
  | TravelerSurveyResponse
  | UnauthenticatedError
  | ValidationErrorCollection;

/** An error encountered when the request is not unauthenticated */
export type UnauthenticatedError = {
  message: Scalars['String']['output'];
};

/** An error encountered when the request is not unauthorized */
export type UnauthorizedError = {
  message: Scalars['String']['output'];
};

export enum UniquePropertyType {
  Barn = 'BARN',
  Boat = 'BOAT',
  BoutiqueHotel = 'BOUTIQUE_HOTEL',
  Bungalow = 'BUNGALOW',
  Cabin = 'CABIN',
  CamperOrRv = 'CAMPER_OR_RV',
  Campsite = 'CAMPSITE',
  Casita = 'CASITA',
  Castle = 'CASTLE',
  Cave = 'CAVE',
  Chalet = 'CHALET',
  Condo = 'CONDO',
  Cottage = 'COTTAGE',
  DomeHouse = 'DOME_HOUSE',
  EarthenHome = 'EARTHEN_HOME',
  FarmStay = 'FARM_STAY',
  GlampingTent = 'GLAMPING_TENT',
  HistoricHotel = 'HISTORIC_HOTEL',
  Home = 'HOME',
  Hostel = 'HOSTEL',
  Houseboat = 'HOUSEBOAT',
  Hut = 'HUT',
  Lighthouse = 'LIGHTHOUSE',
  NatureLodge = 'NATURE_LODGE',
  Resort = 'RESORT',
  Rv = 'RV',
  TinyHome = 'TINY_HOME',
  Tipi = 'TIPI',
  Townhouse = 'TOWNHOUSE',
  Treehouse = 'TREEHOUSE',
  Villa = 'VILLA',
  Windmill = 'WINDMILL',
  Yurt = 'YURT',
}

/** An error encountered when the server can understand a request, but cannot process the request */
export type UnprocessableContentError = {
  message: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

/** An error encountered when the request does not have verified resource */
export type UnverifiedError = {
  message: Scalars['String']['output'];
};

/** An error response that indicates that the server refuses to perform the request using the current protocol but might be willing to do so after the client upgrades to a different protocol */
export type UpgradeRequiredError = {
  message: Scalars['String']['output'];
  minimumSupportedVersion: Scalars['String']['output'];
};

/** User object */
export type User = {
  /** The user access token */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** The account that the user belongs to */
  account?: Maybe<Account>;
  /** The role this user has for the host-side account */
  accountRole?: Maybe<AccountRole>;
  /** The user avatar path, relative to the endpoint */
  avatarPath?: Maybe<Scalars['String']['output']>;
  /** The user host image processing flag */
  avatarProcessing: Scalars['Boolean']['output'];
  /** The user host image URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user account is blocked */
  blocked: Scalars['Boolean']['output'];
  /** Flag indicating if the identity has been claimed */
  claimable: Scalars['Boolean']['output'];
  /** The user's birthday */
  dob?: Maybe<Scalars['Date']['output']>;
  /** The user email */
  email: Scalars['String']['output'];
  /** The user first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user ID */
  id: Scalars['ID']['output'];
  /** The identity provider used to register the user */
  identityProvider: IdentityProvider;
  /** Flag indicating if the identity has been verified */
  identityVerified: Scalars['Boolean']['output'];
  /** The last time the user authenticated themselves on the platform */
  lastAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The Stripe customer ID associated with the account */
  paymentServiceUserId: Scalars['String']['output'];
  /** The user phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** E.164 of the verified phone number, or nil if no number is verified */
  phoneNumberVerified?: Maybe<Scalars['String']['output']>;
  /** Timestamp the phone number was last verified, or nil */
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that referred this user */
  referredByUser?: Maybe<User>;
  /** The user identity ID that referred this user */
  referredByUserId?: Maybe<Scalars['String']['output']>;
  /** The user refresh token */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The date time the identity was registered */
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  salesforceUrl?: Maybe<Scalars['String']['output']>;
  /** The referral campaigns created by this user */
  userReferralCampaigns: Array<UserReferralCampaign>;
  /** The identity verification status */
  verificationStatus?: Maybe<VerificationStatus>;
  /** The traveler government-ID verification status */
  travelerVerificationStatus?: Maybe<VerificationStatus>;
};

export type UserAccountAddInput = {
  /** The user that will be added to the account ID */
  userEmail: Scalars['String']['input'];
};

/** The result of the user account update mutation */
export type UserAccountAddResponse =
  | ConflictError
  | NotFoundError
  | User
  | ValidationErrorCollection;

export type UserAccountRemoveInput = {
  /** The user that will be added to the account ID */
  userId: Scalars['String']['input'];
};

/** The result of the user account update mutation */
export type UserAccountRemoveResponse =
  | ConflictError
  | NotFoundError
  | User
  | ValidationErrorCollection;

/** The result of adding a referral code to a user */
export type UserAddReferralCodeResponse =
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

export type UserAndPmAccountCreateInput = {
  /** The account address line one */
  addressLineOne: Scalars['String']['input'];
  /** The account address line two */
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  /** Cloudflare Turnstile token from the signup form widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** The account city */
  city: Scalars['String']['input'];
  /** The company name for the PM account */
  companyName: Scalars['String']['input'];
  /** The account country or region */
  countryOrRegionLongName: Scalars['String']['input'];
  /** The default subscription type for listings */
  defaultListingLevel?: InputMaybe<SubscriptionType>;
  /** The user's date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The user's account email */
  email: Scalars['String']['input'];
  /** The user's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The homeowner marketing URL */
  homeownerMarketingUrl?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The company marketing website URL */
  marketingWebsiteUrl: Scalars['String']['input'];
  /** Number of listings managed */
  numberOfListings: Scalars['Int']['input'];
  /** The user's account password */
  password: Scalars['String']['input'];
  /** The user's account phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The PMS software used */
  pmsSoftware: Scalars['String']['input'];
  /** The account postal code */
  postalCode: Scalars['String']['input'];
  /** Whether the account is private */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** The account state or province */
  stateOrProvinceLongName: Scalars['String']['input'];
};

export type UserAndPmAccountCreatePayload = {
  /** The created property manager account */
  account: Account;
  /** Whether the account is based in the United States */
  isUsBased: Scalars['Boolean']['output'];
  /** The number of listings the PM reported managing */
  numberOfListings: Scalars['Int']['output'];
  /** The onboarding session created for this account */
  pmOnboardingSession: PmOnboardingSession;
  /** The PMS software the PM reported using */
  pmsSoftware: Scalars['String']['output'];
  /** The created user with auth tokens */
  user: User;
};

/** The result of creating a user and PM account together */
export type UserAndPmAccountCreateResponse =
  | UserAndPmAccountCreatePayload
  | ValidationErrorCollection;

export type UserAppleSocialSessionInput = {
  /** The access token returned from Apple OAuth flow */
  accessToken: Scalars['String']['input'];
  /** The user email provided by Apple during the first login attempt */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The user first_name provided by Apple during the first login attempt */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user last_name provided by Apple during the first login attempt */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserCollection = {
  /** The collection of users for a given page */
  entries: Array<User>;
  /** The meta information containing additional info about the collection */
  meta: CollectionInfo;
};

export type UserCreateInput = {
  /** Cloudflare Turnstile token from the signup form widget */
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  /** The user's date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The user's account email */
  email: Scalars['String']['input'];
  /** The user's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The user's account password */
  password: Scalars['String']['input'];
  /** The user's account phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional referral code to link this user to a referral campaign */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user create mutation */
export type UserCreateResponse = User | ValidationErrorCollection;

export type UserFacebookSocialSessionInput = {
  /** The access token returned from Facebook OAuth flow */
  accessToken: Scalars['String']['input'];
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /** The signed request returned from Facebook OAuth flow */
  signedRequest?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user session mutation */
export type UserFacebookSocialSessionResponse =
  | BlockedError
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

export type UserGoogleSocialSessionInput = {
  /** The access token returned from Google OAuth flow */
  accessToken: Scalars['String']['input'];
  /** Optional referral code to be used during sign up */
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the user account mark for deletion mutation */
export type UserMarkForDeletionResponse = User | ValidationErrorCollection;

/** A user's referral campaign */
export type UserReferralCampaign = {
  /** The description of the campaign */
  campaignDescription: Scalars['String']['output'];
  /** The display name of the campaign */
  campaignName: Scalars['String']['output'];
  /** The type of referral campaign */
  campaignType: ReferralCampaignType;
  /** The unique referral code */
  code: Scalars['String']['output'];
  /** The campaign ID */
  id: Scalars['ID']['output'];
  /** When the campaign was created */
  insertedAt: Scalars['DateTime']['output'];
  /** The current rewards balance in cents */
  rewardsBalanceCents: Scalars['Int']['output'];
  /** The number of rewards issued to the referring user */
  rewardsIssuedCount: Scalars['Int']['output'];
  /** The number of rewards remaining for the referring user (null if unlimited) */
  rewardsRemaining?: Maybe<Scalars['Int']['output']>;
  /** The current state of the campaign */
  state: UserReferralCampaignState;
};

/** A collection of user referral campaigns */
export type UserReferralCampaignCollection = {
  /** The list of referral campaigns */
  entries: Array<UserReferralCampaign>;
  /** The total number of campaigns */
  totalCount: Scalars['Int']['output'];
};

export type UserReferralCampaignCreateInput = {
  /** The type of referral campaign to create */
  campaignType: ReferralCampaignType;
};

/** The state of a user referral campaign */
export enum UserReferralCampaignState {
  /** The campaign is active and accepting referrals */
  Active = 'ACTIVE',
  /** The campaign is inactive and not accepting referrals */
  Inactive = 'INACTIVE',
}

/** Response for fetching the current user's referral campaigns */
export type UserReferralCampaignsForCurrentUserResponse =
  | UnauthenticatedError
  | UserReferralCampaignCollection;

export type UserSessionInput = {
  /** The user's email */
  email: Scalars['String']['input'];
  /** The user's password */
  password: Scalars['String']['input'];
};

export type UserSessionRefreshInput = {
  /** The user's refresh token */
  refreshToken: Scalars['String']['input'];
};

/** The result of the user session mutation */
export type UserSessionRefreshResponse =
  | BlockedError
  | UnauthenticatedError
  | User;

/** The result of the user session mutation */
export type UserSessionResponse =
  | BlockedError
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

export type UserUpdateInput = {
  /** The user uploaded avatar URL. */
  avatarUploadUrl?: InputMaybe<Scalars['String']['input']>;
  /** The updated date of birth for an user. */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** The updated email for an user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The updated first name for an user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The updated last name for an user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The updated phone number for an user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the update user mutation for an authenticated user */
export type UserUpdateResult =
  | UnauthenticatedError
  | User
  | ValidationErrorCollection;

/** Response for getting the users with access records for the given listing */
export type UsersListAllWithAccessOnListingByStatusResponse =
  | UnauthenticatedError
  | UserCollection;

export type VacayHomePmsConnectionCreateInput = {
  apiKey: Scalars['String']['input'];
  reservationApiKey: Scalars['String']['input'];
};

/** An error encountered when mutating data */
export type ValidationError = {
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** A collection of errors encountered when mutating data */
export type ValidationErrorCollection = {
  errors: Array<ValidationError>;
};

export enum VerificationStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  NeedsReview = 'NEEDS_REVIEW',
  Pending = 'PENDING',
}

/** The version object */
export type Version = {
  /** The version value */
  value: Scalars['String']['output'];
};

export type AccountActionLinkAcceptTermsOfUseMutationVariables = Exact<{
  token: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  isAuthorized: Scalars['Boolean']['input'];
  termsOfUseVersion: Scalars['String']['input'];
}>;

export type AccountActionLinkAcceptTermsOfUseMutation = {
  accountActionLinkAcceptTermsOfUse:
    | {
        __typename: 'AccountActionLink';
        companyName?: string | undefined;
        email: string;
        firstName?: string | undefined;
        lastName?: string | undefined;
        shouldAcceptTermsOfUse: boolean;
        shouldAddCreditCard: boolean;
        termsOfUseVersion: string;
        authorizationStatement: string;
      }
    | {
        __typename: 'UnprocessableContentError';
        message: string;
        reason?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{ field?: string | undefined; message: string }>;
      };
};

export type AccountActionLinkRequestNewLinkMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type AccountActionLinkRequestNewLinkMutation = {
  accountActionLinkRequestNewLink:
    | { __typename: 'AccountActionLinkNewLinkSent'; message: string }
    | {
        __typename: 'UnprocessableContentError';
        message: string;
        reason?: string | undefined;
      };
};

export type AccountActionLinkCreateCardSetupSessionMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type AccountActionLinkCreateCardSetupSessionMutation = {
  accountActionLinkCreateCardSetupSession:
    | { __typename: 'CardSetupSession'; url: string }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'ServiceUnavailableError'; message: string }
    | {
        __typename: 'UnprocessableContentError';
        message: string;
        reason?: string | undefined;
      };
};

export type AccountActionLinkFieldsFragment = {
  companyName?: string | undefined;
  email: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  shouldAcceptTermsOfUse: boolean;
  shouldAddCreditCard: boolean;
  termsOfUseVersion: string;
  authorizationStatement: string;
};

export type AccountActionLinkQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type AccountActionLinkQuery = {
  accountActionLink:
    | {
        __typename: 'AccountActionLink';
        companyName?: string | undefined;
        email: string;
        firstName?: string | undefined;
        lastName?: string | undefined;
        shouldAcceptTermsOfUse: boolean;
        shouldAddCreditCard: boolean;
        termsOfUseVersion: string;
        authorizationStatement: string;
      }
    | {
        __typename: 'UnprocessableContentError';
        message: string;
        reason?: string | undefined;
      };
};

export type AccountReviewSummaryCreateMutationVariables = Exact<{
  input: AccountReviewSummaryCreateInput;
}>;

export type AccountReviewSummaryCreateMutation = {
  accountReviewSummaryCreate:
    | {
        __typename: 'AccountReviewSummary';
        id: string;
        imageUrl?: string | undefined;
        numberOfReviews?: number | undefined;
        source: AccountReviewSummarySource;
        sourceId: string;
        url?: string | undefined;
        rating: number;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type PrivateAccountFieldsFragment = {
  pmsSoftware?: string | undefined;
  reportedPmsSoftware?: string | undefined;
  numberOfClaimedListings?: number | undefined;
  activeListingsCount: number;
  addressLineOne?: string | undefined;
  addressLineTwo?: string | undefined;
  city?: string | undefined;
  countryOrRegionLongName?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  postalCode?: string | undefined;
  salesforceUrl?: string | undefined;
  onboardingCompleted: boolean;
  onboardingCompletedAt?: string | undefined;
  id: string;
  slug: string;
  avatarUrl?: string | undefined;
  avatarFileName?: string | undefined;
  avatarUploadUrl?: string | undefined;
  avatarProcessing: boolean;
  companyName?: string | undefined;
  heroFileName?: string | undefined;
  heroUploadUrl?: string | undefined;
  heroUrl?: string | undefined;
  heroProcessing: boolean;
  title?: string | undefined;
  description?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  marketingWebsiteUrl?: string | undefined;
  homeownerMarketingUrl?: string | undefined;
  twitterUrl?: string | undefined;
  instagramUrl?: string | undefined;
  twitterHandle?: string | undefined;
  instagramUsername?: string | undefined;
  facebookPageUrl?: string | undefined;
  inBusinessSince?: number | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  youtubeUrl?: string | undefined;
  linkedinUrl?: string | undefined;
  accountReviewSummaries: Array<{
    id: string;
    source: AccountReviewSummarySource;
    sourceId: string;
    numberOfReviews?: number | undefined;
    imageUrl?: string | undefined;
    rating: number;
  }>;
};

export type PrivateAccountIndexFieldsFragment = {
  pmsSoftware?: string | undefined;
  reportedPmsSoftware?: string | undefined;
  numberOfClaimedListings?: number | undefined;
  activeListingsCount: number;
  addressLineOne?: string | undefined;
  addressLineTwo?: string | undefined;
  city?: string | undefined;
  countryOrRegionLongName?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  postalCode?: string | undefined;
  firstPublishedAt?: string | undefined;
  stripeCustomerId: string;
  creditCardOnFile: boolean;
  salesforceUrl?: string | undefined;
  onboardingCompleted: boolean;
  onboardingCompletedAt?: string | undefined;
  archived: boolean;
  id: string;
  slug: string;
  avatarUrl?: string | undefined;
  avatarFileName?: string | undefined;
  avatarUploadUrl?: string | undefined;
  avatarProcessing: boolean;
  companyName?: string | undefined;
  heroFileName?: string | undefined;
  heroUploadUrl?: string | undefined;
  heroUrl?: string | undefined;
  heroProcessing: boolean;
  title?: string | undefined;
  description?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  marketingWebsiteUrl?: string | undefined;
  homeownerMarketingUrl?: string | undefined;
  twitterUrl?: string | undefined;
  instagramUrl?: string | undefined;
  twitterHandle?: string | undefined;
  instagramUsername?: string | undefined;
  facebookPageUrl?: string | undefined;
  inBusinessSince?: number | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  youtubeUrl?: string | undefined;
  linkedinUrl?: string | undefined;
  pmsConnection?:
    | {
        id: string;
        type: PmsName;
        failed: boolean;
        failingSince?: string | undefined;
        insertedAt: string;
        maskedCredentials?: string | undefined;
        userConfig: Array<{
          fieldName: string;
          value: string;
          options: Array<string>;
        }>;
      }
    | undefined;
  listings: Array<{
    id: string;
    lastPublishedAt?: string | undefined;
    firstPublishedAt?: string | undefined;
    name?: string | undefined;
    published: boolean;
    insertedAt?: string | undefined;
    listingLevel: SubscriptionType;
  }>;
  owner: { id: string; email: string };
  users: Array<{
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email: string;
    accountRole?: AccountRole | undefined;
  }>;
  billingSubscription?: { currentPeriodEnd: string } | undefined;
  latestTask?:
    | {
        id: string;
        status: TaskStatus;
        startedAt: string;
        completedAt?: string | undefined;
        importCount?: number | undefined;
        importSuccessCount?: number | undefined;
        importedAt?: string | undefined;
        processedAt?: string | undefined;
        finalizedAt?: string | undefined;
        expiresAt?: string | undefined;
        errors?: Array<string> | undefined;
      }
    | undefined;
  accountReviewSummaries: Array<{
    id: string;
    source: AccountReviewSummarySource;
    sourceId: string;
    numberOfReviews?: number | undefined;
    imageUrl?: string | undefined;
    rating: number;
  }>;
};

export type PublicAccountFieldsFragment = {
  id: string;
  slug: string;
  avatarUrl?: string | undefined;
  avatarFileName?: string | undefined;
  avatarUploadUrl?: string | undefined;
  avatarProcessing: boolean;
  companyName?: string | undefined;
  countryOrRegionLongName?: string | undefined;
  heroFileName?: string | undefined;
  heroUploadUrl?: string | undefined;
  heroUrl?: string | undefined;
  heroProcessing: boolean;
  title?: string | undefined;
  description?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  marketingWebsiteUrl?: string | undefined;
  homeownerMarketingUrl?: string | undefined;
  twitterUrl?: string | undefined;
  instagramUrl?: string | undefined;
  twitterHandle?: string | undefined;
  instagramUsername?: string | undefined;
  facebookPageUrl?: string | undefined;
  inBusinessSince?: number | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  youtubeUrl?: string | undefined;
  linkedinUrl?: string | undefined;
  city?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  accountReviewSummaries: Array<{
    id: string;
    source: AccountReviewSummarySource;
    sourceId: string;
    numberOfReviews?: number | undefined;
    imageUrl?: string | undefined;
    rating: number;
  }>;
};

export type PmAccountCreateMutationVariables = Exact<{
  input: PmAccountCreateInput;
}>;

export type PmAccountCreateMutation = {
  pmAccountCreate:
    | {
        __typename: 'Account';
        id: string;
        isUsBased?: boolean | undefined;
        pmOnboardingSession?:
          | {
              id: string;
              accountId?: string | undefined;
              userId?: string | undefined;
              pmsType?: string | undefined;
              currentStepKey: PmOnboardingStepKey;
              status: PmOnboardingSessionStatus;
              reviewReason?: PmOnboardingReviewReason | undefined;
              publishedAt?: string | undefined;
              startedAt: string;
              completedAt?: string | undefined;
              lastActivityAt: string;
              currentStepIndex: number;
              totalSteps: number;
              completedStepKeys: Array<PmOnboardingStepKey>;
              canAdvance: boolean;
              flow: {
                id: string;
                version: string;
                name: string;
                description?: string | undefined;
                isActive: boolean;
                totalSteps: number;
                steps: Array<{
                  stepKey: PmOnboardingStepKey;
                  position: number;
                  label: string;
                  required: boolean;
                }>;
              };
              stepCompletions: Array<{
                stepKey: PmOnboardingStepKey;
                completedAt: string;
              }>;
              account?:
                | {
                    id: string;
                    isUsBased?: boolean | undefined;
                    countryOrRegionLongName?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type AccountUpdateMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;

export type AccountUpdateMutation = {
  accountUpdate:
    | {
        __typename: 'Account';
        pmsSoftware?: string | undefined;
        reportedPmsSoftware?: string | undefined;
        numberOfClaimedListings?: number | undefined;
        activeListingsCount: number;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        postalCode?: string | undefined;
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        avatarFileName?: string | undefined;
        avatarUploadUrl?: string | undefined;
        avatarProcessing: boolean;
        companyName?: string | undefined;
        heroFileName?: string | undefined;
        heroUploadUrl?: string | undefined;
        heroUrl?: string | undefined;
        heroProcessing: boolean;
        title?: string | undefined;
        description?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        marketingWebsiteUrl?: string | undefined;
        homeownerMarketingUrl?: string | undefined;
        twitterUrl?: string | undefined;
        instagramUrl?: string | undefined;
        twitterHandle?: string | undefined;
        instagramUsername?: string | undefined;
        facebookPageUrl?: string | undefined;
        inBusinessSince?: number | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        linkedinUrl?: string | undefined;
        accountReviewSummaries: Array<{
          id: string;
          source: AccountReviewSummarySource;
          sourceId: string;
          numberOfReviews?: number | undefined;
          imageUrl?: string | undefined;
          rating: number;
        }>;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type AccountAcceptTermsOfUseMutationVariables = Exact<{
  [key: string]: never;
}>;

export type AccountAcceptTermsOfUseMutation = {
  accountAcceptTermsOfUse:
    | {
        __typename: 'Account';
        id: string;
        commissionable?: boolean | undefined;
        termsOfUseAcceptedAt?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;

export type CreateSubscriptionMutation = {
  createSubscription:
    | { __typename: 'Account'; id: string }
    | { __typename: 'ConflictError'; message: string }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'ServiceUnavailableError' }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type SetSubscriptionCouponMutationVariables = Exact<{
  input: SetSubscriptionCouponInput;
}>;

export type SetSubscriptionCouponMutation = {
  setSubscriptionCoupon:
    | { __typename: 'Account'; id: string }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type AccountUpdateAllListingSubscriptionsMutationVariables = Exact<{
  input: AccountUpdateAllListingSubscriptionsInput;
}>;

export type AccountUpdateAllListingSubscriptionsMutation = {
  accountUpdateAllListingSubscriptions:
    | {
        __typename: 'AccountBulkUpdateResults';
        successCount: number;
        failureCount: number;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type AccountBulkUpdateLocationObfuscatedMutationVariables = Exact<{
  input: AccountBulkUpdateLocationObfuscatedInput;
}>;

export type AccountBulkUpdateLocationObfuscatedMutation = {
  accountBulkUpdateLocationObfuscated:
    | {
        __typename: 'AccountBulkUpdateResults';
        successCount: number;
        failureCount: number;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type AccountSetDefaultListingLevelMutationVariables = Exact<{
  defaultListingLevel: SubscriptionType;
}>;

export type AccountSetDefaultListingLevelMutation = {
  accountSetDefaultListingLevel:
    | {
        __typename: 'Account';
        id: string;
        defaultListingLevel: SubscriptionType;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type AccountsListRandomQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
}>;

export type AccountsListRandomQuery = {
  accountsListRandom: {
    __typename: 'AccountCollection';
    entries: Array<{
      id: string;
      slug: string;
      avatarUrl?: string | undefined;
      avatarProcessing: boolean;
      heroUploadUrl?: string | undefined;
      heroProcessing: boolean;
      companyName?: string | undefined;
      title?: string | undefined;
      description?: string | undefined;
      email?: string | undefined;
      phoneNumber?: string | undefined;
      marketingWebsiteUrl?: string | undefined;
      homeownerMarketingUrl?: string | undefined;
      twitterUrl?: string | undefined;
      instagramUrl?: string | undefined;
      twitterHandle?: string | undefined;
      instagramUsername?: string | undefined;
      facebookPageUrl?: string | undefined;
      activeListingsCount: number;
      inBusinessSince?: number | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      youtubeUrl?: string | undefined;
      linkedinUrl?: string | undefined;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      accountReviewSummaries: Array<{
        id: string;
        source: AccountReviewSummarySource;
        sourceId: string;
        numberOfReviews?: number | undefined;
        imageUrl?: string | undefined;
        rating: number;
      }>;
    }>;
    meta: {
      nextPage?: number | undefined;
      previousPage?: number | undefined;
      currentPage?: number | undefined;
      totalEntries?: number | undefined;
      totalPages?: number | undefined;
    };
  };
};

export type AccountByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type AccountByIdQuery = {
  accountById:
    | {
        __typename: 'Account';
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        avatarFileName?: string | undefined;
        avatarUploadUrl?: string | undefined;
        avatarProcessing: boolean;
        companyName?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        heroFileName?: string | undefined;
        heroUploadUrl?: string | undefined;
        heroUrl?: string | undefined;
        heroProcessing: boolean;
        title?: string | undefined;
        description?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        marketingWebsiteUrl?: string | undefined;
        homeownerMarketingUrl?: string | undefined;
        twitterUrl?: string | undefined;
        instagramUrl?: string | undefined;
        twitterHandle?: string | undefined;
        instagramUsername?: string | undefined;
        facebookPageUrl?: string | undefined;
        inBusinessSince?: number | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        linkedinUrl?: string | undefined;
        city?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        accountReviewSummaries: Array<{
          id: string;
          source: AccountReviewSummarySource;
          sourceId: string;
          numberOfReviews?: number | undefined;
          imageUrl?: string | undefined;
          rating: number;
        }>;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type AccountBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type AccountBySlugQuery = {
  accountBySlug:
    | {
        __typename: 'Account';
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        avatarFileName?: string | undefined;
        avatarUploadUrl?: string | undefined;
        avatarProcessing: boolean;
        companyName?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        heroFileName?: string | undefined;
        heroUploadUrl?: string | undefined;
        heroUrl?: string | undefined;
        heroProcessing: boolean;
        title?: string | undefined;
        description?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        marketingWebsiteUrl?: string | undefined;
        homeownerMarketingUrl?: string | undefined;
        twitterUrl?: string | undefined;
        instagramUrl?: string | undefined;
        twitterHandle?: string | undefined;
        instagramUsername?: string | undefined;
        facebookPageUrl?: string | undefined;
        inBusinessSince?: number | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        linkedinUrl?: string | undefined;
        city?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        accountReviewSummaries: Array<{
          id: string;
          source: AccountReviewSummarySource;
          sourceId: string;
          numberOfReviews?: number | undefined;
          imageUrl?: string | undefined;
          rating: number;
        }>;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type AccountForCurrentUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountForCurrentUserQuery = {
  accountForCurrentUser:
    | {
        __typename: 'Account';
        onboardingCompletedAt?: string | undefined;
        pmsSoftware?: string | undefined;
        reportedPmsSoftware?: string | undefined;
        isPpr: boolean;
        creditCardOnFile: boolean;
        defaultListingLevel: SubscriptionType;
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        avatarFileName?: string | undefined;
        avatarUploadUrl?: string | undefined;
        avatarProcessing: boolean;
        companyName?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        heroFileName?: string | undefined;
        heroUploadUrl?: string | undefined;
        heroUrl?: string | undefined;
        heroProcessing: boolean;
        title?: string | undefined;
        description?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        marketingWebsiteUrl?: string | undefined;
        homeownerMarketingUrl?: string | undefined;
        twitterUrl?: string | undefined;
        instagramUrl?: string | undefined;
        twitterHandle?: string | undefined;
        instagramUsername?: string | undefined;
        facebookPageUrl?: string | undefined;
        inBusinessSince?: number | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        linkedinUrl?: string | undefined;
        city?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        latestTask?:
          | {
              id: string;
              status: TaskStatus;
              startedAt: string;
              completedAt?: string | undefined;
              importCount?: number | undefined;
              importSuccessCount?: number | undefined;
            }
          | undefined;
        pmOnboardingSession?:
          | {
              id: string;
              accountId?: string | undefined;
              userId?: string | undefined;
              pmsType?: string | undefined;
              currentStepKey: PmOnboardingStepKey;
              status: PmOnboardingSessionStatus;
              reviewReason?: PmOnboardingReviewReason | undefined;
              publishedAt?: string | undefined;
              startedAt: string;
              completedAt?: string | undefined;
              lastActivityAt: string;
              currentStepIndex: number;
              totalSteps: number;
              completedStepKeys: Array<PmOnboardingStepKey>;
              canAdvance: boolean;
              flow: {
                id: string;
                version: string;
                name: string;
                description?: string | undefined;
                isActive: boolean;
                totalSteps: number;
                steps: Array<{
                  stepKey: PmOnboardingStepKey;
                  position: number;
                  label: string;
                  required: boolean;
                }>;
              };
              stepCompletions: Array<{
                stepKey: PmOnboardingStepKey;
                completedAt: string;
              }>;
              account?:
                | {
                    id: string;
                    isUsBased?: boolean | undefined;
                    countryOrRegionLongName?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        accountReviewSummaries: Array<{
          id: string;
          source: AccountReviewSummarySource;
          sourceId: string;
          numberOfReviews?: number | undefined;
          imageUrl?: string | undefined;
          rating: number;
        }>;
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type AccountsListAllActiveQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  stateOrProvinceLongNameFilter?: InputMaybe<Scalars['String']['input']>;
}>;

export type AccountsListAllActiveQuery = {
  accountsListAllActive: {
    __typename: 'AccountCollection';
    entries: Array<{
      id: string;
      slug: string;
      avatarUrl?: string | undefined;
      avatarProcessing: boolean;
      heroUploadUrl?: string | undefined;
      heroProcessing: boolean;
      companyName?: string | undefined;
      title?: string | undefined;
      description?: string | undefined;
      email?: string | undefined;
      phoneNumber?: string | undefined;
      marketingWebsiteUrl?: string | undefined;
      homeownerMarketingUrl?: string | undefined;
      twitterUrl?: string | undefined;
      instagramUrl?: string | undefined;
      twitterHandle?: string | undefined;
      instagramUsername?: string | undefined;
      facebookPageUrl?: string | undefined;
      activeListingsCount: number;
      inBusinessSince?: number | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      youtubeUrl?: string | undefined;
      linkedinUrl?: string | undefined;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      accountReviewSummaries: Array<{
        id: string;
        source: AccountReviewSummarySource;
        sourceId: string;
        numberOfReviews?: number | undefined;
        imageUrl?: string | undefined;
        rating: number;
      }>;
    }>;
    meta: {
      nextPage?: number | undefined;
      previousPage?: number | undefined;
      currentPage?: number | undefined;
      totalEntries?: number | undefined;
      totalPages?: number | undefined;
    };
  };
};

export type AffiliationFindOrCreateMutationVariables = Exact<{
  input: AffiliationFindOrCreateInput;
}>;

export type AffiliationFindOrCreateMutation = {
  affiliationFindOrCreate:
    | {
        __typename: 'Affiliation';
        id: string;
        name: string;
        type: AffiliationType;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type AffiliationDeleteMutationVariables = Exact<{
  input: AffiliationDeleteInput;
}>;

export type AffiliationDeleteMutation = {
  affiliationDelete:
    | {
        __typename: 'Affiliation';
        id: string;
        name: string;
        type: AffiliationType;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type AffiliationSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type?: InputMaybe<AffiliationTypeFilter>;
  listingId: Scalars['ID']['input'];
}>;

export type AffiliationSearchQuery = {
  affiliationSearch:
    | {
        __typename: 'AffiliationCollection';
        entries: Array<{ id: string; name: string; type: AffiliationType }>;
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type BlogPostsListAllFeaturedQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BlogPostsListAllFeaturedQuery = {
  blogPostsListAllFeatured: Array<{
    id: string;
    title: string;
    publishedAt: string;
    url: string;
    imageUrl: string;
  }>;
};

export type BookingQuoteByListingAndDatesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  adultCount: Scalars['Int']['input'];
  childCount: Scalars['Int']['input'];
  infantCount: Scalars['Int']['input'];
  petCount: Scalars['Int']['input'];
}>;

export type BookingQuoteByListingAndDatesQuery = {
  bookingQuoteByListingAndDates:
    | {
        __typename: 'BookingQuote';
        id: string;
        listingId?: string | undefined;
        totalCostCents?: number | undefined;
        totalRecoverableCostCents?: number | undefined;
        totalWithoutTaxesCents?: number | undefined;
        checkInDate?: string | undefined;
        checkOutDate?: string | undefined;
        iframeBookingUrl?: string | undefined;
        listing: {
          priceDisplay?:
            | {
                subtotalWithoutTaxesCents?: number | undefined;
                baseAmountCents: number;
                nights: number;
              }
            | undefined;
        };
        quoteItems: Array<{
          costCents: number;
          type: QuoteItemizedType;
          description: string;
        }>;
        paymentSchedule: Array<{
          dueDate: string;
          amountCents: number;
          description?: string | undefined;
          paymentItemType: PaymentItemType;
        }>;
      }
    | { __typename: 'BookingQuoteUnavailable'; message: string }
    | { __typename: 'BookingQuoteUnsupported' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'ServiceUnavailableError'; message: string }
    | { __typename: 'ValidationError'; message: string };
};

export type SetAccountCardMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type SetAccountCardMutation = {
  setAccountCard:
    | {
        __typename: 'Card';
        brand: string;
        addressZip?: string | undefined;
        last4: string;
        expMonth: number;
        expYear: number;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'ServiceUnavailableError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | { __typename: 'UnauthorizedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type CardsListAllQueryVariables = Exact<{ [key: string]: never }>;

export type CardsListAllQuery = {
  cardsListAll:
    | {
        __typename: 'CardCollection';
        entries: Array<{
          brand: string;
          addressZip?: string | undefined;
          last4: string;
          expMonth: number;
          expYear: number;
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'ServiceUnavailableError' }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type AccountCardsListAllQueryVariables = Exact<{ [key: string]: never }>;

export type AccountCardsListAllQuery = {
  accountCardsListAll:
    | {
        __typename: 'CardCollection';
        entries: Array<{
          brand: string;
          addressZip?: string | undefined;
          last4: string;
          expMonth: number;
          expYear: number;
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'ServiceUnavailableError' }
    | { __typename: 'UnauthenticatedError'; message: string }
    | { __typename: 'UnauthorizedError'; message: string };
};

export type ReservationCommissionSummaryForAccountQueryVariables = Exact<{
  billingMonth: Scalars['String']['input'];
}>;

export type ReservationCommissionSummaryForAccountQuery = {
  reservationCommissionSummaryForAccount:
    | {
        __typename: 'ReservationCommissionSummary';
        billingMonth: string;
        periodStart: string;
        periodEnd: string;
        bookingCount: number;
        commissionableBookingValueCents: number;
        grossCommissionCents: number;
        adjustmentCents: number;
        statementAvailable: boolean;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type ReservationCommissionStatementForAccountQueryVariables = Exact<{
  billingMonth: Scalars['String']['input'];
}>;

export type ReservationCommissionStatementForAccountQuery = {
  reservationCommissionStatementForAccount:
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'ReservationCommissionStatement'; url: string }
    | { __typename: 'ServiceUnavailableError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type ReservationCommissionActivityExportForAccountQueryVariables =
  Exact<{
    billingMonth: Scalars['String']['input'];
    kind?: InputMaybe<ReservationCommissionKind>;
    status?: InputMaybe<ReservationCommissionStatuses>;
    search?: InputMaybe<Scalars['String']['input']>;
  }>;

export type ReservationCommissionActivityExportForAccountQuery = {
  reservationCommissionActivityExportForAccount:
    | {
        __typename: 'ReservationCommissionActivityExport';
        filename: string;
        content: string;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type ReservationCommissionListAllForAccountQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  billingMonth?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ReservationCommissionKind>;
  status?: InputMaybe<ReservationCommissionStatuses>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReservationCommissionListAllForAccountQuery = {
  reservationCommissionListAllForAccount:
    | {
        __typename: 'ReservationCommissionCollection';
        totalCommissionCents: number;
        entries: Array<{
          id: string;
          kind: ReservationCommissionKind;
          status: ReservationCommissionStatuses;
          commissionCents: number;
          commissionRate: string;
          confirmedAt?: string | undefined;
          createdAt: string;
          reservation: {
            id: string;
            status: ReservationStatuses;
            externalReservationId?: string | undefined;
            travelerFirstName?: string | undefined;
            travelerLastName?: string | undefined;
            startDate: string;
            endDate: string;
            totalCostCents?: number | undefined;
            listing: {
              id: string;
              name?: string | undefined;
              city?: string | undefined;
              stateOrProvinceLongName?: string | undefined;
            };
          };
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type ComparisonQuoteByListingAndDatesQueryVariables = Exact<{
  quoteId: Scalars['ID']['input'];
  checkInDate: Scalars['Date']['input'];
  checkOutDate: Scalars['Date']['input'];
  externalListingUrl: Scalars['String']['input'];
  numberOfAdults: Scalars['Int']['input'];
  numberOfChildren?: InputMaybe<Scalars['Int']['input']>;
  numberOfInfants?: InputMaybe<Scalars['Int']['input']>;
  numberOfPets?: InputMaybe<Scalars['Int']['input']>;
  priceType: PriceType;
}>;

export type ComparisonQuoteByListingAndDatesQuery = {
  comparisonQuoteByListingAndDates:
    | {
        __typename: 'ComparisonQuote';
        checkInDate: string;
        checkOutDate: string;
        externalListingId: string;
        externalSource: string;
        numberOfAdults: number;
        numberOfChildren: number;
        numberOfInfants: number;
        numberOfPets: number;
        priceCents: number;
      }
    | { __typename: 'ComparisonQuoteUnsupported' }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnprocessableContentError'; message: string }
    | { __typename: 'ValidationError'; message: string };
};

export type CouponFindAvailableForAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CouponFindAvailableForAccountQuery = {
  couponFindAvailableForAccount:
    | {
        __typename: 'Coupon';
        amountOffCents?: number | undefined;
        applicableSubscriptions?:
          | Array<SubscriptionType | undefined>
          | undefined;
        endDate?: string | undefined;
        name: string;
        percentOff?: number | undefined;
        promoCode?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError' };
};

export type CouponFindByPromoCodeQueryVariables = Exact<{
  promoCode: Scalars['String']['input'];
}>;

export type CouponFindByPromoCodeQuery = {
  couponFindByPromoCode:
    | {
        __typename: 'Coupon';
        amountOffCents?: number | undefined;
        applicableSubscriptions?:
          | Array<SubscriptionType | undefined>
          | undefined;
        endDate?: string | undefined;
        name: string;
        percentOff?: number | undefined;
        promoCode?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type CouponFindForAccountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CouponFindForAccountQuery = {
  couponFindForAccount:
    | {
        __typename: 'Coupon';
        amountOffCents?: number | undefined;
        applicableSubscriptions?:
          | Array<SubscriptionType | undefined>
          | undefined;
        endDate?: string | undefined;
        name: string;
        percentOff?: number | undefined;
        promoCode?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type EmailVerificationUpdateMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type EmailVerificationUpdateMutation = {
  emailVerificationUpdate:
    | { __typename: 'EmailVerificationMessage'; message: string }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type FeaturesListAllQueryVariables = Exact<{
  propertyType?: InputMaybe<PropertyType>;
}>;

export type FeaturesListAllQuery = {
  featuresListAll: Array<{
    key: FeatureKey;
    displayName: string;
    categoryName: string;
    promoted: boolean;
  }>;
};

export type FeaturesListAllForSearchFiltersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FeaturesListAllForSearchFiltersQuery = {
  featuresListAllForSearchFilters: Array<{
    categoryName: string;
    displayName: string;
    key: FeatureKey;
    promoted: boolean;
  }>;
};

export type GalleryAssetCreateMutationVariables = Exact<{
  input: GalleryAssetCreateInput;
}>;

export type GalleryAssetCreateMutation = {
  galleryAssetCreate:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type GalleryAssetDeleteMutationVariables = Exact<{
  input: GalleryAssetDeleteInput;
}>;

export type GalleryAssetDeleteMutation = {
  galleryAssetDelete:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type GalleryAssetOrderMutationVariables = Exact<{
  input: GalleryAssetOrderInput;
}>;

export type GalleryAssetOrderMutation = {
  galleryAssetOrder:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type GalleryAssetUpdateImageMutationVariables = Exact<{
  input: GalleryAssetUpdateImageInput;
}>;

export type GalleryAssetUpdateImageMutation = {
  galleryAssetUpdateImage:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type GalleryAssetUpdateMutationVariables = Exact<{
  input: GalleryAssetUpdateInput;
}>;

export type GalleryAssetUpdateMutation = {
  galleryAssetUpdate:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type GalleryAssetByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GalleryAssetByIdQuery = {
  galleryAssetById:
    | {
        __typename: 'GalleryAsset';
        id: string;
        description?: string | undefined;
        processing: boolean;
        rawUrl?: string | undefined;
        position: number;
        url?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type IdentityVerificationCreateMutationVariables = Exact<{
  [key: string]: never;
}>;

export type IdentityVerificationCreateMutation = {
  identityVerificationCreate:
    | {
        __typename: 'IdentityVerificationInquiryResult';
        personaInquiryId: string;
        sessionToken?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type TravelerIdentityVerificationCreateMutationVariables = Exact<{
  [key: string]: never;
}>;

export type TravelerIdentityVerificationCreateMutation = {
  travelerIdentityVerificationCreate:
    | {
        __typename: 'TravelerIdentityVerificationInquiryResult';
        personaInquiryId: string;
        sessionToken?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type TravelerVerificationStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TravelerVerificationStatusQuery = {
  currentUser:
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'User';
        id: string;
        travelerVerificationStatus?: VerificationStatus | undefined;
      };
};

export type CurrentInnkeeperQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentInnkeeperQuery = {
  currentInnkeeper:
    | {
        __typename: 'Innkeeper';
        id: string;
        accessToken?: string | undefined;
        claimable: boolean;
        email: string;
        firstName?: string | undefined;
        identityVerified: boolean;
        lastName?: string | undefined;
        phoneNumber?: string | undefined;
        referredByUserId?: string | undefined;
        registeredAt?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type CreateLeadMutationVariables = Exact<{
  input: CreateLeadInput;
}>;

export type CreateLeadMutation = {
  createLead:
    | { __typename: 'LeadCreatedMessage'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingBookingInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type ListingBookingInfoQuery = {
  listingBookingInfo:
    | {
        __typename: 'ListingBookingInfo';
        availabilityDates: Array<{
          date: string;
          available: boolean;
          checkInAllowed: boolean;
          checkOutAllowed: boolean;
          minNights?: number | undefined;
          maxNights?: number | undefined;
        }>;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type ListingReviewSummariesListAllForListingQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ListingReviewSummariesListAllForListingQuery = {
  listingReviewSummariesListAllForListing:
    | {
        __typename: 'ListingReviewSummaryCollection';
        entries: Array<{
          source: ListingReviewSummarySource;
          averageRating?: number | undefined;
          count?: number | undefined;
        }>;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type ListingReviewsListAllForListingQueryVariables = Exact<{
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListingReviewSortOptions>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListingReviewsListAllForListingQuery = {
  listingReviewsListAllForListing:
    | {
        __typename: 'ListingReviewCollection';
        entries: Array<{
          id: string;
          rating?: number | undefined;
          body?: string | undefined;
          authorName?: string | undefined;
          date?: string | undefined;
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
        };
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type ListingFieldsFragment = {
  id: string;
  addressLineOne?: string | undefined;
  addressLineTwo?: string | undefined;
  cancellationPolicy?: string | undefined;
  checkIn?: SupportedCheckInAndOutTimes | undefined;
  checkout?: SupportedCheckInAndOutTimes | undefined;
  numberOfFloors?: number | undefined;
  listedFloor?: number | undefined;
  numberOfRooms?: number | undefined;
  numberOfBathrooms?: number | undefined;
  guestCapacity?: number | undefined;
  propertyType?: PropertyType | undefined;
  uniquePropertyType?: UniquePropertyType | undefined;
  hostImageProcessing: boolean;
  bookDirectWebsiteUrl?: string | undefined;
  city?: string | undefined;
  countryOrRegionLongName?: string | undefined;
  currentBalanceCents: number;
  description?: string | undefined;
  facebookPageUrl?: string | undefined;
  hostBio?: string | undefined;
  hostDisplayName?: string | undefined;
  hostImageUrl?: string | undefined;
  instagramUrl?: string | undefined;
  instagramUsername?: string | undefined;
  isFavorited: boolean;
  firstPublishedAt?: string | undefined;
  lastPublishedAt?: string | undefined;
  unpublishedAt?: string | undefined;
  lat?: number | undefined;
  lng?: number | undefined;
  licenseNumber?: string | undefined;
  locationObfuscated: boolean;
  locationSetManually: boolean;
  marketingWebsiteUrl?: string | undefined;
  name?: string | undefined;
  pinterestUrl?: string | undefined;
  pinterestUsername?: string | undefined;
  placeId?: string | undefined;
  placeName?: string | undefined;
  postalCode?: string | undefined;
  publicEmail?: string | undefined;
  youtubeUrl?: string | undefined;
  wNineOnFile: boolean;
  twitterUrl?: string | undefined;
  twitterHandle?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  slug: string;
  minPrice?: number | undefined;
  maxPrice?: number | undefined;
  published: boolean;
  publishIpAddress?: string | undefined;
  publicPhoneNumber?: string | undefined;
  listingLevel: SubscriptionType;
  isDiamondCollection: boolean;
  featuredByOwner: boolean;
  account: {
    id: string;
    slug: string;
    avatarUrl?: string | undefined;
    companyName?: string | undefined;
  };
  affiliations: Array<{ id: string; name: string; type: AffiliationType }>;
  features: Array<{
    categoryName: string;
    displayName: string;
    key: FeatureKey;
    legacyKey: string;
    promoted: boolean;
  }>;
  galleryAssets: Array<{
    description?: string | undefined;
    id: string;
    processing: boolean;
    rawUrl?: string | undefined;
    position: number;
    url?: string | undefined;
  }>;
};

export type OwnerListingFieldsFragment = {
  id: string;
  preciseAddressLineOne?: string | undefined;
  preciseAddressLineTwo?: string | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  city?: string | undefined;
  checkIn?: SupportedCheckInAndOutTimes | undefined;
  checkout?: SupportedCheckInAndOutTimes | undefined;
  cancellationPolicy?: string | undefined;
  termsAndConditionsLink?: string | undefined;
  numberOfFloors?: number | undefined;
  licenseNumber?: string | undefined;
  listedFloor?: number | undefined;
  numberOfRooms?: number | undefined;
  numberOfBathrooms?: number | undefined;
  guestCapacity?: number | undefined;
  countryOrRegionLongName?: string | undefined;
  description?: string | undefined;
  facebookPageUrl?: string | undefined;
  propertyType?: PropertyType | undefined;
  uniquePropertyType?: UniquePropertyType | undefined;
  hostBio?: string | undefined;
  hostDisplayName?: string | undefined;
  hostImageProcessing: boolean;
  hostImageUrl?: string | undefined;
  instagramUrl?: string | undefined;
  preciseLat?: number | undefined;
  preciseLng?: number | undefined;
  locationObfuscated: boolean;
  marketingWebsiteUrl?: string | undefined;
  instagramUsername?: string | undefined;
  pinterestUsername?: string | undefined;
  name?: string | undefined;
  published: boolean;
  pinterestUrl?: string | undefined;
  postalCode?: string | undefined;
  publicEmail?: string | undefined;
  publicPhoneNumber?: string | undefined;
  slug: string;
  stateOrProvinceLongName?: string | undefined;
  twitterUrl?: string | undefined;
  twitterHandle?: string | undefined;
  youtubeUrl?: string | undefined;
  minPrice?: number | undefined;
  maxPrice?: number | undefined;
  listingLevel: SubscriptionType;
  isDiamondCollection: boolean;
  featuredByOwner: boolean;
  galleryAssets: Array<{
    id: string;
    url?: string | undefined;
    rawUrl?: string | undefined;
    description?: string | undefined;
    processing: boolean;
    position: number;
  }>;
  features: Array<{
    key: FeatureKey;
    legacyKey: string;
    displayName: string;
    promoted: boolean;
    categoryName: string;
  }>;
  affiliations: Array<{ id: string; type: AffiliationType; name: string }>;
  account: {
    id: string;
    slug: string;
    companyName?: string | undefined;
    avatarUrl?: string | undefined;
    owner: { id: string };
    availableCoupon?:
      | {
          percentOff?: number | undefined;
          applicableSubscriptions?:
            | Array<SubscriptionType | undefined>
            | undefined;
        }
      | undefined;
  };
  policies: Array<
    | { type: PolicyType; cancellationPolicy: string }
    | { type: PolicyType; termsLink?: string | undefined }
    | { type: PolicyType; cancellationPolicy: string }
    | Record<PropertyKey, never>
  >;
};

export type ListingUpdateMutationVariables = Exact<{
  input: ListingUpdateInput;
}>;

export type ListingUpdateMutation = {
  listingUpdate:
    | {
        __typename: 'Listing';
        id: string;
        preciseAddressLineOne?: string | undefined;
        preciseAddressLineTwo?: string | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        cancellationPolicy?: string | undefined;
        termsAndConditionsLink?: string | undefined;
        numberOfFloors?: number | undefined;
        licenseNumber?: string | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        countryOrRegionLongName?: string | undefined;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageProcessing: boolean;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        preciseLat?: number | undefined;
        preciseLng?: number | undefined;
        locationObfuscated: boolean;
        marketingWebsiteUrl?: string | undefined;
        instagramUsername?: string | undefined;
        pinterestUsername?: string | undefined;
        name?: string | undefined;
        published: boolean;
        pinterestUrl?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        publicPhoneNumber?: string | undefined;
        slug: string;
        stateOrProvinceLongName?: string | undefined;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        youtubeUrl?: string | undefined;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        galleryAssets: Array<{
          id: string;
          url?: string | undefined;
          rawUrl?: string | undefined;
          description?: string | undefined;
          processing: boolean;
          position: number;
        }>;
        features: Array<{
          key: FeatureKey;
          legacyKey: string;
          displayName: string;
          promoted: boolean;
          categoryName: string;
        }>;
        affiliations: Array<{
          id: string;
          type: AffiliationType;
          name: string;
        }>;
        account: {
          id: string;
          slug: string;
          companyName?: string | undefined;
          avatarUrl?: string | undefined;
          owner: { id: string };
          availableCoupon?:
            | {
                percentOff?: number | undefined;
                applicableSubscriptions?:
                  | Array<SubscriptionType | undefined>
                  | undefined;
              }
            | undefined;
        };
        policies: Array<
          | { type: PolicyType; cancellationPolicy: string }
          | { type: PolicyType; termsLink?: string | undefined }
          | { type: PolicyType; cancellationPolicy: string }
          | Record<PropertyKey, never>
        >;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingPublishMutationVariables = Exact<{
  input: ListingPublishInput;
}>;

export type ListingPublishMutation = {
  listingPublish:
    | {
        __typename: 'Listing';
        id: string;
        preciseAddressLineOne?: string | undefined;
        preciseAddressLineTwo?: string | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        cancellationPolicy?: string | undefined;
        termsAndConditionsLink?: string | undefined;
        numberOfFloors?: number | undefined;
        licenseNumber?: string | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        countryOrRegionLongName?: string | undefined;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageProcessing: boolean;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        preciseLat?: number | undefined;
        preciseLng?: number | undefined;
        locationObfuscated: boolean;
        marketingWebsiteUrl?: string | undefined;
        instagramUsername?: string | undefined;
        pinterestUsername?: string | undefined;
        name?: string | undefined;
        published: boolean;
        pinterestUrl?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        publicPhoneNumber?: string | undefined;
        slug: string;
        stateOrProvinceLongName?: string | undefined;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        youtubeUrl?: string | undefined;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        galleryAssets: Array<{
          id: string;
          url?: string | undefined;
          rawUrl?: string | undefined;
          description?: string | undefined;
          processing: boolean;
          position: number;
        }>;
        features: Array<{
          key: FeatureKey;
          legacyKey: string;
          displayName: string;
          promoted: boolean;
          categoryName: string;
        }>;
        affiliations: Array<{
          id: string;
          type: AffiliationType;
          name: string;
        }>;
        account: {
          id: string;
          slug: string;
          companyName?: string | undefined;
          avatarUrl?: string | undefined;
          owner: { id: string };
          availableCoupon?:
            | {
                percentOff?: number | undefined;
                applicableSubscriptions?:
                  | Array<SubscriptionType | undefined>
                  | undefined;
              }
            | undefined;
        };
        policies: Array<
          | { type: PolicyType; cancellationPolicy: string }
          | { type: PolicyType; termsLink?: string | undefined }
          | { type: PolicyType; cancellationPolicy: string }
          | Record<PropertyKey, never>
        >;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingUnpublishMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;

export type ListingUnpublishMutation = {
  listingUnpublish:
    | {
        __typename: 'Listing';
        id: string;
        preciseAddressLineOne?: string | undefined;
        preciseAddressLineTwo?: string | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        cancellationPolicy?: string | undefined;
        termsAndConditionsLink?: string | undefined;
        numberOfFloors?: number | undefined;
        licenseNumber?: string | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        countryOrRegionLongName?: string | undefined;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageProcessing: boolean;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        preciseLat?: number | undefined;
        preciseLng?: number | undefined;
        locationObfuscated: boolean;
        marketingWebsiteUrl?: string | undefined;
        instagramUsername?: string | undefined;
        pinterestUsername?: string | undefined;
        name?: string | undefined;
        published: boolean;
        pinterestUrl?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        publicPhoneNumber?: string | undefined;
        slug: string;
        stateOrProvinceLongName?: string | undefined;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        youtubeUrl?: string | undefined;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        galleryAssets: Array<{
          id: string;
          url?: string | undefined;
          rawUrl?: string | undefined;
          description?: string | undefined;
          processing: boolean;
          position: number;
        }>;
        features: Array<{
          key: FeatureKey;
          legacyKey: string;
          displayName: string;
          promoted: boolean;
          categoryName: string;
        }>;
        affiliations: Array<{
          id: string;
          type: AffiliationType;
          name: string;
        }>;
        account: {
          id: string;
          slug: string;
          companyName?: string | undefined;
          avatarUrl?: string | undefined;
          owner: { id: string };
          availableCoupon?:
            | {
                percentOff?: number | undefined;
                applicableSubscriptions?:
                  | Array<SubscriptionType | undefined>
                  | undefined;
              }
            | undefined;
        };
        policies: Array<
          | { type: PolicyType; cancellationPolicy: string }
          | { type: PolicyType; termsLink?: string | undefined }
          | { type: PolicyType; cancellationPolicy: string }
          | Record<PropertyKey, never>
        >;
      }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthenticatedError'; message: string }
    | { __typename: 'ValidationErrorCollection' };
};

export type SetSubscriptionMutationVariables = Exact<{
  input: SetSubscriptionInput;
}>;

export type SetSubscriptionMutation = {
  setSubscription:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        cancellationPolicy?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        numberOfFloors?: number | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostImageProcessing: boolean;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        currentBalanceCents: number;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        instagramUsername?: string | undefined;
        isFavorited: boolean;
        firstPublishedAt?: string | undefined;
        lastPublishedAt?: string | undefined;
        unpublishedAt?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        licenseNumber?: string | undefined;
        locationObfuscated: boolean;
        locationSetManually: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        pinterestUrl?: string | undefined;
        pinterestUsername?: string | undefined;
        placeId?: string | undefined;
        placeName?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        youtubeUrl?: string | undefined;
        wNineOnFile: boolean;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        slug: string;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        published: boolean;
        publishIpAddress?: string | undefined;
        publicPhoneNumber?: string | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        account: {
          id: string;
          slug: string;
          avatarUrl?: string | undefined;
          companyName?: string | undefined;
        };
        affiliations: Array<{
          id: string;
          name: string;
          type: AffiliationType;
        }>;
        features: Array<{
          categoryName: string;
          displayName: string;
          key: FeatureKey;
          legacyKey: string;
          promoted: boolean;
        }>;
        galleryAssets: Array<{
          description?: string | undefined;
          id: string;
          processing: boolean;
          rawUrl?: string | undefined;
          position: number;
          url?: string | undefined;
        }>;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingCreateMutationVariables = Exact<{
  input: ListingCreateInput;
}>;

export type ListingCreateMutation = {
  listingCreate:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        cancellationPolicy?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        numberOfFloors?: number | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostImageProcessing: boolean;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        currentBalanceCents: number;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        instagramUsername?: string | undefined;
        isFavorited: boolean;
        firstPublishedAt?: string | undefined;
        lastPublishedAt?: string | undefined;
        unpublishedAt?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        licenseNumber?: string | undefined;
        locationObfuscated: boolean;
        locationSetManually: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        pinterestUrl?: string | undefined;
        pinterestUsername?: string | undefined;
        placeId?: string | undefined;
        placeName?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        youtubeUrl?: string | undefined;
        wNineOnFile: boolean;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        slug: string;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        published: boolean;
        publishIpAddress?: string | undefined;
        publicPhoneNumber?: string | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        account: {
          id: string;
          slug: string;
          avatarUrl?: string | undefined;
          companyName?: string | undefined;
        };
        affiliations: Array<{
          id: string;
          name: string;
          type: AffiliationType;
        }>;
        features: Array<{
          categoryName: string;
          displayName: string;
          key: FeatureKey;
          legacyKey: string;
          promoted: boolean;
        }>;
        galleryAssets: Array<{
          description?: string | undefined;
          id: string;
          processing: boolean;
          rawUrl?: string | undefined;
          position: number;
          url?: string | undefined;
        }>;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingFavoriteCreateMutationVariables = Exact<{
  input: ListingFavoriteCreateInput;
}>;

export type ListingFavoriteCreateMutation = {
  listingFavoriteCreate:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        cancellationPolicy?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        numberOfFloors?: number | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostImageProcessing: boolean;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        currentBalanceCents: number;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        instagramUsername?: string | undefined;
        isFavorited: boolean;
        firstPublishedAt?: string | undefined;
        lastPublishedAt?: string | undefined;
        unpublishedAt?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        licenseNumber?: string | undefined;
        locationObfuscated: boolean;
        locationSetManually: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        pinterestUrl?: string | undefined;
        pinterestUsername?: string | undefined;
        placeId?: string | undefined;
        placeName?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        youtubeUrl?: string | undefined;
        wNineOnFile: boolean;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        slug: string;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        published: boolean;
        publishIpAddress?: string | undefined;
        publicPhoneNumber?: string | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        account: {
          id: string;
          slug: string;
          avatarUrl?: string | undefined;
          companyName?: string | undefined;
        };
        affiliations: Array<{
          id: string;
          name: string;
          type: AffiliationType;
        }>;
        features: Array<{
          categoryName: string;
          displayName: string;
          key: FeatureKey;
          legacyKey: string;
          promoted: boolean;
        }>;
        galleryAssets: Array<{
          description?: string | undefined;
          id: string;
          processing: boolean;
          rawUrl?: string | undefined;
          position: number;
          url?: string | undefined;
        }>;
      }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type ListingFavoriteDeleteMutationVariables = Exact<{
  input: ListingFavoriteDeleteInput;
}>;

export type ListingFavoriteDeleteMutation = {
  listingFavoriteDelete:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        cancellationPolicy?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        numberOfFloors?: number | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostImageProcessing: boolean;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        currentBalanceCents: number;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        instagramUsername?: string | undefined;
        isFavorited: boolean;
        firstPublishedAt?: string | undefined;
        lastPublishedAt?: string | undefined;
        unpublishedAt?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        licenseNumber?: string | undefined;
        locationObfuscated: boolean;
        locationSetManually: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        pinterestUrl?: string | undefined;
        pinterestUsername?: string | undefined;
        placeId?: string | undefined;
        placeName?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        youtubeUrl?: string | undefined;
        wNineOnFile: boolean;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        slug: string;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        published: boolean;
        publishIpAddress?: string | undefined;
        publicPhoneNumber?: string | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        account: {
          id: string;
          slug: string;
          avatarUrl?: string | undefined;
          companyName?: string | undefined;
        };
        affiliations: Array<{
          id: string;
          name: string;
          type: AffiliationType;
        }>;
        features: Array<{
          categoryName: string;
          displayName: string;
          key: FeatureKey;
          legacyKey: string;
          promoted: boolean;
        }>;
        galleryAssets: Array<{
          description?: string | undefined;
          id: string;
          processing: boolean;
          rawUrl?: string | undefined;
          position: number;
          url?: string | undefined;
        }>;
      }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthenticatedError'; message: string }
    | { __typename: 'ValidationErrorCollection' };
};

export type ListingToggleFeaturedByOwnerMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;

export type ListingToggleFeaturedByOwnerMutation = {
  listingToggleFeaturedByOwner:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        cancellationPolicy?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        numberOfFloors?: number | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostImageProcessing: boolean;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        currentBalanceCents: number;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        instagramUsername?: string | undefined;
        isFavorited: boolean;
        firstPublishedAt?: string | undefined;
        lastPublishedAt?: string | undefined;
        unpublishedAt?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        licenseNumber?: string | undefined;
        locationObfuscated: boolean;
        locationSetManually: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        pinterestUrl?: string | undefined;
        pinterestUsername?: string | undefined;
        placeId?: string | undefined;
        placeName?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        youtubeUrl?: string | undefined;
        wNineOnFile: boolean;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        slug: string;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        published: boolean;
        publishIpAddress?: string | undefined;
        publicPhoneNumber?: string | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        account: {
          id: string;
          slug: string;
          avatarUrl?: string | undefined;
          companyName?: string | undefined;
        };
        affiliations: Array<{
          id: string;
          name: string;
          type: AffiliationType;
        }>;
        features: Array<{
          categoryName: string;
          displayName: string;
          key: FeatureKey;
          legacyKey: string;
          promoted: boolean;
        }>;
        galleryAssets: Array<{
          description?: string | undefined;
          id: string;
          processing: boolean;
          rawUrl?: string | undefined;
          position: number;
          url?: string | undefined;
        }>;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type AccountCollectionListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  accountId: Scalars['String']['input'];
  applyFeaturedByOwnerFilter?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ListingSortOptions>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  featuresFilter?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
}>;

export type AccountCollectionListingsListAllQuery = {
  listingsListAllActive: {
    entries: Array<{
      checkIn?: SupportedCheckInAndOutTimes | undefined;
      checkout?: SupportedCheckInAndOutTimes | undefined;
      cancellationPolicy?: string | undefined;
      city?: string | undefined;
      licenseNumber?: string | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      guestCapacity?: number | undefined;
      name?: string | undefined;
      slug: string;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      stateOrProvinceLongName?: string | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      listingLevel: SubscriptionType;
      isDiamondCollection: boolean;
      isFavorited: boolean;
      id: string;
      searchableAvailability: boolean;
      featuredByOwner: boolean;
      galleryAssets: Array<{ id: string; url?: string | undefined }>;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        companyName?: string | undefined;
        avatarUrl?: string | undefined;
      };
    }>;
    meta: {
      totalEntries?: number | undefined;
      totalPages?: number | undefined;
      nextPage?: number | undefined;
      previousPage?: number | undefined;
    };
  };
};

export type AccountActiveListingsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AccountActiveListingsQuery = {
  listingsListAllActive: {
    meta: { totalEntries?: number | undefined };
    entries: Array<{
      slug: string;
      name?: string | undefined;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      guestCapacity?: number | undefined;
      numberOfRooms?: number | undefined;
    }>;
  };
};

export type DiamondCollectionListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  stateOrProvinceLongNameFilter?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type DiamondCollectionListingsListAllQuery = {
  listingsListAllActive: {
    entries: Array<{
      id: string;
      city?: string | undefined;
      listedFloor?: number | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      guestCapacity?: number | undefined;
      name?: string | undefined;
      slug: string;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      stateOrProvinceLongName?: string | undefined;
      isFavorited: boolean;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      marketingWebsiteUrl?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      listingLevel: SubscriptionType;
      isDiamondCollection: boolean;
      searchableAvailability: boolean;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        companyName?: string | undefined;
        avatarUrl?: string | undefined;
      };
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
    }>;
    meta: {
      totalPages?: number | undefined;
      nextPage?: number | undefined;
      previousPage?: number | undefined;
    };
  };
};

export type SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables =
  Exact<{
    cursorAfter?: InputMaybe<Scalars['String']['input']>;
    cursorBefore?: InputMaybe<Scalars['String']['input']>;
    pageSize?: Scalars['Int']['input'];
    featuresFilter?: InputMaybe<Array<FeatureKey> | FeatureKey>;
    propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
    minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
    minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
    minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
    minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
    accountId?: InputMaybe<Scalars['String']['input']>;
    regionPath?: InputMaybe<Scalars['String']['input']>;
  }>;

export type SearchRegionForListingsByPlaceNameWithSingleAssetQuery = {
  regionListingsCollection: {
    entries: Array<{
      city?: string | undefined;
      propertyType?: PropertyType | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      guestCapacity?: number | undefined;
      name?: string | undefined;
      slug: string;
      stateOrProvinceLongName?: string | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      listingLevel: SubscriptionType;
      isDiamondCollection: boolean;
      isFavorited: boolean;
      id: string;
      searchableAvailability: boolean;
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
      priceDisplay?:
        | {
            checkInDate: string;
            checkOutDate: string;
            baseAmountCents: number;
            subtotalWithoutTaxesCents?: number | undefined;
            nights: number;
          }
        | undefined;
      account: {
        slug: string;
        avatarUrl?: string | undefined;
        companyName?: string | undefined;
      };
    }>;
  };
};

export type ListingByExternalIdAndSourceQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
  externalSource: ExternalSource;
}>;

export type ListingByExternalIdAndSourceQuery = {
  listingByExternalIdAndSource:
    | { __typename: 'Listing'; slug: string }
    | { __typename: 'NotFoundError'; message: string };
};

export type ListingBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type ListingBySlugQuery = {
  listingBySlug:
    | {
        __typename: 'Listing';
        id: string;
        addressLineOne?: string | undefined;
        airbnbUrl?: string | undefined;
        vrboUrl?: string | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        bookDirectWebsiteUrlParamsTemplate?: string | undefined;
        city?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        cancellationPolicy?: string | undefined;
        licenseNumber?: string | undefined;
        listedFloor?: number | undefined;
        numberOfFloors?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        lat?: number | undefined;
        lng?: number | undefined;
        locationObfuscated: boolean;
        marketingWebsiteUrl?: string | undefined;
        name?: string | undefined;
        published: boolean;
        pinterestUrl?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        publicPhoneNumber?: string | undefined;
        slug: string;
        stateOrProvinceLongName?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        twitterUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        isFavorited: boolean;
        supportsQuotes: boolean;
        supportsBookings: boolean;
        supportsIframeBooking: boolean;
        searchableAvailability: boolean;
        indexable: boolean;
        ose: boolean;
        termsAndConditionsLink?: string | undefined;
        termsAndConditionsText?: string | undefined;
        reviewsAverageRating?: number | undefined;
        reviewsCount?: number | undefined;
        reviewSummary?: string | undefined;
        numberOfBeds?: number | undefined;
        regions: Array<{
          placeId: string;
          name: string;
          path?: string | undefined;
        }>;
        galleryAssets: Array<{
          id: string;
          url?: string | undefined;
          rawUrl?: string | undefined;
          description?: string | undefined;
        }>;
        features: Array<{
          key: FeatureKey;
          legacyKey: string;
          displayName: string;
          promoted: boolean;
          categoryName: string;
        }>;
        affiliations: Array<{
          id: string;
          type: AffiliationType;
          name: string;
        }>;
        account: {
          id: string;
          slug: string;
          companyName?: string | undefined;
          title?: string | undefined;
          description?: string | undefined;
          avatarUrl?: string | undefined;
          inBusinessSince?: number | undefined;
          city?: string | undefined;
          stateOrProvinceLongName?: string | undefined;
          activeListingsCount: number;
          marketingWebsiteUrl?: string | undefined;
          facebookPageUrl?: string | undefined;
          instagramUrl?: string | undefined;
          twitterUrl?: string | undefined;
          phoneNumber?: string | undefined;
          email?: string | undefined;
          linkedinUrl?: string | undefined;
          youtubeUrl?: string | undefined;
          accountReviewSummaries: Array<{
            id: string;
            source: AccountReviewSummarySource;
            sourceId: string;
            numberOfReviews?: number | undefined;
            imageUrl?: string | undefined;
            rating: number;
          }>;
        };
        policies: Array<
          | { cancellationPolicy: string }
          | { termsLink?: string | undefined }
          | { cancellationPolicy: string }
          | Record<PropertyKey, never>
        >;
        reviews?:
          | Array<{
              body?: string | undefined;
              rating?: number | undefined;
              authorName?: string | undefined;
              date?: string | undefined;
            }>
          | undefined;
        rooms: Array<{
          index: number;
          name: string;
          beds: Array<{ type: BedType; count: number }>;
        }>;
      }
    | { __typename: 'ListingArchivedError'; message: string }
    | { __typename: 'ListingUnpublishedError'; message: string }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError' }
    | { __typename: 'UnauthorizedError' };
};

export type ListingByIdAndUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ListingByIdAndUserQuery = {
  listingByIdAndUser:
    | {
        __typename: 'Listing';
        id: string;
        preciseAddressLineOne?: string | undefined;
        preciseAddressLineTwo?: string | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        city?: string | undefined;
        checkIn?: SupportedCheckInAndOutTimes | undefined;
        checkout?: SupportedCheckInAndOutTimes | undefined;
        cancellationPolicy?: string | undefined;
        termsAndConditionsLink?: string | undefined;
        numberOfFloors?: number | undefined;
        licenseNumber?: string | undefined;
        listedFloor?: number | undefined;
        numberOfRooms?: number | undefined;
        numberOfBathrooms?: number | undefined;
        guestCapacity?: number | undefined;
        countryOrRegionLongName?: string | undefined;
        description?: string | undefined;
        facebookPageUrl?: string | undefined;
        propertyType?: PropertyType | undefined;
        uniquePropertyType?: UniquePropertyType | undefined;
        hostBio?: string | undefined;
        hostDisplayName?: string | undefined;
        hostImageProcessing: boolean;
        hostImageUrl?: string | undefined;
        instagramUrl?: string | undefined;
        preciseLat?: number | undefined;
        preciseLng?: number | undefined;
        locationObfuscated: boolean;
        marketingWebsiteUrl?: string | undefined;
        instagramUsername?: string | undefined;
        pinterestUsername?: string | undefined;
        name?: string | undefined;
        published: boolean;
        pinterestUrl?: string | undefined;
        postalCode?: string | undefined;
        publicEmail?: string | undefined;
        publicPhoneNumber?: string | undefined;
        slug: string;
        stateOrProvinceLongName?: string | undefined;
        twitterUrl?: string | undefined;
        twitterHandle?: string | undefined;
        youtubeUrl?: string | undefined;
        minPrice?: number | undefined;
        maxPrice?: number | undefined;
        listingLevel: SubscriptionType;
        isDiamondCollection: boolean;
        featuredByOwner: boolean;
        galleryAssets: Array<{
          id: string;
          url?: string | undefined;
          rawUrl?: string | undefined;
          description?: string | undefined;
          processing: boolean;
          position: number;
        }>;
        features: Array<{
          key: FeatureKey;
          legacyKey: string;
          displayName: string;
          promoted: boolean;
          categoryName: string;
        }>;
        affiliations: Array<{
          id: string;
          type: AffiliationType;
          name: string;
        }>;
        account: {
          id: string;
          slug: string;
          companyName?: string | undefined;
          avatarUrl?: string | undefined;
          owner: { id: string };
          availableCoupon?:
            | {
                percentOff?: number | undefined;
                applicableSubscriptions?:
                  | Array<SubscriptionType | undefined>
                  | undefined;
              }
            | undefined;
        };
        policies: Array<
          | { type: PolicyType; cancellationPolicy: string }
          | { type: PolicyType; termsLink?: string | undefined }
          | { type: PolicyType; cancellationPolicy: string }
          | Record<PropertyKey, never>
        >;
      }
    | { __typename: 'NotFoundError'; message: string };
};

export type AccountListingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;

export type AccountListingsQuery = {
  accountListings:
    | {
        __typename: 'ListingCollection';
        entries: Array<{
          id: string;
          addressLineOne?: string | undefined;
          addressLineTwo?: string | undefined;
          cancellationPolicy?: string | undefined;
          checkIn?: SupportedCheckInAndOutTimes | undefined;
          checkout?: SupportedCheckInAndOutTimes | undefined;
          numberOfFloors?: number | undefined;
          listedFloor?: number | undefined;
          numberOfRooms?: number | undefined;
          numberOfBathrooms?: number | undefined;
          guestCapacity?: number | undefined;
          propertyType?: PropertyType | undefined;
          uniquePropertyType?: UniquePropertyType | undefined;
          hostImageProcessing: boolean;
          bookDirectWebsiteUrl?: string | undefined;
          city?: string | undefined;
          countryOrRegionLongName?: string | undefined;
          currentBalanceCents: number;
          description?: string | undefined;
          facebookPageUrl?: string | undefined;
          hostBio?: string | undefined;
          hostDisplayName?: string | undefined;
          hostImageUrl?: string | undefined;
          instagramUrl?: string | undefined;
          instagramUsername?: string | undefined;
          isFavorited: boolean;
          firstPublishedAt?: string | undefined;
          lastPublishedAt?: string | undefined;
          unpublishedAt?: string | undefined;
          lat?: number | undefined;
          lng?: number | undefined;
          licenseNumber?: string | undefined;
          locationObfuscated: boolean;
          locationSetManually: boolean;
          marketingWebsiteUrl?: string | undefined;
          name?: string | undefined;
          pinterestUrl?: string | undefined;
          pinterestUsername?: string | undefined;
          placeId?: string | undefined;
          placeName?: string | undefined;
          postalCode?: string | undefined;
          publicEmail?: string | undefined;
          youtubeUrl?: string | undefined;
          wNineOnFile: boolean;
          twitterUrl?: string | undefined;
          twitterHandle?: string | undefined;
          stateOrProvinceLongName?: string | undefined;
          slug: string;
          minPrice?: number | undefined;
          maxPrice?: number | undefined;
          published: boolean;
          publishIpAddress?: string | undefined;
          publicPhoneNumber?: string | undefined;
          listingLevel: SubscriptionType;
          isDiamondCollection: boolean;
          featuredByOwner: boolean;
          account: {
            id: string;
            slug: string;
            avatarUrl?: string | undefined;
            companyName?: string | undefined;
          };
          affiliations: Array<{
            id: string;
            name: string;
            type: AffiliationType;
          }>;
          features: Array<{
            categoryName: string;
            displayName: string;
            key: FeatureKey;
            legacyKey: string;
            promoted: boolean;
          }>;
          galleryAssets: Array<{
            description?: string | undefined;
            id: string;
            processing: boolean;
            rawUrl?: string | undefined;
            position: number;
            url?: string | undefined;
          }>;
        }>;
        meta: {
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          currentPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type ListingsListAllFavoritedQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort: ListingFavoriteSortOptions;
}>;

export type ListingsListAllFavoritedQuery = {
  listingsListAllFavorited:
    | {
        __typename: 'ListingCollection';
        entries: Array<{
          lat?: number | undefined;
          lng?: number | undefined;
          locationObfuscated: boolean;
          city?: string | undefined;
          propertyType?: PropertyType | undefined;
          numberOfRooms?: number | undefined;
          numberOfBathrooms?: number | undefined;
          guestCapacity?: number | undefined;
          name?: string | undefined;
          slug: string;
          stateOrProvinceLongName?: string | undefined;
          marketingWebsiteUrl?: string | undefined;
          bookDirectWebsiteUrl?: string | undefined;
          description?: string | undefined;
          minPrice?: number | undefined;
          maxPrice?: number | undefined;
          averageSavings?: number | undefined;
          listingLevel: SubscriptionType;
          isDiamondCollection: boolean;
          isFavorited: boolean;
          id: string;
          searchableAvailability: boolean;
          account: {
            id: string;
            slug: string;
            avatarUrl?: string | undefined;
            companyName?: string | undefined;
          };
          galleryAssets: Array<{ id: string; url?: string | undefined }>;
        }>;
        meta: {
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          currentPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type ListingsSearchQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['String']['input']>;
  centerLat?: InputMaybe<Scalars['Float']['input']>;
  centerLng?: InputMaybe<Scalars['Float']['input']>;
  features?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  propertyTypes?: InputMaybe<Array<PropertyType> | PropertyType>;
  uniquePropertyTypes?: InputMaybe<
    Array<InputMaybe<UniquePropertyType>> | InputMaybe<UniquePropertyType>
  >;
  minGuestCapacity?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfRooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minNumberOfBeds?: InputMaybe<Scalars['Int']['input']>;
  minPriceCents?: InputMaybe<Scalars['Int']['input']>;
  maxPriceCents?: InputMaybe<Scalars['Int']['input']>;
  northEastLat?: InputMaybe<Scalars['Float']['input']>;
  northEastLng?: InputMaybe<Scalars['Float']['input']>;
  cursorAfter?: InputMaybe<Scalars['String']['input']>;
  cursorBefore?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  searchType: ListingsSearchType;
  southWestLat?: InputMaybe<Scalars['Float']['input']>;
  southWestLng?: InputMaybe<Scalars['Float']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  petCount?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListingSortOptions>;
}>;

export type ListingsSearchQuery = {
  listingsSearch:
    | {
        __typename: 'ListingSearchCursorCollection';
        entries: Array<{
          lat?: number | undefined;
          lng?: number | undefined;
          locationObfuscated: boolean;
          city?: string | undefined;
          propertyType?: PropertyType | undefined;
          uniquePropertyType?: UniquePropertyType | undefined;
          numberOfRooms?: number | undefined;
          numberOfBathrooms?: number | undefined;
          guestCapacity?: number | undefined;
          name?: string | undefined;
          slug: string;
          stateOrProvinceLongName?: string | undefined;
          marketingWebsiteUrl?: string | undefined;
          bookDirectWebsiteUrl?: string | undefined;
          description?: string | undefined;
          minPrice?: number | undefined;
          maxPrice?: number | undefined;
          averageSavings?: number | undefined;
          searchPromotionType?: SearchPromotionType | undefined;
          listingLevel: SubscriptionType;
          isDiamondCollection: boolean;
          isFavorited: boolean;
          id: string;
          searchableAvailability: boolean;
          reviewsAverageRating?: number | undefined;
          reviewsCount?: number | undefined;
          account: {
            id: string;
            slug: string;
            avatarUrl?: string | undefined;
            companyName?: string | undefined;
          };
          priceDisplay?:
            | {
                checkInDate: string;
                checkOutDate: string;
                baseAmountCents: number;
                subtotalWithoutTaxesCents?: number | undefined;
                nights: number;
              }
            | undefined;
          features: Array<{
            key: FeatureKey;
            categoryName: string;
            displayName: string;
            promoted: boolean;
          }>;
          galleryAssets: Array<{ id: string; url?: string | undefined }>;
        }>;
        metadata: {
          cursorAfter?: string | undefined;
          cursorBefore?: string | undefined;
          totalCount?: number | undefined;
        };
        searchPlace?:
          | {
              name?: string | undefined;
              placeType?: string | undefined;
              geometry?:
                | {
                    centerPoint?: { lat: number; lng: number } | undefined;
                    northEastPoint?: { lat: number; lng: number } | undefined;
                    southWestPoint?: { lat: number; lng: number } | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type ListingsListAllIndexableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type ListingsListAllIndexableQuery = {
  listingsListAllIndexable: {
    entries: Array<{ slug: string; updatedAt?: string | undefined }>;
    meta: {
      nextPage?: number | undefined;
      previousPage?: number | undefined;
      totalEntries?: number | undefined;
      totalPages?: number | undefined;
    };
  };
};

export type HomePageListingFieldsFragment = {
  id: string;
  name?: string | undefined;
  slug: string;
  city?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  propertyType?: PropertyType | undefined;
  uniquePropertyType?: UniquePropertyType | undefined;
  guestCapacity?: number | undefined;
  numberOfRooms?: number | undefined;
  numberOfBathrooms?: number | undefined;
  marketingWebsiteUrl?: string | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  description?: string | undefined;
  minPrice?: number | undefined;
  maxPrice?: number | undefined;
  averageSavings?: number | undefined;
  reviewsAverageRating?: number | undefined;
  reviewsCount?: number | undefined;
  isFavorited: boolean;
  listingLevel: SubscriptionType;
  searchableAvailability: boolean;
  isDiamondCollection: boolean;
  priceDisplay?:
    | {
        baseAmountCents: number;
        subtotalWithoutTaxesCents?: number | undefined;
        nights: number;
        checkInDate: string;
        checkOutDate: string;
      }
    | undefined;
  galleryAssets: Array<{
    id: string;
    url?: string | undefined;
    description?: string | undefined;
  }>;
  features: Array<{
    key: FeatureKey;
    displayName: string;
    categoryName: string;
    promoted: boolean;
  }>;
  account: {
    id: string;
    slug: string;
    avatarUrl?: string | undefined;
    companyName?: string | undefined;
  };
};

export type HomePageListingsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type HomePageListingsQuery = {
  listingsHomePage: {
    featured: Array<{
      id: string;
      name?: string | undefined;
      slug: string;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      guestCapacity?: number | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      reviewsAverageRating?: number | undefined;
      reviewsCount?: number | undefined;
      isFavorited: boolean;
      listingLevel: SubscriptionType;
      searchableAvailability: boolean;
      isDiamondCollection: boolean;
      priceDisplay?:
        | {
            baseAmountCents: number;
            subtotalWithoutTaxesCents?: number | undefined;
            nights: number;
            checkInDate: string;
            checkOutDate: string;
          }
        | undefined;
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        companyName?: string | undefined;
      };
    }>;
    highlyRated: Array<{
      id: string;
      name?: string | undefined;
      slug: string;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      guestCapacity?: number | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      reviewsAverageRating?: number | undefined;
      reviewsCount?: number | undefined;
      isFavorited: boolean;
      listingLevel: SubscriptionType;
      searchableAvailability: boolean;
      isDiamondCollection: boolean;
      priceDisplay?:
        | {
            baseAmountCents: number;
            subtotalWithoutTaxesCents?: number | undefined;
            nights: number;
            checkInDate: string;
            checkOutDate: string;
          }
        | undefined;
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        companyName?: string | undefined;
      };
    }>;
    trending: Array<{
      id: string;
      name?: string | undefined;
      slug: string;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      guestCapacity?: number | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      reviewsAverageRating?: number | undefined;
      reviewsCount?: number | undefined;
      isFavorited: boolean;
      listingLevel: SubscriptionType;
      searchableAvailability: boolean;
      isDiamondCollection: boolean;
      priceDisplay?:
        | {
            baseAmountCents: number;
            subtotalWithoutTaxesCents?: number | undefined;
            nights: number;
            checkInDate: string;
            checkOutDate: string;
          }
        | undefined;
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        companyName?: string | undefined;
      };
    }>;
  };
};

export type FourthOfJulyListingFieldsFragment = {
  id: string;
  name?: string | undefined;
  slug: string;
  city?: string | undefined;
  stateOrProvinceLongName?: string | undefined;
  propertyType?: PropertyType | undefined;
  uniquePropertyType?: UniquePropertyType | undefined;
  guestCapacity?: number | undefined;
  numberOfRooms?: number | undefined;
  numberOfBathrooms?: number | undefined;
  marketingWebsiteUrl?: string | undefined;
  bookDirectWebsiteUrl?: string | undefined;
  description?: string | undefined;
  minPrice?: number | undefined;
  maxPrice?: number | undefined;
  averageSavings?: number | undefined;
  reviewsAverageRating?: number | undefined;
  reviewsCount?: number | undefined;
  isFavorited: boolean;
  listingLevel: SubscriptionType;
  searchableAvailability: boolean;
  isDiamondCollection: boolean;
  priceDisplay?:
    | {
        baseAmountCents: number;
        subtotalWithoutTaxesCents?: number | undefined;
        nights: number;
        checkInDate: string;
        checkOutDate: string;
      }
    | undefined;
  galleryAssets: Array<{
    id: string;
    url?: string | undefined;
    description?: string | undefined;
  }>;
  features: Array<{
    key: FeatureKey;
    displayName: string;
    categoryName: string;
    promoted: boolean;
  }>;
  account: {
    id: string;
    slug: string;
    avatarUrl?: string | undefined;
    companyName?: string | undefined;
  };
};

export type FourthOfJulyContainerListingsQueryVariables = Exact<{
  featuresFilter?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  featuresFilterAny?: InputMaybe<Array<FeatureKey> | FeatureKey>;
  minAverageSavings?: InputMaybe<Scalars['Float']['input']>;
  maxAverageSavings?: InputMaybe<Scalars['Float']['input']>;
  minPricingStatsCount?: InputMaybe<Scalars['Int']['input']>;
  checkInDate?: InputMaybe<Scalars['Date']['input']>;
  checkOutDate?: InputMaybe<Scalars['Date']['input']>;
  pageSize?: Scalars['Int']['input'];
  sort?: InputMaybe<ListingSortOptions>;
}>;

export type FourthOfJulyContainerListingsQuery = {
  listingsListAllActive: {
    entries: Array<{
      id: string;
      name?: string | undefined;
      slug: string;
      city?: string | undefined;
      stateOrProvinceLongName?: string | undefined;
      propertyType?: PropertyType | undefined;
      uniquePropertyType?: UniquePropertyType | undefined;
      guestCapacity?: number | undefined;
      numberOfRooms?: number | undefined;
      numberOfBathrooms?: number | undefined;
      marketingWebsiteUrl?: string | undefined;
      bookDirectWebsiteUrl?: string | undefined;
      description?: string | undefined;
      minPrice?: number | undefined;
      maxPrice?: number | undefined;
      averageSavings?: number | undefined;
      reviewsAverageRating?: number | undefined;
      reviewsCount?: number | undefined;
      isFavorited: boolean;
      listingLevel: SubscriptionType;
      searchableAvailability: boolean;
      isDiamondCollection: boolean;
      priceDisplay?:
        | {
            baseAmountCents: number;
            subtotalWithoutTaxesCents?: number | undefined;
            nights: number;
            checkInDate: string;
            checkOutDate: string;
          }
        | undefined;
      galleryAssets: Array<{
        id: string;
        url?: string | undefined;
        description?: string | undefined;
      }>;
      features: Array<{
        key: FeatureKey;
        displayName: string;
        categoryName: string;
        promoted: boolean;
      }>;
      account: {
        id: string;
        slug: string;
        avatarUrl?: string | undefined;
        companyName?: string | undefined;
      };
    }>;
    meta: { totalEntries?: number | undefined };
  };
};

export type SubscribeEmailToNewsletterMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SubscribeEmailToNewsletterMutation = {
  subscribeEmailToNewsletter:
    | { __typename: 'NewsletterSubscription'; email: string }
    | { __typename: 'ServiceUnavailableError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type SubscribeEmailToIosWaitlistMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type SubscribeEmailToIosWaitlistMutation = {
  subscribeEmailToIosWaitlist:
    | { __typename: 'IosWaitlistSubscription'; email: string }
    | { __typename: 'ServiceUnavailableError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type UserAddReferralCodeMutationVariables = Exact<{
  referralCode: Scalars['String']['input'];
}>;

export type UserAddReferralCodeMutation = {
  userAddReferralCode:
    | { message: string }
    | {
        id: string;
        email: string;
        firstName?: string | undefined;
        lastName?: string | undefined;
      }
    | { errors: Array<{ field?: string | undefined; message: string }> };
};

export type OrderLoadMutationVariables = Exact<{
  input: OrderLoadInput;
}>;

export type OrderLoadMutation = {
  orderLoad:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Order';
        id: string;
        quote: {
          checkInDate?: string | undefined;
          checkOutDate?: string | undefined;
          listingId?: string | undefined;
          numberOfAdults?: number | undefined;
          numberOfChildren?: number | undefined;
          numberOfInfants?: number | undefined;
          numberOfPets?: number | undefined;
          totalCostCents?: number | undefined;
          totalWithoutTaxesCents?: number | undefined;
          totalRecoverableCostCents?: number | undefined;
          quoteItems: Array<{
            costCents: number;
            type: QuoteItemizedType;
            description: string;
          }>;
          paymentSchedule: Array<{
            dueDate: string;
            amountCents: number;
            description?: string | undefined;
            paymentItemType: PaymentItemType;
          }>;
        };
      }
    | { __typename: 'OrderUnavailable'; message: string }
    | { __typename: 'OrderUnsupported'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | { __typename: 'ValidationError'; message: string };
};

export type SendPasswordResetEmailMutationVariables = Exact<{
  input: SendPasswordResetEmailInput;
}>;

export type SendPasswordResetEmailMutation = {
  sendPasswordResetEmail:
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'PasswordResetMessage'; message: string };
};

export type ResetPasswordForTokenMutationVariables = Exact<{
  input: ResetPasswordForTokenInput;
}>;

export type ResetPasswordForTokenMutation = {
  resetPasswordForToken:
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'PasswordResetMessage'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          field?: string | undefined;
          type?: string | undefined;
        }>;
      };
};

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
  resetPassword:
    | { __typename: 'PasswordResetMessage'; message: string }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          field?: string | undefined;
          type?: string | undefined;
        }>;
      };
};

export type PhoneVerificationStartMutationVariables = Exact<{
  input: PhoneVerificationStartInput;
}>;

export type PhoneVerificationStartMutation = {
  phoneVerificationStart:
    | { __typename: 'ServiceUnavailableError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        id: string;
        phoneNumber?: string | undefined;
        phoneNumberVerified?: string | undefined;
        phoneNumberVerifiedAt?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          type?: string | undefined;
          message: string;
        }>;
      };
};

export type PhoneVerificationCheckMutationVariables = Exact<{
  input: PhoneVerificationCheckInput;
}>;

export type PhoneVerificationCheckMutation = {
  phoneVerificationCheck:
    | { __typename: 'ServiceUnavailableError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        id: string;
        phoneNumber?: string | undefined;
        phoneNumberVerified?: string | undefined;
        phoneNumberVerifiedAt?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          type?: string | undefined;
          message: string;
        }>;
      };
};

export type PlacesAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type: PlaceTypeFilter;
}>;

export type PlacesAutocompleteQuery = {
  placesAutocomplete: Array<{ id: string; name: string }>;
};

export type PlaceFindByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PlaceFindByIdQuery = {
  placeById:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Place';
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        countryOrRegionShortName?: string | undefined;
        id: string;
        name: string;
        postalCode?: string | undefined;
        ratingValue?: number | undefined;
        ratingValueMax?: number | undefined;
        rawTypes?: Array<string> | undefined;
        stateOrProvinceLongName?: string | undefined;
        stateOrProvinceShortName?: string | undefined;
        geometry?:
          | {
              centerPoint?: { lat: number; lng: number } | undefined;
              northEastPoint?: { lat: number; lng: number } | undefined;
              southWestPoint?: { lat: number; lng: number } | undefined;
            }
          | undefined;
        rawAddressComponents?:
          | Array<{ longName: string; shortName: string; types: Array<string> }>
          | undefined;
      };
};

export type PlaceSearchGeometryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PlaceSearchGeometryQuery = {
  placeSearchGeometry?:
    | {
        centerPoint?: { lat: number; lng: number } | undefined;
        northEastPoint?: { lat: number; lng: number } | undefined;
        southWestPoint?: { lat: number; lng: number } | undefined;
      }
    | undefined;
};

export type PlansListAllQueryVariables = Exact<{ [key: string]: never }>;

export type PlansListAllQuery = {
  plansListAll:
    | {
        __typename: 'PlanCollection';
        entries: Array<{ id: string; name: string; amount: number }>;
      }
    | { __typename: 'ServiceUnavailableError' }
    | { __typename: 'UnauthenticatedError' };
};

export type PmOnboardingFlowStepFieldsFragment = {
  stepKey: PmOnboardingStepKey;
  position: number;
  label: string;
  required: boolean;
};

export type PmOnboardingFlowFieldsFragment = {
  id: string;
  version: string;
  name: string;
  description?: string | undefined;
  isActive: boolean;
  totalSteps: number;
  steps: Array<{
    stepKey: PmOnboardingStepKey;
    position: number;
    label: string;
    required: boolean;
  }>;
};

export type PmOnboardingStepCompletionFieldsFragment = {
  stepKey: PmOnboardingStepKey;
  completedAt: string;
};

export type PmOnboardingSessionFieldsFragment = {
  id: string;
  accountId?: string | undefined;
  userId?: string | undefined;
  pmsType?: string | undefined;
  currentStepKey: PmOnboardingStepKey;
  status: PmOnboardingSessionStatus;
  reviewReason?: PmOnboardingReviewReason | undefined;
  publishedAt?: string | undefined;
  startedAt: string;
  completedAt?: string | undefined;
  lastActivityAt: string;
  currentStepIndex: number;
  totalSteps: number;
  completedStepKeys: Array<PmOnboardingStepKey>;
  canAdvance: boolean;
  flow: {
    id: string;
    version: string;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    totalSteps: number;
    steps: Array<{
      stepKey: PmOnboardingStepKey;
      position: number;
      label: string;
      required: boolean;
    }>;
  };
  stepCompletions: Array<{ stepKey: PmOnboardingStepKey; completedAt: string }>;
  account?:
    | {
        id: string;
        isUsBased?: boolean | undefined;
        countryOrRegionLongName?: string | undefined;
      }
    | undefined;
};

export type PmOnboardingCompleteStepMutationVariables = Exact<{
  input: PmOnboardingCompleteStepInput;
}>;

export type PmOnboardingCompleteStepMutation = {
  pmOnboardingCompleteStep:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'PmOnboardingSession';
        id: string;
        accountId?: string | undefined;
        userId?: string | undefined;
        pmsType?: string | undefined;
        currentStepKey: PmOnboardingStepKey;
        status: PmOnboardingSessionStatus;
        reviewReason?: PmOnboardingReviewReason | undefined;
        publishedAt?: string | undefined;
        startedAt: string;
        completedAt?: string | undefined;
        lastActivityAt: string;
        currentStepIndex: number;
        totalSteps: number;
        completedStepKeys: Array<PmOnboardingStepKey>;
        canAdvance: boolean;
        flow: {
          id: string;
          version: string;
          name: string;
          description?: string | undefined;
          isActive: boolean;
          totalSteps: number;
          steps: Array<{
            stepKey: PmOnboardingStepKey;
            position: number;
            label: string;
            required: boolean;
          }>;
        };
        stepCompletions: Array<{
          stepKey: PmOnboardingStepKey;
          completedAt: string;
        }>;
        account?:
          | {
              id: string;
              isUsBased?: boolean | undefined;
              countryOrRegionLongName?: string | undefined;
            }
          | undefined;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type PmOnboardingNavigateToStepMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  stepKey: PmOnboardingStepKey;
}>;

export type PmOnboardingNavigateToStepMutation = {
  pmOnboardingNavigateToStep:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'PmOnboardingSession';
        id: string;
        accountId?: string | undefined;
        userId?: string | undefined;
        pmsType?: string | undefined;
        currentStepKey: PmOnboardingStepKey;
        status: PmOnboardingSessionStatus;
        reviewReason?: PmOnboardingReviewReason | undefined;
        publishedAt?: string | undefined;
        startedAt: string;
        completedAt?: string | undefined;
        lastActivityAt: string;
        currentStepIndex: number;
        totalSteps: number;
        completedStepKeys: Array<PmOnboardingStepKey>;
        canAdvance: boolean;
        flow: {
          id: string;
          version: string;
          name: string;
          description?: string | undefined;
          isActive: boolean;
          totalSteps: number;
          steps: Array<{
            stepKey: PmOnboardingStepKey;
            position: number;
            label: string;
            required: boolean;
          }>;
        };
        stepCompletions: Array<{
          stepKey: PmOnboardingStepKey;
          completedAt: string;
        }>;
        account?:
          | {
              id: string;
              isUsBased?: boolean | undefined;
              countryOrRegionLongName?: string | undefined;
            }
          | undefined;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type MyPmOnboardingSessionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyPmOnboardingSessionQuery = {
  myPmOnboardingSession:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'PmOnboardingSession';
        id: string;
        accountId?: string | undefined;
        userId?: string | undefined;
        pmsType?: string | undefined;
        currentStepKey: PmOnboardingStepKey;
        status: PmOnboardingSessionStatus;
        reviewReason?: PmOnboardingReviewReason | undefined;
        publishedAt?: string | undefined;
        startedAt: string;
        completedAt?: string | undefined;
        lastActivityAt: string;
        currentStepIndex: number;
        totalSteps: number;
        completedStepKeys: Array<PmOnboardingStepKey>;
        canAdvance: boolean;
        flow: {
          id: string;
          version: string;
          name: string;
          description?: string | undefined;
          isActive: boolean;
          totalSteps: number;
          steps: Array<{
            stepKey: PmOnboardingStepKey;
            position: number;
            label: string;
            required: boolean;
          }>;
        };
        stepCompletions: Array<{
          stepKey: PmOnboardingStepKey;
          completedAt: string;
        }>;
        account?:
          | {
              id: string;
              isUsBased?: boolean | undefined;
              countryOrRegionLongName?: string | undefined;
            }
          | undefined;
      }
    | { __typename: 'UnauthenticatedError' };
};

export type PmsConnectionFieldsFragment = {
  id: string;
  type: PmsName;
  failed: boolean;
  supportsBookings: boolean;
};

export type GuestyDhPmsConnectionCreateMutationVariables = Exact<{
  input: GuestyDhPmsConnectionCreateInput;
}>;

export type GuestyDhPmsConnectionCreateMutation = {
  guestyDhPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type HostawayPmsConnectionCreateMutationVariables = Exact<{
  input: HostawayPmsConnectionCreateInput;
}>;

export type HostawayPmsConnectionCreateMutation = {
  hostawayPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type LodgifyPmsConnectionCreateMutationVariables = Exact<{
  input: LodgifyPmsConnectionCreateInput;
}>;

export type LodgifyPmsConnectionCreateMutation = {
  lodgifyPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type HostfullyPmsConnectionCreateMutationVariables = Exact<{
  input: HostfullyPmsConnectionCreateInput;
}>;

export type HostfullyPmsConnectionCreateMutation = {
  hostfullyPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type HospitablePmsConnectionCreateMutationVariables = Exact<{
  input: HospitablePmsConnectionCreateInput;
}>;

export type HospitablePmsConnectionCreateMutation = {
  hospitablePmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type OwnerRezPmsConnectionCreateMutationVariables = Exact<{
  input: OwnerRezPmsConnectionCreateInput;
}>;

export type OwnerRezPmsConnectionCreateMutation = {
  ownerRezPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type DemoPmsConnectionCreateMutationVariables = Exact<{
  input: DemoPmsConnectionCreateInput;
}>;

export type DemoPmsConnectionCreateMutation = {
  demoPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type BooksterPmsConnectionCreateMutationVariables = Exact<{
  input: BooksterPmsConnectionCreateInput;
}>;

export type BooksterPmsConnectionCreateMutation = {
  booksterPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type LodgixPmsConnectionCreateMutationVariables = Exact<{
  input: LodgixPmsConnectionCreateInput;
}>;

export type LodgixPmsConnectionCreateMutation = {
  lodgixPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type StreamlinePartnerPmsConnectionCreateMutationVariables = Exact<{
  input: StreamlinePartnerPmsConnectionCreateInput;
}>;

export type StreamlinePartnerPmsConnectionCreateMutation = {
  streamlinePartnerPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type EscapiaPmsConnectionCreateMutationVariables = Exact<{
  input: EscapiaPmsConnectionCreateInput;
}>;

export type EscapiaPmsConnectionCreateMutation = {
  escapiaPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type BarefootPmsConnectionCreateMutationVariables = Exact<{
  input: BarefootPmsConnectionCreateInput;
}>;

export type BarefootPmsConnectionCreateMutation = {
  barefootPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type TrackPmsConnectionCreateMutationVariables = Exact<{
  input: TrackPmsConnectionCreateInput;
}>;

export type TrackPmsConnectionCreateMutation = {
  trackPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type RentalsUnitedPmsConnectionCreateMutationVariables = Exact<{
  input: RentalsUnitedPmsConnectionCreateInput;
}>;

export type RentalsUnitedPmsConnectionCreateMutation = {
  rentalsUnitedPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type CiirusPmsConnectionCreateMutationVariables = Exact<{
  input: CiirusPmsConnectionCreateInput;
}>;

export type CiirusPmsConnectionCreateMutation = {
  ciirusPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type BoostPmsConnectionCreateMutationVariables = Exact<{
  input: BoostPmsConnectionCreateInput;
}>;

export type BoostPmsConnectionCreateMutation = {
  boostPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type LiveListPmsConnectionCreateMutationVariables = Exact<{
  input: LiveListPmsConnectionCreateInput;
}>;

export type LiveListPmsConnectionCreateMutation = {
  liveListPmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type VacayHomePmsConnectionCreateMutationVariables = Exact<{
  input: VacayHomePmsConnectionCreateInput;
}>;

export type VacayHomePmsConnectionCreateMutation = {
  vacayHomePmsConnectionCreate:
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type PmsConnectionForCurrentUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PmsConnectionForCurrentUserQuery = {
  pmsConnectionForCurrentUser:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'PmsConnection';
        id: string;
        type: PmsName;
        failed: boolean;
        supportsBookings: boolean;
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type PmsIntegrationListAllQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PmsIntegrationListAllQuery = {
  pmsIntegrationListAll: Array<{
    name: string;
    docsUrl: string;
    jiraTicketUrl: string;
    authType: string;
    status: PmsIntegrationStatus;
    contentSync?: string | undefined;
    availabilitySync?: string | undefined;
    ratesSync?: string | undefined;
    supportsPricing?: boolean | undefined;
    supportsBookings?: boolean | undefined;
    supportsReviews?: boolean | undefined;
    supportedFields: Array<{
      fieldName: FieldNames;
      description?: string | undefined;
      supported: PmsIntegrationFieldSupported;
    }>;
    fields: Array<{
      fieldName: FieldNames;
      description?: string | undefined;
      supported: PmsIntegrationFieldSupported;
    }>;
  }>;
};

export type PolicyUpsertAccountTermsAndConditionsMutationVariables = Exact<{
  input: PolicyUpsertAccountTermsAndConditionsInput;
}>;

export type PolicyUpsertAccountTermsAndConditionsMutation = {
  policyUpsertAccountTermsAndConditions:
    | {
        __typename: 'AccountTermsAndConditions';
        id: string;
        type: PolicyType;
        termsLink?: string | undefined;
        termsUploadUrl?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type PolicyUpsertListingTermsAndConditionsMutationVariables = Exact<{
  input: PolicyUpsertListingTermsAndConditionsInput;
}>;

export type PolicyUpsertListingTermsAndConditionsMutation = {
  policyUpsertListingTermsAndConditions:
    | {
        __typename: 'ListingTermsAndConditions';
        type: PolicyType;
        termsLink?: string | undefined;
        termsUploadUrl?: string | undefined;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type PolicyUpsertAccountCancellationPolicyMutationVariables = Exact<{
  input: PolicyUpsertAccountCancellationPolicyInput;
}>;

export type PolicyUpsertAccountCancellationPolicyMutation = {
  policyUpsertAccountCancellationPolicy:
    | {
        __typename: 'AccountCancellationPolicy';
        id: string;
        type: PolicyType;
        cancellationPolicy: string;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type PolicyUpsertListingCancellationPolicyMutationVariables = Exact<{
  input: PolicyUpsertListingCancellationPolicyInput;
}>;

export type PolicyUpsertListingCancellationPolicyMutation = {
  policyUpsertListingCancellationPolicy:
    | {
        __typename: 'ListingCancellationPolicy';
        type: PolicyType;
        cancellationPolicy: string;
      }
    | { __typename: 'NotFoundError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type UserReferralCampaignCreateMutationVariables = Exact<{
  input: UserReferralCampaignCreateInput;
}>;

export type UserReferralCampaignCreateMutation = {
  userReferralCampaignCreate:
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'UserReferralCampaign';
        id: string;
        code: string;
        campaignType: ReferralCampaignType;
        campaignName: string;
        campaignDescription: string;
        state: UserReferralCampaignState;
        rewardsBalanceCents: number;
        rewardsIssuedCount: number;
        rewardsRemaining?: number | undefined;
        insertedAt: string;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{ field?: string | undefined; message: string }>;
      };
};

export type UserReferralCampaignsForCurrentUserQueryVariables = Exact<{
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UserReferralCampaignsForCurrentUserQuery = {
  userReferralCampaignsForCurrentUser:
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'UserReferralCampaignCollection';
        totalCount: number;
        entries: Array<{
          id: string;
          code: string;
          campaignType: ReferralCampaignType;
          campaignName: string;
          campaignDescription: string;
          state: UserReferralCampaignState;
          rewardsBalanceCents: number;
          rewardsIssuedCount: number;
          rewardsRemaining?: number | undefined;
          insertedAt: string;
        }>;
      };
};

export type ReferralCodeFindByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type ReferralCodeFindByCodeQuery = {
  referralCodeFindByCode:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'ReferralCodeDetails';
        code: string;
        campaignType: ReferralCampaignType;
        campaignName: string;
        campaignDescription: string;
        referredUserRewardAmountCents: number;
      };
};

export type RewardsForCurrentUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RewardsForCurrentUserQuery = {
  rewardsForCurrentUser:
    | {
        __typename: 'RewardCollection';
        entries: Array<{
          id: string;
          amountCents: number;
          status: string;
          insertedAt: string;
          recipient: {
            id: string;
            firstName?: string | undefined;
            email: string;
          };
          giftCard?:
            | {
                id: string;
                certificateNumber?: string | undefined;
                status: GiftCardStatus;
                type: GiftCardType;
              }
            | undefined;
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
          totalPages?: number | undefined;
        };
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type RegionsListAllWithActiveSearchPageContentsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchType: SearchPageContentType;
}>;

export type RegionsListAllWithActiveSearchPageContentsQuery = {
  regionsListAllWithActiveSearchPageContents: {
    entries: Array<{
      id: string;
      countrySlug?: string | undefined;
      levelOneSlug?: string | undefined;
      citySlug?: string | undefined;
      slug: string;
      name: string;
    }>;
    meta: {
      nextPage?: number | undefined;
      previousPage?: number | undefined;
      totalPages?: number | undefined;
    };
  };
};

export type RegionsListAllFeaturedQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type RegionsListAllFeaturedQuery = {
  regionsListAllFeatured: {
    __typename: 'RegionCollection';
    entries: Array<{
      id: string;
      name: string;
      imageUrl?: string | undefined;
      placeId: string;
    }>;
    meta: {
      currentPage?: number | undefined;
      totalEntries?: number | undefined;
      nextPage?: number | undefined;
      previousPage?: number | undefined;
    };
  };
};

export type CreateReservationMutationVariables = Exact<{
  input: CreateReservationInput;
}>;

export type CreateReservationMutation = {
  createReservation:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Reservation';
        startDate: string;
        endDate: string;
        status: ReservationStatuses;
        id: string;
        externalReservationId?: string | undefined;
      }
    | {
        __typename: 'ReservationCreationUnknown';
        reservationId: string;
        orderId: string;
        message: string;
      }
    | { __typename: 'ReservationUnavailable'; message: string }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type CancelReservationMutationVariables = Exact<{
  input: CancelReservationInput;
}>;

export type CancelReservationMutation = {
  cancelReservation:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Reservation';
        startDate: string;
        endDate: string;
        status: ReservationStatuses;
        id: string;
        externalReservationId?: string | undefined;
      }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type FreePromoCreateReservationMutationVariables = Exact<{
  input: FreePromoCreateReservationInput;
}>;

export type FreePromoCreateReservationMutation = {
  freePromoCreateReservation:
    | { __typename: 'InvalidPromoCodeError' }
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Reservation';
        startDate: string;
        endDate: string;
        status: ReservationStatuses;
        id: string;
        externalReservationId?: string | undefined;
      }
    | { __typename: 'ReservationUnavailable'; message: string }
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          type?: string | undefined;
          field?: string | undefined;
          message: string;
        }>;
      };
};

export type ReservationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ReservationByIdQuery = {
  reservationById:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Reservation';
        id: string;
        totalCostCents?: number | undefined;
        startDate: string;
        endDate: string;
        status: ReservationStatuses;
        note?: string | undefined;
        externalReservationId?: string | undefined;
        numberOfAdults?: number | undefined;
        numberOfChildren?: number | undefined;
        numberOfInfants?: number | undefined;
        numberOfPets?: number | undefined;
        cancellationPolicy?: string | undefined;
        supportsCancellations: boolean;
        paymentSchedule: Array<{
          dueDate: string;
          amountCents: number;
          description?: string | undefined;
          paymentItemType: PaymentItemType;
        }>;
        listing: {
          bookDirectWebsiteUrl?: string | undefined;
          city?: string | undefined;
          description?: string | undefined;
          marketingWebsiteUrl?: string | undefined;
          name?: string | undefined;
          slug: string;
          stateOrProvinceLongName?: string | undefined;
          guestCapacity?: number | undefined;
          numberOfRooms?: number | undefined;
          numberOfBathrooms?: number | undefined;
          lat?: number | undefined;
          lng?: number | undefined;
          minPrice?: number | undefined;
          maxPrice?: number | undefined;
          propertyType?: PropertyType | undefined;
          uniquePropertyType?: UniquePropertyType | undefined;
          id: string;
          isFavorited: boolean;
          listingLevel: SubscriptionType;
          searchableAvailability: boolean;
          isDiamondCollection: boolean;
          addressLineOne?: string | undefined;
          cancellationPolicy?: string | undefined;
          publicPhoneNumber?: string | undefined;
          features: Array<{
            key: FeatureKey;
            displayName: string;
            categoryName: string;
            promoted: boolean;
          }>;
          account: {
            id: string;
            slug: string;
            companyName?: string | undefined;
            avatarUrl?: string | undefined;
            description?: string | undefined;
            email?: string | undefined;
            marketingWebsiteUrl?: string | undefined;
            phoneNumber?: string | undefined;
          };
          galleryAssets: Array<{
            id: string;
            url?: string | undefined;
            description?: string | undefined;
          }>;
        };
      };
};

export type ReservationForOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ReservationForOrderQuery = {
  reservationForOrder:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'Reservation';
        id: string;
        status: ReservationStatuses;
        startDate: string;
        endDate: string;
        externalReservationId?: string | undefined;
      };
};

export type ReservationsListAllForCurrentUserQueryVariables = Exact<{
  statusFilter?: InputMaybe<
    Array<InputMaybe<ReservationStatuses>> | InputMaybe<ReservationStatuses>
  >;
  page: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;

export type ReservationsListAllForCurrentUserQuery = {
  reservationsListAllForUser:
    | {
        __typename: 'ReservationCollection';
        entries: Array<{
          id: string;
          totalCostCents?: number | undefined;
          startDate: string;
          endDate: string;
          status: ReservationStatuses;
          note?: string | undefined;
          listing: {
            bookDirectWebsiteUrl?: string | undefined;
            city?: string | undefined;
            description?: string | undefined;
            marketingWebsiteUrl?: string | undefined;
            name?: string | undefined;
            slug: string;
            stateOrProvinceLongName?: string | undefined;
            guestCapacity?: number | undefined;
            numberOfRooms?: number | undefined;
            numberOfBathrooms?: number | undefined;
            lat?: number | undefined;
            lng?: number | undefined;
            minPrice?: number | undefined;
            maxPrice?: number | undefined;
            propertyType?: PropertyType | undefined;
            id: string;
            isFavorited: boolean;
            listingLevel: SubscriptionType;
            searchableAvailability: boolean;
            isDiamondCollection: boolean;
            addressLineOne?: string | undefined;
            cancellationPolicy?: string | undefined;
            features: Array<{
              key: FeatureKey;
              displayName: string;
              categoryName: string;
              promoted: boolean;
            }>;
            account: {
              id: string;
              slug: string;
              companyName?: string | undefined;
              avatarUrl?: string | undefined;
            };
            galleryAssets: Array<{
              id: string;
              url?: string | undefined;
              description?: string | undefined;
            }>;
          };
        }>;
        meta: {
          currentPage?: number | undefined;
          nextPage?: number | undefined;
          totalPages?: number | undefined;
          previousPage?: number | undefined;
          totalEntries?: number | undefined;
        };
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type SearchPageContentsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  h1Query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SearchPageContentType>;
}>;

export type SearchPageContentsListAllQuery = {
  searchPageContentListAll: {
    entries: Array<{
      active: boolean;
      searchType: SearchPageContentType;
      h1: string;
      h1ParagraphRaw?: string | undefined;
      h2?: string | undefined;
      h2ParagraphRaw?: string | undefined;
      heroImageHtmlAlt?: string | undefined;
      heroImageProcessing: boolean;
      heroImageUploadUrl?: string | undefined;
      heroImageUrl: string;
      htmlMetaDescription?: string | undefined;
      htmlMetaTitle?: string | undefined;
      id: string;
      updatedAt: string;
    }>;
    meta: {
      previousPage?: number | undefined;
      nextPage?: number | undefined;
      totalEntries?: number | undefined;
      currentPage?: number | undefined;
    };
  };
};

export type SearchPageContentForUrlPathAndTypeQueryVariables = Exact<{
  urlPath: Scalars['String']['input'];
  searchType: SearchPageContentType;
}>;

export type SearchPageContentForUrlPathAndTypeQuery = {
  searchPageContentForUrlPathAndType:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'SearchPageContent';
        active: boolean;
        searchType: SearchPageContentType;
        h1: string;
        h1ParagraphRaw?: string | undefined;
        h2?: string | undefined;
        h2ParagraphRaw?: string | undefined;
        heroImageHtmlAlt?: string | undefined;
        heroImageProcessing: boolean;
        heroImageUploadUrl?: string | undefined;
        heroImageUrl: string;
        htmlMetaDescription?: string | undefined;
        htmlMetaTitle?: string | undefined;
        aboutItemsTitle?: string | undefined;
        faqsTitle?: string | undefined;
        id: string;
        topicSlug?: string | undefined;
        updatedAt: string;
        cities: Array<{
          searchType: SearchPageContentType;
          region?:
            | {
                description: string;
                citySlug?: string | undefined;
                countrySlug?: string | undefined;
                slug: string;
                levelOneSlug?: string | undefined;
              }
            | undefined;
        }>;
        searchPageLinks: Array<{
          href: string;
          id: string;
          title: string;
          type: SearchPageLinkType;
          customLinkCategory?: string | undefined;
        }>;
        searchPageParagraphs: Array<{
          bodyRaw: string;
          id: string;
          title: string;
          type: SearchPageParagraphType;
        }>;
        region?:
          | {
              description: string;
              placeId: string;
              slug: string;
              citySlug?: string | undefined;
              countrySlug?: string | undefined;
              levelOneSlug?: string | undefined;
            }
          | undefined;
        searchPageTopic?: { name: string; slug: string } | undefined;
      }
    | { __typename: 'ValidationErrorCollection' };
};

export type SitemapListingsTotalCountQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type SitemapListingsTotalCountQuery = {
  listingCollection: { meta: { totalEntries?: number | undefined } };
};

export type SitemapListingsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type SitemapListingsListAllQuery = {
  listingCollection: {
    entries: Array<{ slug: string; updatedAt?: string | undefined }>;
    meta: { nextPage?: number | undefined; previousPage?: number | undefined };
  };
};

export type SitemapRegionsListBedAndBreakfastQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;

export type SitemapRegionsListBedAndBreakfastQuery = {
  regionsListAllWithActiveSearchPageContents: {
    entries: Array<{
      id: string;
      countrySlug?: string | undefined;
      levelOneSlug?: string | undefined;
      citySlug?: string | undefined;
      slug: string;
    }>;
    meta: { nextPage?: number | undefined; previousPage?: number | undefined };
  };
};

export type SitemapSearchPageContentsListAllQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  type?: InputMaybe<SearchPageContentType>;
}>;

export type SitemapSearchPageContentsListAllQuery = {
  searchPageContentListAll: {
    entries: Array<{
      id: string;
      path?: string | undefined;
      updatedAt: string;
    }>;
    meta: { nextPage?: number | undefined };
  };
};

export type TestUnhandledErrorQueryVariables = Exact<{ [key: string]: never }>;

export type TestUnhandledErrorQuery = { testUnhandledError: number };

export type TravelerSurveyResponseCreateMutationVariables = Exact<{
  input: TravelerSurveyResponseCreateInput;
}>;

export type TravelerSurveyResponseCreateMutation = {
  travelerSurveyResponseCreate:
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'TravelerSurveyResponse';
        id: string;
        choice: TravelerSurveyChoice;
        label: string;
      }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{ message: string }>;
      };
};

export type TravelerSurveyPromptQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TravelerSurveyPromptQuery = {
  travelerSurveyPrompt:
    | {
        __typename: 'TravelerSurveyQuestion';
        choices: Array<{ value: TravelerSurveyChoice; label: string }>;
      }
    | {
        __typename: 'TravelerSurveyResponse';
        id: string;
        choice: TravelerSurveyChoice;
        label: string;
      }
    | { __typename: 'UnauthenticatedError'; message: string };
};

export type UserFieldsWithAccountFragment = {
  avatarUrl?: string | undefined;
  avatarProcessing: boolean;
  accessToken?: string | undefined;
  refreshToken?: string | undefined;
  accountRole?: AccountRole | undefined;
  claimable: boolean;
  email: string;
  firstName?: string | undefined;
  id: string;
  identityVerified: boolean;
  verificationStatus?: VerificationStatus | undefined;
  lastAuthenticatedAt?: string | undefined;
  lastName?: string | undefined;
  dob?: string | undefined;
  paymentServiceUserId: string;
  phoneNumber?: string | undefined;
  phoneNumberVerified?: string | undefined;
  phoneNumberVerifiedAt?: string | undefined;
  referredByUserId?: string | undefined;
  registeredAt?: string | undefined;
  account?:
    | {
        id: string;
        isPpr: boolean;
        avatarUrl?: string | undefined;
        avatarFileName?: string | undefined;
        avatarUploadUrl?: string | undefined;
        avatarProcessing: boolean;
        heroUrl?: string | undefined;
        heroFileName?: string | undefined;
        heroUploadUrl?: string | undefined;
        heroProcessing: boolean;
        title?: string | undefined;
        companyName?: string | undefined;
        description?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        marketingWebsiteUrl?: string | undefined;
        homeownerMarketingUrl?: string | undefined;
        twitterUrl?: string | undefined;
        instagramUrl?: string | undefined;
        twitterHandle?: string | undefined;
        inBusinessSince?: number | undefined;
        bookDirectWebsiteUrl?: string | undefined;
        instagramUsername?: string | undefined;
        facebookPageUrl?: string | undefined;
        youtubeUrl?: string | undefined;
        linkedinUrl?: string | undefined;
        slug: string;
        insertedAt?: string | undefined;
        firstPublishedAt?: string | undefined;
        onboardingCompletedAt?: string | undefined;
        creditCardOnFile: boolean;
        defaultListingLevel: SubscriptionType;
        addressLineOne?: string | undefined;
        addressLineTwo?: string | undefined;
        city?: string | undefined;
        countryOrRegionLongName?: string | undefined;
        stateOrProvinceLongName?: string | undefined;
        postalCode?: string | undefined;
        billingSubscription?: { currentPeriodEnd: string } | undefined;
        latestTask?:
          | {
              id: string;
              status: TaskStatus;
              startedAt: string;
              completedAt?: string | undefined;
              importCount?: number | undefined;
              importSuccessCount?: number | undefined;
              importedAt?: string | undefined;
              processedAt?: string | undefined;
              finalizedAt?: string | undefined;
              expiresAt?: string | undefined;
              errors?: Array<string> | undefined;
            }
          | undefined;
        listings: Array<{ id: string; name?: string | undefined }>;
        availableCoupon?:
          | {
              promoCode?: string | undefined;
              percentOff?: number | undefined;
              applicableSubscriptions?:
                | Array<SubscriptionType | undefined>
                | undefined;
              name: string;
            }
          | undefined;
        policies: Array<
          | {
              __typename: 'AccountCancellationPolicy';
              cancellationPolicy: string;
            }
          | {
              __typename: 'AccountTermsAndConditions';
              termsLink?: string | undefined;
            }
          | {
              __typename: 'ListingCancellationPolicy';
              cancellationPolicy: string;
            }
          | { __typename: 'ListingTermsAndConditions' }
        >;
        accountReviewSummaries: Array<{
          id: string;
          source: AccountReviewSummarySource;
          rating: number;
          numberOfReviews?: number | undefined;
          url?: string | undefined;
        }>;
      }
    | undefined;
};

export type UserFieldsFragment = {
  avatarUrl?: string | undefined;
  avatarProcessing: boolean;
  accessToken?: string | undefined;
  accountRole?: AccountRole | undefined;
  claimable: boolean;
  email: string;
  firstName?: string | undefined;
  id: string;
  identityVerified: boolean;
  verificationStatus?: VerificationStatus | undefined;
  lastAuthenticatedAt?: string | undefined;
  lastName?: string | undefined;
  paymentServiceUserId: string;
  phoneNumber?: string | undefined;
  referredByUserId?: string | undefined;
  registeredAt?: string | undefined;
};

export type UserSessionFieldsFragment = {
  avatarUrl?: string | undefined;
  accessToken?: string | undefined;
  email: string;
  firstName?: string | undefined;
  id: string;
  lastName?: string | undefined;
  refreshToken?: string | undefined;
  accountRole?: AccountRole | undefined;
  registeredAt?: string | undefined;
  lastAuthenticatedAt?: string | undefined;
};

export type UserCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;

export type UserCreateMutation = {
  userCreate:
    | {
        __typename: 'User';
        refreshToken?: string | undefined;
        avatarUrl?: string | undefined;
        avatarProcessing: boolean;
        accessToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        claimable: boolean;
        email: string;
        firstName?: string | undefined;
        id: string;
        identityVerified: boolean;
        verificationStatus?: VerificationStatus | undefined;
        travelerVerificationStatus?: VerificationStatus | undefined;
        lastAuthenticatedAt?: string | undefined;
        lastName?: string | undefined;
        paymentServiceUserId: string;
        phoneNumber?: string | undefined;
        referredByUserId?: string | undefined;
        registeredAt?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type UserSessionMutationVariables = Exact<{
  input: UserSessionInput;
}>;

export type UserSessionMutation = {
  userSession:
    | { __typename: 'BlockedError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        accessToken?: string | undefined;
        email: string;
        firstName?: string | undefined;
        id: string;
        lastName?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        registeredAt?: string | undefined;
        lastAuthenticatedAt?: string | undefined;
      }
    | { __typename: 'ValidationErrorCollection' };
};

export type UserAppleSocialSessionMutationVariables = Exact<{
  input: UserAppleSocialSessionInput;
}>;

export type UserAppleSocialSessionMutation = {
  userAppleSocialSession:
    | { __typename: 'BlockedError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        accessToken?: string | undefined;
        email: string;
        firstName?: string | undefined;
        id: string;
        lastName?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        registeredAt?: string | undefined;
        lastAuthenticatedAt?: string | undefined;
      }
    | { __typename: 'ValidationErrorCollection' };
};

export type UserGoogleSocialSessionMutationVariables = Exact<{
  input: UserGoogleSocialSessionInput;
}>;

export type UserGoogleSocialSessionMutation = {
  userGoogleSocialSession:
    | { __typename: 'BlockedError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        accessToken?: string | undefined;
        email: string;
        firstName?: string | undefined;
        id: string;
        lastName?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        registeredAt?: string | undefined;
        lastAuthenticatedAt?: string | undefined;
      }
    | { __typename: 'ValidationErrorCollection' };
};

export type UserFacebookSocialSessionMutationVariables = Exact<{
  input: UserFacebookSocialSessionInput;
}>;

export type UserFacebookSocialSessionMutation = {
  userFacebookSocialSession:
    | { __typename: 'BlockedError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        accessToken?: string | undefined;
        email: string;
        firstName?: string | undefined;
        id: string;
        lastName?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        registeredAt?: string | undefined;
        lastAuthenticatedAt?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type UserAccountAddMutationVariables = Exact<{
  input: UserAccountAddInput;
}>;

export type UserAccountAddMutation = {
  userAccountAdd:
    | { __typename: 'ConflictError'; message: string }
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        avatarProcessing: boolean;
        accessToken?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        claimable: boolean;
        email: string;
        firstName?: string | undefined;
        id: string;
        identityVerified: boolean;
        verificationStatus?: VerificationStatus | undefined;
        travelerVerificationStatus?: VerificationStatus | undefined;
        lastAuthenticatedAt?: string | undefined;
        lastName?: string | undefined;
        dob?: string | undefined;
        paymentServiceUserId: string;
        phoneNumber?: string | undefined;
        phoneNumberVerified?: string | undefined;
        phoneNumberVerifiedAt?: string | undefined;
        referredByUserId?: string | undefined;
        registeredAt?: string | undefined;
        account?:
          | {
              id: string;
              isPpr: boolean;
              avatarUrl?: string | undefined;
              avatarFileName?: string | undefined;
              avatarUploadUrl?: string | undefined;
              avatarProcessing: boolean;
              heroUrl?: string | undefined;
              heroFileName?: string | undefined;
              heroUploadUrl?: string | undefined;
              heroProcessing: boolean;
              title?: string | undefined;
              companyName?: string | undefined;
              description?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              marketingWebsiteUrl?: string | undefined;
              homeownerMarketingUrl?: string | undefined;
              twitterUrl?: string | undefined;
              instagramUrl?: string | undefined;
              twitterHandle?: string | undefined;
              inBusinessSince?: number | undefined;
              bookDirectWebsiteUrl?: string | undefined;
              instagramUsername?: string | undefined;
              facebookPageUrl?: string | undefined;
              youtubeUrl?: string | undefined;
              linkedinUrl?: string | undefined;
              slug: string;
              insertedAt?: string | undefined;
              firstPublishedAt?: string | undefined;
              onboardingCompletedAt?: string | undefined;
              creditCardOnFile: boolean;
              defaultListingLevel: SubscriptionType;
              addressLineOne?: string | undefined;
              addressLineTwo?: string | undefined;
              city?: string | undefined;
              countryOrRegionLongName?: string | undefined;
              stateOrProvinceLongName?: string | undefined;
              postalCode?: string | undefined;
              billingSubscription?: { currentPeriodEnd: string } | undefined;
              latestTask?:
                | {
                    id: string;
                    status: TaskStatus;
                    startedAt: string;
                    completedAt?: string | undefined;
                    importCount?: number | undefined;
                    importSuccessCount?: number | undefined;
                    importedAt?: string | undefined;
                    processedAt?: string | undefined;
                    finalizedAt?: string | undefined;
                    expiresAt?: string | undefined;
                    errors?: Array<string> | undefined;
                  }
                | undefined;
              listings: Array<{ id: string; name?: string | undefined }>;
              availableCoupon?:
                | {
                    promoCode?: string | undefined;
                    percentOff?: number | undefined;
                    applicableSubscriptions?:
                      | Array<SubscriptionType | undefined>
                      | undefined;
                    name: string;
                  }
                | undefined;
              policies: Array<
                | {
                    __typename: 'AccountCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | {
                    __typename: 'AccountTermsAndConditions';
                    termsLink?: string | undefined;
                  }
                | {
                    __typename: 'ListingCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | { __typename: 'ListingTermsAndConditions' }
              >;
              accountReviewSummaries: Array<{
                id: string;
                source: AccountReviewSummarySource;
                rating: number;
                numberOfReviews?: number | undefined;
                url?: string | undefined;
              }>;
            }
          | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          type?: string | undefined;
          message: string;
        }>;
      };
};

export type UserSessionRefreshMutationVariables = Exact<{
  input: UserSessionRefreshInput;
}>;

export type UserSessionRefreshMutation = {
  userSessionRefresh:
    | { __typename: 'BlockedError'; message: string }
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        accessToken?: string | undefined;
        email: string;
        firstName?: string | undefined;
        id: string;
        lastName?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        registeredAt?: string | undefined;
        lastAuthenticatedAt?: string | undefined;
      };
};

export type UserAccountRemoveMutationVariables = Exact<{
  input: UserAccountRemoveInput;
}>;

export type UserAccountRemoveMutation = {
  userAccountRemove:
    | { __typename: 'ConflictError'; message: string }
    | { __typename: 'NotFoundError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        avatarProcessing: boolean;
        accessToken?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        claimable: boolean;
        email: string;
        firstName?: string | undefined;
        id: string;
        identityVerified: boolean;
        verificationStatus?: VerificationStatus | undefined;
        travelerVerificationStatus?: VerificationStatus | undefined;
        lastAuthenticatedAt?: string | undefined;
        lastName?: string | undefined;
        dob?: string | undefined;
        paymentServiceUserId: string;
        phoneNumber?: string | undefined;
        phoneNumberVerified?: string | undefined;
        phoneNumberVerifiedAt?: string | undefined;
        referredByUserId?: string | undefined;
        registeredAt?: string | undefined;
        account?:
          | {
              id: string;
              isPpr: boolean;
              avatarUrl?: string | undefined;
              avatarFileName?: string | undefined;
              avatarUploadUrl?: string | undefined;
              avatarProcessing: boolean;
              heroUrl?: string | undefined;
              heroFileName?: string | undefined;
              heroUploadUrl?: string | undefined;
              heroProcessing: boolean;
              title?: string | undefined;
              companyName?: string | undefined;
              description?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              marketingWebsiteUrl?: string | undefined;
              homeownerMarketingUrl?: string | undefined;
              twitterUrl?: string | undefined;
              instagramUrl?: string | undefined;
              twitterHandle?: string | undefined;
              inBusinessSince?: number | undefined;
              bookDirectWebsiteUrl?: string | undefined;
              instagramUsername?: string | undefined;
              facebookPageUrl?: string | undefined;
              youtubeUrl?: string | undefined;
              linkedinUrl?: string | undefined;
              slug: string;
              insertedAt?: string | undefined;
              firstPublishedAt?: string | undefined;
              onboardingCompletedAt?: string | undefined;
              creditCardOnFile: boolean;
              defaultListingLevel: SubscriptionType;
              addressLineOne?: string | undefined;
              addressLineTwo?: string | undefined;
              city?: string | undefined;
              countryOrRegionLongName?: string | undefined;
              stateOrProvinceLongName?: string | undefined;
              postalCode?: string | undefined;
              billingSubscription?: { currentPeriodEnd: string } | undefined;
              latestTask?:
                | {
                    id: string;
                    status: TaskStatus;
                    startedAt: string;
                    completedAt?: string | undefined;
                    importCount?: number | undefined;
                    importSuccessCount?: number | undefined;
                    importedAt?: string | undefined;
                    processedAt?: string | undefined;
                    finalizedAt?: string | undefined;
                    expiresAt?: string | undefined;
                    errors?: Array<string> | undefined;
                  }
                | undefined;
              listings: Array<{ id: string; name?: string | undefined }>;
              availableCoupon?:
                | {
                    promoCode?: string | undefined;
                    percentOff?: number | undefined;
                    applicableSubscriptions?:
                      | Array<SubscriptionType | undefined>
                      | undefined;
                    name: string;
                  }
                | undefined;
              policies: Array<
                | {
                    __typename: 'AccountCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | {
                    __typename: 'AccountTermsAndConditions';
                    termsLink?: string | undefined;
                  }
                | {
                    __typename: 'ListingCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | { __typename: 'ListingTermsAndConditions' }
              >;
              accountReviewSummaries: Array<{
                id: string;
                source: AccountReviewSummarySource;
                rating: number;
                numberOfReviews?: number | undefined;
                url?: string | undefined;
              }>;
            }
          | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          type?: string | undefined;
          message: string;
        }>;
      };
};

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;

export type UserUpdateMutation = {
  userUpdate:
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        id: string;
        email: string;
        firstName?: string | undefined;
        lastName?: string | undefined;
        phoneNumber?: string | undefined;
        avatarUrl?: string | undefined;
        dob?: string | undefined;
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          message: string;
          type?: string | undefined;
          field?: string | undefined;
        }>;
      };
};

export type UserAndPmAccountCreateMutationVariables = Exact<{
  input: UserAndPmAccountCreateInput;
}>;

export type UserAndPmAccountCreateMutation = {
  userAndPmAccountCreate:
    | {
        __typename: 'UserAndPmAccountCreatePayload';
        pmsSoftware: string;
        numberOfListings: number;
        isUsBased: boolean;
        user: {
          refreshToken?: string | undefined;
          avatarUrl?: string | undefined;
          avatarProcessing: boolean;
          accessToken?: string | undefined;
          accountRole?: AccountRole | undefined;
          claimable: boolean;
          email: string;
          firstName?: string | undefined;
          id: string;
          identityVerified: boolean;
          verificationStatus?: VerificationStatus | undefined;
          travelerVerificationStatus?: VerificationStatus | undefined;
          lastAuthenticatedAt?: string | undefined;
          lastName?: string | undefined;
          paymentServiceUserId: string;
          phoneNumber?: string | undefined;
          referredByUserId?: string | undefined;
          registeredAt?: string | undefined;
        };
        account: { id: string; companyName?: string | undefined; slug: string };
        pmOnboardingSession: {
          id: string;
          accountId?: string | undefined;
          userId?: string | undefined;
          pmsType?: string | undefined;
          currentStepKey: PmOnboardingStepKey;
          status: PmOnboardingSessionStatus;
          reviewReason?: PmOnboardingReviewReason | undefined;
          publishedAt?: string | undefined;
          startedAt: string;
          completedAt?: string | undefined;
          lastActivityAt: string;
          currentStepIndex: number;
          totalSteps: number;
          completedStepKeys: Array<PmOnboardingStepKey>;
          canAdvance: boolean;
          flow: {
            id: string;
            version: string;
            name: string;
            description?: string | undefined;
            isActive: boolean;
            totalSteps: number;
            steps: Array<{
              stepKey: PmOnboardingStepKey;
              position: number;
              label: string;
              required: boolean;
            }>;
          };
          stepCompletions: Array<{
            stepKey: PmOnboardingStepKey;
            completedAt: string;
          }>;
          account?:
            | {
                id: string;
                isUsBased?: boolean | undefined;
                countryOrRegionLongName?: string | undefined;
              }
            | undefined;
        };
      }
    | {
        __typename: 'ValidationErrorCollection';
        errors: Array<{
          field?: string | undefined;
          message: string;
          type?: string | undefined;
        }>;
      };
};

export type TermsOfUseStatusQueryVariables = Exact<{ [key: string]: never }>;

export type TermsOfUseStatusQuery = {
  currentUser:
    | { __typename: 'UnauthenticatedError' }
    | {
        __typename: 'User';
        id: string;
        accountRole?: AccountRole | undefined;
        lastAuthenticatedAt?: string | undefined;
        account?:
          | {
              id: string;
              commissionable?: boolean | undefined;
              termsOfUseAcceptedAt?: string | undefined;
            }
          | undefined;
      };
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser:
    | { __typename: 'UnauthenticatedError'; message: string }
    | {
        __typename: 'User';
        avatarUrl?: string | undefined;
        avatarProcessing: boolean;
        accessToken?: string | undefined;
        refreshToken?: string | undefined;
        accountRole?: AccountRole | undefined;
        claimable: boolean;
        email: string;
        firstName?: string | undefined;
        id: string;
        identityVerified: boolean;
        verificationStatus?: VerificationStatus | undefined;
        travelerVerificationStatus?: VerificationStatus | undefined;
        lastAuthenticatedAt?: string | undefined;
        lastName?: string | undefined;
        dob?: string | undefined;
        paymentServiceUserId: string;
        phoneNumber?: string | undefined;
        phoneNumberVerified?: string | undefined;
        phoneNumberVerifiedAt?: string | undefined;
        referredByUserId?: string | undefined;
        registeredAt?: string | undefined;
        account?:
          | {
              id: string;
              isPpr: boolean;
              avatarUrl?: string | undefined;
              avatarFileName?: string | undefined;
              avatarUploadUrl?: string | undefined;
              avatarProcessing: boolean;
              heroUrl?: string | undefined;
              heroFileName?: string | undefined;
              heroUploadUrl?: string | undefined;
              heroProcessing: boolean;
              title?: string | undefined;
              companyName?: string | undefined;
              description?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              marketingWebsiteUrl?: string | undefined;
              homeownerMarketingUrl?: string | undefined;
              twitterUrl?: string | undefined;
              instagramUrl?: string | undefined;
              twitterHandle?: string | undefined;
              inBusinessSince?: number | undefined;
              bookDirectWebsiteUrl?: string | undefined;
              instagramUsername?: string | undefined;
              facebookPageUrl?: string | undefined;
              youtubeUrl?: string | undefined;
              linkedinUrl?: string | undefined;
              slug: string;
              insertedAt?: string | undefined;
              firstPublishedAt?: string | undefined;
              onboardingCompletedAt?: string | undefined;
              creditCardOnFile: boolean;
              defaultListingLevel: SubscriptionType;
              addressLineOne?: string | undefined;
              addressLineTwo?: string | undefined;
              city?: string | undefined;
              countryOrRegionLongName?: string | undefined;
              stateOrProvinceLongName?: string | undefined;
              postalCode?: string | undefined;
              billingSubscription?: { currentPeriodEnd: string } | undefined;
              latestTask?:
                | {
                    id: string;
                    status: TaskStatus;
                    startedAt: string;
                    completedAt?: string | undefined;
                    importCount?: number | undefined;
                    importSuccessCount?: number | undefined;
                    importedAt?: string | undefined;
                    processedAt?: string | undefined;
                    finalizedAt?: string | undefined;
                    expiresAt?: string | undefined;
                    errors?: Array<string> | undefined;
                  }
                | undefined;
              listings: Array<{ id: string; name?: string | undefined }>;
              availableCoupon?:
                | {
                    promoCode?: string | undefined;
                    percentOff?: number | undefined;
                    applicableSubscriptions?:
                      | Array<SubscriptionType | undefined>
                      | undefined;
                    name: string;
                  }
                | undefined;
              policies: Array<
                | {
                    __typename: 'AccountCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | {
                    __typename: 'AccountTermsAndConditions';
                    termsLink?: string | undefined;
                  }
                | {
                    __typename: 'ListingCancellationPolicy';
                    cancellationPolicy: string;
                  }
                | { __typename: 'ListingTermsAndConditions' }
              >;
              accountReviewSummaries: Array<{
                id: string;
                source: AccountReviewSummarySource;
                rating: number;
                numberOfReviews?: number | undefined;
                url?: string | undefined;
              }>;
            }
          | undefined;
      };
};

export const AccountActionLinkFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountActionLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountActionLink' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAcceptTermsOfUse' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAddCreditCard' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'termsOfUseVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authorizationStatement' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountActionLinkFieldsFragment, unknown>;
export const PublicAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublicAccountFieldsFragment, unknown>;
export const PrivateAccountFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrivateAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pmsSoftware' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportedPmsSoftware' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfClaimedListings' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeListingsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salesforceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardingCompleted' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardingCompletedAt' },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'PublicAccountFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrivateAccountFieldsFragment, unknown>;
export const PrivateAccountIndexFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrivateAccountIndexFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'pmsSoftware' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportedPmsSoftware' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsConnection' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'failingSince' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'options' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'maskedCredentials' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'numberOfClaimedListings' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeListingsCount' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stripeCustomerId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creditCardOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'salesforceUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardingCompleted' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardingCompletedAt' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastPublishedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstPublishedAt' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listingLevel' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billingSubscription' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentPeriodEnd' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'latestTask' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'importSuccessCount' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'importedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalizedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'PublicAccountFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrivateAccountIndexFieldsFragment, unknown>;
export const ListingFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListingFieldsFragment, unknown>;
export const OwnerListingFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OwnerListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineOne' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineTwo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsLink' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLng' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerListingFieldsFragment, unknown>;
export const HomePageListingFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HomePageListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageSavings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceDisplay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseAmountCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotalWithoutTaxesCents' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewsAverageRating' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAvailability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomePageListingFieldsFragment, unknown>;
export const FourthOfJulyListingFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FourthOfJulyListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageSavings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceDisplay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseAmountCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotalWithoutTaxesCents' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewsAverageRating' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAvailability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FourthOfJulyListingFieldsFragment, unknown>;
export const PmOnboardingFlowStepFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmOnboardingFlowStepFieldsFragment, unknown>;
export const PmOnboardingFlowFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmOnboardingFlowFieldsFragment, unknown>;
export const PmOnboardingStepCompletionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmOnboardingStepCompletionFieldsFragment, unknown>;
export const PmOnboardingSessionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmOnboardingSessionFieldsFragment, unknown>;
export const PmsConnectionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PmsConnectionFieldsFragment, unknown>;
export const UserFieldsWithAccountFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFieldsWithAccount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerified' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPpr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homeownerMarketingUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twitterHandle' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inBusinessSince' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUsername' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookPageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstPublishedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingCompletedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditCardOnFile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultListingLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingSubscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPeriodEnd' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importSuccessCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineOne' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineTwo' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stateOrProvinceLongName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountTermsAndConditions',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'termsLink' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ListingCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountReviewSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfReviews' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFieldsWithAccountFragment, unknown>;
export const UserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const UserSessionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSessionFieldsFragment, unknown>;
export const AccountActionLinkAcceptTermsOfUseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountActionLinkAcceptTermsOfUse' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'title' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isAuthorized' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'termsOfUseVersion' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountActionLinkAcceptTermsOfUse' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'title' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isAuthorized' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'isAuthorized' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'termsOfUseVersion' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'termsOfUseVersion' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountActionLinkFields' },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnprocessableContentError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountActionLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountActionLink' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAcceptTermsOfUse' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAddCreditCard' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'termsOfUseVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authorizationStatement' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountActionLinkAcceptTermsOfUseMutation,
  AccountActionLinkAcceptTermsOfUseMutationVariables
>;
export const AccountActionLinkRequestNewLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountActionLinkRequestNewLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountActionLinkRequestNewLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'AccountActionLinkNewLinkSent',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnprocessableContentError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountActionLinkRequestNewLinkMutation,
  AccountActionLinkRequestNewLinkMutationVariables
>;
export const AccountActionLinkCreateCardSetupSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountActionLinkCreateCardSetupSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'accountActionLinkCreateCardSetupSession',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CardSetupSession' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnprocessableContentError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountActionLinkCreateCardSetupSessionMutation,
  AccountActionLinkCreateCardSetupSessionMutationVariables
>;
export const AccountActionLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountActionLink' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountActionLink' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountActionLinkFields' },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnprocessableContentError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reason' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountActionLinkFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountActionLink' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAcceptTermsOfUse' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shouldAddCreditCard' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'termsOfUseVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authorizationStatement' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountActionLinkQuery,
  AccountActionLinkQueryVariables
>;
export const AccountReviewSummaryCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountReviewSummaryCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountReviewSummaryCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaryCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountReviewSummary' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'imageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfReviews' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountReviewSummaryCreateMutation,
  AccountReviewSummaryCreateMutationVariables
>;
export const PmAccountCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PmAccountCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PmAccountCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmAccountCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isUsBased' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmOnboardingSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'PmOnboardingSessionFields',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PmAccountCreateMutation,
  PmAccountCreateMutationVariables
>;
export const AccountUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmsSoftware' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportedPmsSoftware' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'numberOfClaimedListings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeListingsCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressLineOne' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressLineTwo' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'countryOrRegionLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PublicAccountFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountUpdateMutation,
  AccountUpdateMutationVariables
>;
export const AccountAcceptTermsOfUseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountAcceptTermsOfUse' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountAcceptTermsOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commissionable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsOfUseAcceptedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountAcceptTermsOfUseMutation,
  AccountAcceptTermsOfUseMutationVariables
>;
export const CreateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateSubscriptionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConflictError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;
export const SetSubscriptionCouponDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetSubscriptionCoupon' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetSubscriptionCouponInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setSubscriptionCoupon' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetSubscriptionCouponMutation,
  SetSubscriptionCouponMutationVariables
>;
export const AccountUpdateAllListingSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountUpdateAllListingSubscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'AccountUpdateAllListingSubscriptionsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'accountUpdateAllListingSubscriptions',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountBulkUpdateResults' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'successCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'failureCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountUpdateAllListingSubscriptionsMutation,
  AccountUpdateAllListingSubscriptionsMutationVariables
>;
export const AccountBulkUpdateLocationObfuscatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountBulkUpdateLocationObfuscated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'AccountBulkUpdateLocationObfuscatedInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'accountBulkUpdateLocationObfuscated',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountBulkUpdateResults' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'successCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'failureCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountBulkUpdateLocationObfuscatedMutation,
  AccountBulkUpdateLocationObfuscatedMutationVariables
>;
export const AccountSetDefaultListingLevelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AccountSetDefaultListingLevel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'defaultListingLevel' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubscriptionType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountSetDefaultListingLevel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'defaultListingLevel' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'defaultListingLevel' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultListingLevel' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountSetDefaultListingLevelMutation,
  AccountSetDefaultListingLevelMutationVariables
>;
export const AccountsListRandomDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountsListRandom' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountsListRandom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarProcessing' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'heroUploadUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'heroProcessing' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'homeownerMarketingUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'twitterUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'instagramUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'twitterHandle' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'instagramUsername',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facebookPageUrl' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'activeListingsCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inBusinessSince' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'bookDirectWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'youtubeUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'linkedinUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'accountReviewSummaries',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'source' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sourceId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfReviews',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rating' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsListRandomQuery,
  AccountsListRandomQueryVariables
>;
export const AccountByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PublicAccountFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountByIdQuery, AccountByIdQueryVariables>;
export const AccountBySlugDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PublicAccountFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountBySlugQuery, AccountBySlugQueryVariables>;
export const AccountForCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountForCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountForCurrentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Account' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onboardingCompletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmsSoftware' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportedPmsSoftware' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPpr' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'creditCardOnFile' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultListingLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latestTask' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'importCount' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'importSuccessCount',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmOnboardingSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'PmOnboardingSessionFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PublicAccountFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PublicAccountFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Account' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heroFileName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUploadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heroProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'homeownerMarketingUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inBusinessSince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountReviewSummaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfReviews' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountForCurrentUserQuery,
  AccountForCurrentUserQueryVariables
>;
export const AccountsListAllActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountsListAllActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchQuery' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stateOrProvinceLongNameFilter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchQuery' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stateOrProvinceLongNameFilter' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'stateOrProvinceLongNameFilter',
                  },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarProcessing' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'heroUploadUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'heroProcessing' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'homeownerMarketingUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'twitterUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'instagramUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'twitterHandle' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'instagramUsername',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facebookPageUrl' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'activeListingsCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inBusinessSince' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'bookDirectWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'youtubeUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'linkedinUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'accountReviewSummaries',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'source' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sourceId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfReviews',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rating' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountsListAllActiveQuery,
  AccountsListAllActiveQueryVariables
>;
export const AffiliationFindOrCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AffiliationFindOrCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AffiliationFindOrCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliationFindOrCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Affiliation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AffiliationFindOrCreateMutation,
  AffiliationFindOrCreateMutationVariables
>;
export const AffiliationDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AffiliationDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AffiliationDeleteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliationDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Affiliation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AffiliationDeleteMutation,
  AffiliationDeleteMutationVariables
>;
export const AffiliationSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AffiliationSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AffiliationTypeFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listingId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliationSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'type' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'listingId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AffiliationCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AffiliationSearchQuery,
  AffiliationSearchQueryVariables
>;
export const BlogPostsListAllFeaturedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BlogPostsListAllFeatured' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blogPostsListAllFeatured' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BlogPostsListAllFeaturedQuery,
  BlogPostsListAllFeaturedQueryVariables
>;
export const BookingQuoteByListingAndDatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BookingQuoteByListingAndDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkInDate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkOutDate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adultCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'childCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'infantCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'petCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingQuoteByListingAndDates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adultCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'adultCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'childCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'childCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'infantCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'infantCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'petCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'petCount' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BookingQuote' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listing' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'priceDisplay' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'checkInDate' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkInDate',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'checkOutDate' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkOutDate',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'pets' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'petCount' },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'guests' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'adultCount' },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'subtotalWithoutTaxesCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'baseAmountCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nights' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listingId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCostCents' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalRecoverableCostCents',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalWithoutTaxesCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkInDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkOutDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iframeBookingUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quoteItems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'costCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dueDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentItemType' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BookingQuoteUnavailable' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookingQuoteByListingAndDatesQuery,
  BookingQuoteByListingAndDatesQueryVariables
>;
export const SetAccountCardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAccountCard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAccountCard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stripeTokenId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Card' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressZip' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expMonth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expYear' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthorizedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAccountCardMutation,
  SetAccountCardMutationVariables
>;
export const CardsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CardsListAll' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cardsListAll' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CardCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressZip' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'last4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expMonth' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expYear' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardsListAllQuery, CardsListAllQueryVariables>;
export const AccountCardsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountCardsListAll' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountCardsListAll' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CardCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressZip' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'last4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expMonth' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'expYear' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthorizedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCardsListAllQuery,
  AccountCardsListAllQueryVariables
>;
export const ReservationCommissionSummaryForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationCommissionSummaryForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billingMonth' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'reservationCommissionSummaryForAccount',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingMonth' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billingMonth' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ReservationCommissionSummary',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingMonth' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'periodStart' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'periodEnd' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookingCount' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'commissionableBookingValueCents',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grossCommissionCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adjustmentCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'statementAvailable' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationCommissionSummaryForAccountQuery,
  ReservationCommissionSummaryForAccountQueryVariables
>;
export const ReservationCommissionStatementForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationCommissionStatementForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billingMonth' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'reservationCommissionStatementForAccount',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingMonth' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billingMonth' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ReservationCommissionStatement',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationCommissionStatementForAccountQuery,
  ReservationCommissionStatementForAccountQueryVariables
>;
export const ReservationCommissionActivityExportForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'ReservationCommissionActivityExportForAccount',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billingMonth' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReservationCommissionKind' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReservationCommissionStatuses' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'reservationCommissionActivityExportForAccount',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingMonth' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billingMonth' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kind' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kind' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ReservationCommissionActivityExport',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationCommissionActivityExportForAccountQuery,
  ReservationCommissionActivityExportForAccountQueryVariables
>;
export const ReservationCommissionListAllForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationCommissionListAllForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'billingMonth' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReservationCommissionKind' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ReservationCommissionStatuses' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'search' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'reservationCommissionListAllForAccount',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'billingMonth' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'billingMonth' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kind' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kind' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'search' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ReservationCommissionCollection',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commissionCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commissionRate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'confirmedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reservation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'externalReservationId',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'travelerFirstName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'travelerLastName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'totalCostCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'listing' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'city' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'stateOrProvinceLongName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCommissionCents' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationCommissionListAllForAccountQuery,
  ReservationCommissionListAllForAccountQueryVariables
>;
export const ComparisonQuoteByListingAndDatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ComparisonQuoteByListingAndDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'quoteId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkInDate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkOutDate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalListingUrl' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfAdults' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfChildren' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfInfants' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'numberOfPets' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'priceType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PriceType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'comparisonQuoteByListingAndDates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quoteId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'quoteId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalListingUrl' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalListingUrl' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAdults' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfAdults' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfChildren' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfChildren' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfInfants' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfInfants' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfPets' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'numberOfPets' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'priceType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'priceType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ComparisonQuote' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkInDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkOutDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalListingId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalSource' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfAdults' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfChildren' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfInfants' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfPets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceCents' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnprocessableContentError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ComparisonQuoteByListingAndDatesQuery,
  ComparisonQuoteByListingAndDatesQueryVariables
>;
export const CouponFindAvailableForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CouponFindAvailableForAccount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'couponFindAvailableForAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Coupon' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountOffCents' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CouponFindAvailableForAccountQuery,
  CouponFindAvailableForAccountQueryVariables
>;
export const CouponFindByPromoCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CouponFindByPromoCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'promoCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'couponFindByPromoCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'promoCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'promoCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Coupon' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountOffCents' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CouponFindByPromoCodeQuery,
  CouponFindByPromoCodeQueryVariables
>;
export const CouponFindForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CouponFindForAccount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'couponFindForAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Coupon' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountOffCents' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CouponFindForAccountQuery,
  CouponFindForAccountQueryVariables
>;
export const EmailVerificationUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmailVerificationUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'token' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailVerificationUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'token' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EmailVerificationMessage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EmailVerificationUpdateMutation,
  EmailVerificationUpdateMutationVariables
>;
export const FeaturesListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeaturesListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PropertyType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featuresListAll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'propertyType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FeaturesListAllQuery,
  FeaturesListAllQueryVariables
>;
export const FeaturesListAllForSearchFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeaturesListAllForSearchFilters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featuresListAllForSearchFilters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FeaturesListAllForSearchFiltersQuery,
  FeaturesListAllForSearchFiltersQueryVariables
>;
export const GalleryAssetCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GalleryAssetCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GalleryAssetCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetCreateMutation,
  GalleryAssetCreateMutationVariables
>;
export const GalleryAssetDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GalleryAssetDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GalleryAssetDeleteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetDeleteMutation,
  GalleryAssetDeleteMutationVariables
>;
export const GalleryAssetOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GalleryAssetOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GalleryAssetOrderInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetOrderMutation,
  GalleryAssetOrderMutationVariables
>;
export const GalleryAssetUpdateImageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GalleryAssetUpdateImage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GalleryAssetUpdateImageInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetUpdateImage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetUpdateImageMutation,
  GalleryAssetUpdateImageMutationVariables
>;
export const GalleryAssetUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GalleryAssetUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GalleryAssetUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetUpdateMutation,
  GalleryAssetUpdateMutationVariables
>;
export const GalleryAssetByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GalleryAssetById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssetById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GalleryAsset' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'position' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GalleryAssetByIdQuery,
  GalleryAssetByIdQueryVariables
>;
export const IdentityVerificationCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'IdentityVerificationCreate' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCreate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'IdentityVerificationInquiryResult',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personaInquiryId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sessionToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IdentityVerificationCreateMutation,
  IdentityVerificationCreateMutationVariables
>;
export const TravelerIdentityVerificationCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TravelerIdentityVerificationCreate' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerIdentityVerificationCreate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'TravelerIdentityVerificationInquiryResult',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personaInquiryId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sessionToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TravelerIdentityVerificationCreateMutation,
  TravelerIdentityVerificationCreateMutationVariables
>;
export const TravelerVerificationStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelerVerificationStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'travelerVerificationStatus',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TravelerVerificationStatusQuery,
  TravelerVerificationStatusQueryVariables
>;
export const CurrentInnkeeperDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentInnkeeper' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentInnkeeper' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Innkeeper' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accessToken' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'claimable' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityVerified' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'referredByUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registeredAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CurrentInnkeeperQuery,
  CurrentInnkeeperQueryVariables
>;
export const CreateLeadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateLead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateLeadInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LeadCreatedMessage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLeadMutation, CreateLeadMutationVariables>;
export const ListingBookingInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingBookingInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingBookingInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingBookingInfo' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'availabilityDates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'available' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkInAllowed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkOutAllowed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minNights' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maxNights' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingBookingInfoQuery,
  ListingBookingInfoQueryVariables
>;
export const ListingReviewSummariesListAllForListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingReviewSummariesListAllForListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'listingReviewSummariesListAllForListing',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ListingReviewSummaryCollection',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'source' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'averageRating' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingReviewSummariesListAllForListingQuery,
  ListingReviewSummariesListAllForListingQueryVariables
>;
export const ListingReviewsListAllForListingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingReviewsListAllForListing' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ListingReviewSortOptions' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchQuery' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingReviewsListAllForListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchQuery' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingReviewCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rating' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'body' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'authorName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingReviewsListAllForListingQuery,
  ListingReviewsListAllForListingQueryVariables
>;
export const ListingUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OwnerListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OwnerListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineOne' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineTwo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsLink' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLng' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingUpdateMutation,
  ListingUpdateMutationVariables
>;
export const ListingPublishDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingPublish' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingPublishInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingPublish' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OwnerListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OwnerListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineOne' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineTwo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsLink' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLng' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingPublishMutation,
  ListingPublishMutationVariables
>;
export const ListingUnpublishDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingUnpublish' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listingId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingUnpublish' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'listingId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OwnerListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OwnerListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineOne' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineTwo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsLink' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLng' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingUnpublishMutation,
  ListingUnpublishMutationVariables
>;
export const SetSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetSubscriptionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetSubscriptionMutation,
  SetSubscriptionMutationVariables
>;
export const ListingCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingCreateMutation,
  ListingCreateMutationVariables
>;
export const ListingFavoriteCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingFavoriteCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingFavoriteCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingFavoriteCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingFavoriteCreateMutation,
  ListingFavoriteCreateMutationVariables
>;
export const ListingFavoriteDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingFavoriteDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingFavoriteDeleteInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingFavoriteDelete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingFavoriteDeleteMutation,
  ListingFavoriteDeleteMutationVariables
>;
export const ListingToggleFeaturedByOwnerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ListingToggleFeaturedByOwner' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listingId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingToggleFeaturedByOwner' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listingId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'listingId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingToggleFeaturedByOwnerMutation,
  ListingToggleFeaturedByOwnerMutationVariables
>;
export const AccountCollectionListingsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountCollectionListingsListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '20' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'applyFeaturedByOwnerFilter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ListingSortOptions' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkInDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkOutDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'featuresFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FeatureKey' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minGuestCapacity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBathrooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBeds' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfRooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PropertyType' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applyFeaturedByOwnerFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applyFeaturedByOwnerFilter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featuresFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'featuresFilter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minGuestCapacity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minGuestCapacity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBeds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBeds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfRooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfRooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'propertyTypes' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkIn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkout' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfRooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfBathrooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestCapacity' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniquePropertyType' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageSavings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'galleryAssets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'numberOfAssets' },
                            value: { kind: 'IntValue', value: '10' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'processing' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'features' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categoryName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'promoted' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listingLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDiamondCollection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFavorited' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchableAvailability' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featuredByOwner' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountCollectionListingsListAllQuery,
  AccountCollectionListingsListAllQueryVariables
>;
export const AccountActiveListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'accountActiveListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestCapacity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfRooms' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountActiveListingsQuery,
  AccountActiveListingsQueryVariables
>;
export const DiamondCollectionListingsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DiamondCollectionListingsListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '20' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stateOrProvinceLongNameFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'EnumValue',
                  value: 'STATE_OR_PROVINCE_LONG_NAME_ASC',
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stateOrProvinceLongNameFilter' },
                value: {
                  kind: 'Variable',
                  name: {
                    kind: 'Name',
                    value: 'stateOrProvinceLongNameFilter',
                  },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'onlyDiamondCollection' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listedFloor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfRooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfBathrooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestCapacity' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniquePropertyType' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFavorited' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageSavings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listingLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDiamondCollection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'features' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categoryName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'promoted' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'galleryAssets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'numberOfAssets' },
                            value: { kind: 'IntValue', value: '10' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'processing' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchableAvailability' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DiamondCollectionListingsListAllQuery,
  DiamondCollectionListingsListAllQueryVariables
>;
export const SearchRegionForListingsByPlaceNameWithSingleAssetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'searchRegionForListingsByPlaceNameWithSingleAsset',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursorAfter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursorBefore' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '30' },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'featuresFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FeatureKey' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PropertyType' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minGuestCapacity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfRooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBathrooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBeds' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'regionPath' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'regionListingsCollection' },
            name: { kind: 'Name', value: 'listingsSearchAllActiveForPlace' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursorAfter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursorAfter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursorBefore' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursorBefore' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'propertyTypes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minGuestCapacity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minGuestCapacity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfRooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfRooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBeds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBeds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featuresFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'featuresFilter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'regionPath' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'regionPath' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfRooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfBathrooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestCapacity' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageSavings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'galleryAssets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'numberOfAssets' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'processing' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'priceDisplay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkInDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkOutDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'baseAmountCents' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'subtotalWithoutTaxesCents',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nights' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listingLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDiamondCollection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFavorited' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchableAvailability' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchRegionForListingsByPlaceNameWithSingleAssetQuery,
  SearchRegionForListingsByPlaceNameWithSingleAssetQueryVariables
>;
export const ListingByExternalIdAndSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingByExternalIdAndSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalSource' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExternalSource' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingByExternalIdAndSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalSource' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalSource' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingByExternalIdAndSourceQuery,
  ListingByExternalIdAndSourceQueryVariables
>;
export const ListingBySlugDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressLineOne' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'airbnbUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vrboUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'bookDirectWebsiteUrlParamsTemplate',
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkIn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkout' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licenseNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listedFloor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfFloors' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfRooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfBathrooms' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'guestCapacity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniquePropertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'facebookPageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hostBio' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hostDisplayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hostImageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instagramUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationObfuscated' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'published' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pinterestUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicPhoneNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'countryOrRegionLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'twitterUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'youtubeUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'regions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'path' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'galleryAssets' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'numberOfAssets' },
                            value: { kind: 'IntValue', value: '100' },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'processing' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rawUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'features' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'legacyKey' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'promoted' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categoryName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affiliations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listingLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDiamondCollection' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatarUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'inBusinessSince' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'activeListingsCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'facebookPageUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'instagramUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'twitterUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'linkedinUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'youtubeUrl' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'accountReviewSummaries',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'source' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sourceId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfReviews',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'imageUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rating' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFavorited' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportsQuotes' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportsBookings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportsIframeBooking' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchableAvailability' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'indexable' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ose' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'AccountTermsAndConditions',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'termsLink' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'AccountCancellationPolicy',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cancellationPolicy',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'ListingCancellationPolicy',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cancellationPolicy',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsAndConditionsLink' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsAndConditionsText' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviews' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'numberOfReviews' },
                            value: { kind: 'IntValue', value: '5' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'body' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rating' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'authorName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'date' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewsAverageRating' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewsCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reviewSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfBeds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rooms' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'index' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beds' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingArchivedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingUnpublishedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListingBySlugQuery, ListingBySlugQueryVariables>;
export const ListingByIdAndUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingByIdAndUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingByIdAndUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Listing' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OwnerListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OwnerListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineOne' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'preciseAddressLineTwo' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsLink' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preciseLng' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingByIdAndUserQuery,
  ListingByIdAndUserQueryVariables
>;
export const AccountListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AccountListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchQuery' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchQuery' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ListingFields' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineOne' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLineTwo' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affiliations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancellationPolicy' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'checkIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkout' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfFloors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listedFloor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostImageProcessing' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countryOrRegionLongName' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentBalanceCents' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebookPageUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hostBio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostDisplayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hostImageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagramUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastPublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unpublishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licenseNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationObfuscated' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSetManually' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinterestUsername' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wNineOnFile' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitterHandle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'published' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishIpAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicPhoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredByOwner' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountListingsQuery,
  AccountListingsQueryVariables
>;
export const ListingsListAllFavoritedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listingsListAllFavorited' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingFavoriteSortOptions' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllFavorited' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'companyName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lng' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'locationObfuscated',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfRooms' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'numberOfBathrooms',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'guestCapacity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'bookDirectWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maxPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'averageSavings' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'galleryAssets' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'numberOfAssets',
                                  },
                                  value: { kind: 'IntValue', value: '10' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'processing' },
                                  value: { kind: 'BooleanValue', value: false },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listingLevel' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isDiamondCollection',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isFavorited' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'searchableAvailability',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingsListAllFavoritedQuery,
  ListingsListAllFavoritedQueryVariables
>;
export const ListingsSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingsSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'centerLat' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'centerLng' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'features' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FeatureKey' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PropertyType' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uniquePropertyTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UniquePropertyType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minGuestCapacity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfRooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBathrooms' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minNumberOfBeds' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minPriceCents' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'maxPriceCents' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'northEastLat' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'northEastLng' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursorAfter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cursorBefore' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'placeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ListingsSearchType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'southWestLat' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'southWestLng' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkInDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkOutDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'petCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ListingSortOptions' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'centerLat' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'centerLat' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'centerLng' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'centerLng' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featuresFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'features' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'propertyTypes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'uniquePropertyTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'uniquePropertyTypes' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minGuestCapacity' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minGuestCapacity' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfRooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfRooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBathrooms' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minPriceCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minPriceCents' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maxPriceCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'maxPriceCents' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minNumberOfBeds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minNumberOfBeds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'northEastLat' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'northEastLat' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'northEastLng' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'northEastLng' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursorAfter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursorAfter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cursorBefore' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cursorBefore' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'placeId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'southWestLat' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'southWestLat' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'southWestLng' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'southWestLng' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'petCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'petCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ListingSearchCursorCollection',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'companyName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lng' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'locationObfuscated',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'uniquePropertyType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfRooms' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'numberOfBathrooms',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'guestCapacity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'bookDirectWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maxPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'averageSavings' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'priceDisplay' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'checkInDate' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkInDate',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'checkOutDate' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkOutDate',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'pets' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'petCount' },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'guests' },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'minGuestCapacity',
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkInDate',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkOutDate',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'baseAmountCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'subtotalWithoutTaxesCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nights' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'searchPromotionType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'key' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'categoryName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'promoted' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'galleryAssets' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'numberOfAssets',
                                  },
                                  value: { kind: 'IntValue', value: '10' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'processing' },
                                  value: { kind: 'BooleanValue', value: false },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listingLevel' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isDiamondCollection',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isFavorited' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'searchableAvailability',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'reviewsAverageRating',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reviewsCount' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadata' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursorAfter' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursorBefore' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchPlace' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'geometry' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'centerPoint',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lat' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lng' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'northEastPoint',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lat' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lng' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'southWestPoint',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lat' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'lng' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListingsSearchQuery, ListingsSearchQueryVariables>;
export const ListingsListAllIndexableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListingsListAllIndexable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllIndexable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListingsListAllIndexableQuery,
  ListingsListAllIndexableQueryVariables
>;
export const HomePageListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HomePageListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '12' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsHomePage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'featured' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HomePageListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'highlyRated' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HomePageListingFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trending' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HomePageListingFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HomePageListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageSavings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceDisplay' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseAmountCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotalWithoutTaxesCents' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewsAverageRating' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAvailability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HomePageListingsQuery,
  HomePageListingsQueryVariables
>;
export const FourthOfJulyContainerListingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FourthOfJulyContainerListings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'featuresFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FeatureKey' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'featuresFilterAny' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'FeatureKey' },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minAverageSavings' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'maxAverageSavings' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minPricingStatsCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkInDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkOutDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '50' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ListingSortOptions' },
          },
          defaultValue: { kind: 'EnumValue', value: 'SAVINGS_DESC' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featuresFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'featuresFilter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'featuresFilterAny' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'featuresFilterAny' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minAverageSavings' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minAverageSavings' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maxAverageSavings' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'maxAverageSavings' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'minPricingStatsCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'minPricingStatsCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sort' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'FourthOfJulyListingFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FourthOfJulyListingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Listing' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stateOrProvinceLongName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uniquePropertyType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'guestCapacity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfRooms' } },
          { kind: 'Field', name: { kind: 'Name', value: 'numberOfBathrooms' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketingWebsiteUrl' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'minPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'maxPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageSavings' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceDisplay' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkInDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkInDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkOutDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'baseAmountCents' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subtotalWithoutTaxesCents' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nights' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkOutDate' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewsAverageRating' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryAssets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'numberOfAssets' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'processing' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categoryName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'promoted' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFavorited' } },
          { kind: 'Field', name: { kind: 'Name', value: 'listingLevel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAvailability' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isDiamondCollection' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FourthOfJulyContainerListingsQuery,
  FourthOfJulyContainerListingsQueryVariables
>;
export const SubscribeEmailToNewsletterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubscribeEmailToNewsletter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscribeEmailToNewsletter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NewsletterSubscription' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeEmailToNewsletterMutation,
  SubscribeEmailToNewsletterMutationVariables
>;
export const SubscribeEmailToIosWaitlistDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubscribeEmailToIosWaitlist' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscribeEmailToIosWaitlist' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'IosWaitlistSubscription' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscribeEmailToIosWaitlistMutation,
  SubscribeEmailToIosWaitlistMutationVariables
>;
export const UserAddReferralCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserAddReferralCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'referralCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAddReferralCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referralCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'referralCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserAddReferralCodeMutation,
  UserAddReferralCodeMutationVariables
>;
export const OrderLoadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OrderLoad' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OrderLoadInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderLoad' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Order' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'quote' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkInDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'checkOutDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listingId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfAdults' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfChildren' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfInfants' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfPets' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCostCents' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'totalWithoutTaxesCents',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'totalRecoverableCostCents',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'quoteItems' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'costCents' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentSchedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dueDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'amountCents',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'paymentItemType',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrderUnavailable' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrderUnsupported' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderLoadMutation, OrderLoadMutationVariables>;
export const SendPasswordResetEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPasswordResetEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SendPasswordResetEmailInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendPasswordResetEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PasswordResetMessage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
>;
export const ResetPasswordForTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPasswordForToken' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetPasswordForTokenInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPasswordForToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PasswordResetMessage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPasswordForTokenMutation,
  ResetPasswordForTokenMutationVariables
>;
export const ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ResetPasswordInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PasswordResetMessage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const PhoneVerificationStartDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PhoneVerificationStart' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PhoneVerificationStartInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneVerificationStart' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumberVerified' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PhoneVerificationStartMutation,
  PhoneVerificationStartMutationVariables
>;
export const PhoneVerificationCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PhoneVerificationCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PhoneVerificationCheckInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneVerificationCheck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumberVerified' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ServiceUnavailableError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PhoneVerificationCheckMutation,
  PhoneVerificationCheckMutationVariables
>;
export const PlacesAutocompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlacesAutocomplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PlaceTypeFilter' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placesAutocomplete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'placeTypeFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'type' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlacesAutocompleteQuery,
  PlacesAutocompleteQueryVariables
>;
export const PlaceFindByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlaceFindById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Place' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressLineOne' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addressLineTwo' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'countryOrRegionLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'countryOrRegionShortName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'geometry' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'centerPoint' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lat' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lng' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'northEastPoint' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lat' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lng' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'southWestPoint' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lat' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lng' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingValue' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ratingValueMax' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawAddressComponents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'longName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'shortName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'types' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rawTypes' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceLongName',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stateOrProvinceShortName',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlaceFindByIdQuery, PlaceFindByIdQueryVariables>;
export const PlaceSearchGeometryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlaceSearchGeometry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'placeSearchGeometry' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'centerPoint' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'northEastPoint' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'southWestPoint' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlaceSearchGeometryQuery,
  PlaceSearchGeometryQueryVariables
>;
export const PlansListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PlansListAll' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plansListAll' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PlanCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlansListAllQuery, PlansListAllQueryVariables>;
export const PmOnboardingCompleteStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PmOnboardingCompleteStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PmOnboardingCompleteStepInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmOnboardingCompleteStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmOnboardingSession' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PmOnboardingSessionFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PmOnboardingCompleteStepMutation,
  PmOnboardingCompleteStepMutationVariables
>;
export const PmOnboardingNavigateToStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PmOnboardingNavigateToStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sessionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'stepKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PmOnboardingStepKey' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmOnboardingNavigateToStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sessionId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stepKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'stepKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmOnboardingSession' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PmOnboardingSessionFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PmOnboardingNavigateToStepMutation,
  PmOnboardingNavigateToStepMutationVariables
>;
export const MyPmOnboardingSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyPmOnboardingSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPmOnboardingSession' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmOnboardingSession' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'PmOnboardingSessionFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyPmOnboardingSessionQuery,
  MyPmOnboardingSessionQueryVariables
>;
export const GuestyDhPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GuestyDhPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GuestyDhPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guestyDhPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GuestyDhPmsConnectionCreateMutation,
  GuestyDhPmsConnectionCreateMutationVariables
>;
export const HostawayPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HostawayPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'HostawayPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostawayPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HostawayPmsConnectionCreateMutation,
  HostawayPmsConnectionCreateMutationVariables
>;
export const LodgifyPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LodgifyPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LodgifyPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lodgifyPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LodgifyPmsConnectionCreateMutation,
  LodgifyPmsConnectionCreateMutationVariables
>;
export const HostfullyPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HostfullyPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'HostfullyPmsConnectionCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hostfullyPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HostfullyPmsConnectionCreateMutation,
  HostfullyPmsConnectionCreateMutationVariables
>;
export const HospitablePmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'HospitablePmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'HospitablePmsConnectionCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hospitablePmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HospitablePmsConnectionCreateMutation,
  HospitablePmsConnectionCreateMutationVariables
>;
export const OwnerRezPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OwnerRezPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OwnerRezPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ownerRezPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OwnerRezPmsConnectionCreateMutation,
  OwnerRezPmsConnectionCreateMutationVariables
>;
export const DemoPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DemoPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DemoPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'demoPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DemoPmsConnectionCreateMutation,
  DemoPmsConnectionCreateMutationVariables
>;
export const BooksterPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BooksterPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BooksterPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'booksterPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BooksterPmsConnectionCreateMutation,
  BooksterPmsConnectionCreateMutationVariables
>;
export const LodgixPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LodgixPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LodgixPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lodgixPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LodgixPmsConnectionCreateMutation,
  LodgixPmsConnectionCreateMutationVariables
>;
export const StreamlinePartnerPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StreamlinePartnerPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'StreamlinePartnerPmsConnectionCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'streamlinePartnerPmsConnectionCreate',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StreamlinePartnerPmsConnectionCreateMutation,
  StreamlinePartnerPmsConnectionCreateMutationVariables
>;
export const EscapiaPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EscapiaPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'EscapiaPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'escapiaPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EscapiaPmsConnectionCreateMutation,
  EscapiaPmsConnectionCreateMutationVariables
>;
export const BarefootPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BarefootPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BarefootPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'barefootPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BarefootPmsConnectionCreateMutation,
  BarefootPmsConnectionCreateMutationVariables
>;
export const TrackPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TrackPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TrackPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackPmsConnectionCreateMutation,
  TrackPmsConnectionCreateMutationVariables
>;
export const RentalsUnitedPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RentalsUnitedPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'RentalsUnitedPmsConnectionCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rentalsUnitedPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RentalsUnitedPmsConnectionCreateMutation,
  RentalsUnitedPmsConnectionCreateMutationVariables
>;
export const CiirusPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CiirusPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CiirusPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ciirusPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CiirusPmsConnectionCreateMutation,
  CiirusPmsConnectionCreateMutationVariables
>;
export const BoostPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BoostPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BoostPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'boostPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BoostPmsConnectionCreateMutation,
  BoostPmsConnectionCreateMutationVariables
>;
export const LiveListPmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LiveListPmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LiveListPmsConnectionCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'liveListPmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LiveListPmsConnectionCreateMutation,
  LiveListPmsConnectionCreateMutationVariables
>;
export const VacayHomePmsConnectionCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VacayHomePmsConnectionCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'VacayHomePmsConnectionCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vacayHomePmsConnectionCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VacayHomePmsConnectionCreateMutation,
  VacayHomePmsConnectionCreateMutationVariables
>;
export const PmsConnectionForCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PmsConnectionForCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsConnectionForCurrentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'PmsConnection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PmsConnectionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmsConnectionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'failed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsBookings' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PmsConnectionForCurrentUserQuery,
  PmsConnectionForCurrentUserQueryVariables
>;
export const PmsIntegrationListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PmsIntegrationListAll' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pmsIntegrationListAll' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'docsUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'jiraTicketUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'authType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentSync' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availabilitySync' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ratesSync' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportsPricing' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportsBookings' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportedFields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supported' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supportsReviews' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fields' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fieldName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supported' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PmsIntegrationListAllQuery,
  PmsIntegrationListAllQueryVariables
>;
export const PolicyUpsertAccountTermsAndConditionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PolicyUpsertAccountTermsAndConditions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PolicyUpsertAccountTermsAndConditionsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'policyUpsertAccountTermsAndConditions',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsUploadUrl' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PolicyUpsertAccountTermsAndConditionsMutation,
  PolicyUpsertAccountTermsAndConditionsMutationVariables
>;
export const PolicyUpsertListingTermsAndConditionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PolicyUpsertListingTermsAndConditions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PolicyUpsertListingTermsAndConditionsInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'policyUpsertListingTermsAndConditions',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingTermsAndConditions' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsLink' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'termsUploadUrl' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PolicyUpsertListingTermsAndConditionsMutation,
  PolicyUpsertListingTermsAndConditionsMutationVariables
>;
export const PolicyUpsertAccountCancellationPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PolicyUpsertAccountCancellationPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PolicyUpsertAccountCancellationPolicyInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'policyUpsertAccountCancellationPolicy',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AccountCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PolicyUpsertAccountCancellationPolicyMutation,
  PolicyUpsertAccountCancellationPolicyMutationVariables
>;
export const PolicyUpsertListingCancellationPolicyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PolicyUpsertListingCancellationPolicy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'PolicyUpsertListingCancellationPolicyInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'policyUpsertListingCancellationPolicy',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ListingCancellationPolicy' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PolicyUpsertListingCancellationPolicyMutation,
  PolicyUpsertListingCancellationPolicyMutationVariables
>;
export const UserReferralCampaignCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserReferralCampaignCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserReferralCampaignCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userReferralCampaignCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserReferralCampaign' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignDescription' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewardsBalanceCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewardsIssuedCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rewardsRemaining' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'insertedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserReferralCampaignCreateMutation,
  UserReferralCampaignCreateMutationVariables
>;
export const UserReferralCampaignsForCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserReferralCampaignsForCurrentUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeInactive' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'userReferralCampaignsForCurrentUser',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeInactive' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeInactive' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'UserReferralCampaignCollection',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'campaignType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'campaignName' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'campaignDescription',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'rewardsBalanceCents',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'rewardsIssuedCount',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rewardsRemaining' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'insertedAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserReferralCampaignsForCurrentUserQuery,
  UserReferralCampaignsForCurrentUserQueryVariables
>;
export const ReferralCodeFindByCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReferralCodeFindByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'referralCodeFindByCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'code' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReferralCodeDetails' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'campaignDescription' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'referredUserRewardAmountCents',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReferralCodeFindByCodeQuery,
  ReferralCodeFindByCodeQueryVariables
>;
export const RewardsForCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RewardsForCurrentUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rewardsForCurrentUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'RewardCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'insertedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipient' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'giftCard' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'certificateNumber',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RewardsForCurrentUserQuery,
  RewardsForCurrentUserQueryVariables
>;
export const RegionsListAllWithActiveSearchPageContentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: {
        kind: 'Name',
        value: 'RegionsListAllWithActiveSearchPageContents',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SearchPageContentType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'regionsListAllWithActiveSearchPageContents',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countrySlug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelOneSlug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citySlug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPages' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegionsListAllWithActiveSearchPageContentsQuery,
  RegionsListAllWithActiveSearchPageContentsQueryVariables
>;
export const RegionsListAllFeaturedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RegionsListAllFeatured' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'regionsListAllFeatured' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'RegionCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'imageUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegionsListAllFeaturedQuery,
  RegionsListAllFeaturedQueryVariables
>;
export const CreateReservationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateReservation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateReservationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createReservation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Reservation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalReservationId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReservationCreationUnknown' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reservationId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReservationUnavailable' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateReservationMutation,
  CreateReservationMutationVariables
>;
export const CancelReservationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelReservation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CancelReservationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelReservation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Reservation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalReservationId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelReservationMutation,
  CancelReservationMutationVariables
>;
export const FreePromoCreateReservationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FreePromoCreateReservation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FreePromoCreateReservationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'freePromoCreateReservation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Reservation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalReservationId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReservationUnavailable' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FreePromoCreateReservationMutation,
  FreePromoCreateReservationMutationVariables
>;
export const ReservationByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reservationById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Reservation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCostCents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalReservationId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfAdults' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfChildren' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfInfants' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfPets' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cancellationPolicy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportsCancellations' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'paymentSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dueDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amountCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'paymentItemType' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listing' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'bookDirectWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketingWebsiteUrl',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'stateOrProvinceLongName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'guestCapacity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'numberOfRooms' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'numberOfBathrooms',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lng' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'minPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'maxPrice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'uniquePropertyType',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isFavorited' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listingLevel' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'searchableAvailability',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'isDiamondCollection',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressLineOne' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'publicPhoneNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'features' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'key' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'categoryName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'promoted' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'companyName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'avatarUrl' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'marketingWebsiteUrl',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'phoneNumber',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'galleryAssets' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'numberOfAssets',
                                  },
                                  value: { kind: 'IntValue', value: '10' },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'processing' },
                                  value: { kind: 'BooleanValue', value: false },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationByIdQuery,
  ReservationByIdQueryVariables
>;
export const ReservationForOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationForOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reservationForOrder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Reservation' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalReservationId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationForOrderQuery,
  ReservationForOrderQueryVariables
>;
export const ReservationsListAllForCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReservationsListAllForCurrentUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'statusFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReservationStatuses' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
          defaultValue: { kind: 'IntValue', value: '20' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reservationsListAllForUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'statusFilter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'statusFilter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReservationCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCostCents' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'note' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listing' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'bookDirectWebsiteUrl',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'city' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'marketingWebsiteUrl',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'stateOrProvinceLongName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'guestCapacity',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfRooms',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'numberOfBathrooms',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lat' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lng' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'minPrice' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'maxPrice' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'propertyType',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isFavorited',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'listingLevel',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'searchableAvailability',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isDiamondCollection',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addressLineOne',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cancellationPolicy',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'features' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'key' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'categoryName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'promoted',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'account' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'slug' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatarUrl',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'galleryAssets',
                                    },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: {
                                          kind: 'Name',
                                          value: 'numberOfAssets',
                                        },
                                        value: {
                                          kind: 'IntValue',
                                          value: '10',
                                        },
                                      },
                                      {
                                        kind: 'Argument',
                                        name: {
                                          kind: 'Name',
                                          value: 'processing',
                                        },
                                        value: {
                                          kind: 'BooleanValue',
                                          value: false,
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'meta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'currentPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalPages' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'previousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalEntries' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReservationsListAllForCurrentUserQuery,
  ReservationsListAllForCurrentUserQueryVariables
>;
export const SearchPageContentsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchPageContentsListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'h1Query' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SearchPageContentType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchPageContentListAll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'h1Query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'h1Query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'type' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchType' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'h1' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'h1ParagraphRaw' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'h2' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'h2ParagraphRaw' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageHtmlAlt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageProcessing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUploadUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'htmlMetaDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'htmlMetaTitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchPageContentsListAllQuery,
  SearchPageContentsListAllQueryVariables
>;
export const SearchPageContentForUrlPathAndTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchPageContentForUrlPathAndType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'urlPath' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SearchPageContentType' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchPageContentForUrlPathAndType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'urlPath' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'urlPath' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchType' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SearchPageContent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchType' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'h1' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'h1ParagraphRaw' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'h2' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'h2ParagraphRaw' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageHtmlAlt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageProcessing' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUploadUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'heroImageUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'htmlMetaDescription' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'htmlMetaTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aboutItemsTitle' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'faqsTitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'searchType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'region' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'citySlug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'countrySlug',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'levelOneSlug',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchPageLinks' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'href' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customLinkCategory',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchPageParagraphs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bodyRaw' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'region' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'placeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'citySlug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'countrySlug' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'levelOneSlug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'topicSlug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'searchPageTopic' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SearchPageContentForUrlPathAndTypeQuery,
  SearchPageContentForUrlPathAndTypeQueryVariables
>;
export const SitemapListingsTotalCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapListingsTotalCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'listingCollection' },
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyTypes' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'EnumValue', value: 'BED_AND_BREAKFAST' }],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalEntries' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SitemapListingsTotalCountQuery,
  SitemapListingsTotalCountQueryVariables
>;
export const SitemapListingsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapListingsListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'listingCollection' },
            name: { kind: 'Name', value: 'listingsListAllActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyTypes' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'EnumValue', value: 'BED_AND_BREAKFAST' }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SitemapListingsListAllQuery,
  SitemapListingsListAllQueryVariables
>;
export const SitemapRegionsListBedAndBreakfastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapRegionsListBedAndBreakfast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'regionsListAllWithActiveSearchPageContents',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchType' },
                value: { kind: 'EnumValue', value: 'BED_AND_BREAKFAST' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'countrySlug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelOneSlug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citySlug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previousPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SitemapRegionsListBedAndBreakfastQuery,
  SitemapRegionsListBedAndBreakfastQueryVariables
>;
export const SitemapSearchPageContentsListAllDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SitemapSearchPageContentsListAll' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageSize' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'SearchPageContentType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchPageContentListAll' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'page' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageSize' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageSize' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'type' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'active' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nextPage' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SitemapSearchPageContentsListAllQuery,
  SitemapSearchPageContentsListAllQueryVariables
>;
export const TestUnhandledErrorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TestUnhandledError' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'testUnhandledError' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TestUnhandledErrorQuery,
  TestUnhandledErrorQueryVariables
>;
export const TravelerSurveyResponseCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TravelerSurveyResponseCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'TravelerSurveyResponseCreateInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerSurveyResponseCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TravelerSurveyResponse' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choice' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TravelerSurveyResponseCreateMutation,
  TravelerSurveyResponseCreateMutationVariables
>;
export const TravelerSurveyPromptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelerSurveyPrompt' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerSurveyPrompt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TravelerSurveyQuestion' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choices' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'TravelerSurveyResponse' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'choice' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TravelerSurveyPromptQuery,
  TravelerSurveyPromptQueryVariables
>;
export const UserCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserFields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refreshToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserCreateMutation, UserCreateMutationVariables>;
export const UserSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserSessionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserSessionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BlockedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSessionMutation, UserSessionMutationVariables>;
export const UserAppleSocialSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserAppleSocialSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserAppleSocialSessionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAppleSocialSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserSessionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BlockedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserAppleSocialSessionMutation,
  UserAppleSocialSessionMutationVariables
>;
export const UserGoogleSocialSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserGoogleSocialSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserGoogleSocialSessionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userGoogleSocialSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserSessionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BlockedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserGoogleSocialSessionMutation,
  UserGoogleSocialSessionMutationVariables
>;
export const UserFacebookSocialSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserFacebookSocialSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserFacebookSocialSessionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userFacebookSocialSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserSessionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BlockedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserFacebookSocialSessionMutation,
  UserFacebookSocialSessionMutationVariables
>;
export const UserAccountAddDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserAccountAdd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserAccountAddInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccountAdd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserFieldsWithAccount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConflictError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFieldsWithAccount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerified' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPpr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homeownerMarketingUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twitterHandle' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inBusinessSince' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUsername' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookPageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstPublishedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingCompletedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditCardOnFile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultListingLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingSubscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPeriodEnd' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importSuccessCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineOne' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineTwo' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stateOrProvinceLongName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountTermsAndConditions',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'termsLink' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ListingCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountReviewSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfReviews' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserAccountAddMutation,
  UserAccountAddMutationVariables
>;
export const UserSessionRefreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserSessionRefresh' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserSessionRefreshInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSessionRefresh' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserSessionFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BlockedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserSessionRefreshMutation,
  UserSessionRefreshMutationVariables
>;
export const UserAccountRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserAccountRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserAccountRemoveInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAccountRemove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserFieldsWithAccount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFoundError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConflictError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFieldsWithAccount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerified' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPpr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homeownerMarketingUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twitterHandle' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inBusinessSince' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUsername' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookPageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstPublishedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingCompletedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditCardOnFile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultListingLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingSubscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPeriodEnd' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importSuccessCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineOne' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineTwo' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stateOrProvinceLongName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountTermsAndConditions',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'termsLink' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ListingCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountReviewSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfReviews' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserAccountRemoveMutation,
  UserAccountRemoveMutationVariables
>;
export const UserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userUpdate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dob' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserAndPmAccountCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UserAndPmAccountCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserAndPmAccountCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userAndPmAccountCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'UserAndPmAccountCreatePayload',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'UserFields' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'refreshToken' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmOnboardingSession' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'PmOnboardingSessionFields',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pmsSoftware' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfListings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isUsBased' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ValidationErrorCollection' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'field' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlowStep' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'position' } },
          { kind: 'Field', name: { kind: 'Name', value: 'label' } },
          { kind: 'Field', name: { kind: 'Name', value: 'required' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingFlow' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'steps' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowStepFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingStepCompletionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingStepCompletion' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PmOnboardingSessionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PmOnboardingSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pmsType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reviewReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStepIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalSteps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedStepKeys' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAdvance' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'flow' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PmOnboardingFlowFields' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stepCompletions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'PmOnboardingStepCompletionFields',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isUsBased' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserAndPmAccountCreateMutation,
  UserAndPmAccountCreateMutationVariables
>;
export const TermsOfUseStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TermsOfUseStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountRole' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastAuthenticatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'commissionable' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'termsOfUseAcceptedAt',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TermsOfUseStatusQuery,
  TermsOfUseStatusQueryVariables
>;
export const CurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'User' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'UserFieldsWithAccount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UnauthenticatedError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserFieldsWithAccount' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarProcessing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'refreshToken' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'claimable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'identityVerified' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelerVerificationStatus' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAuthenticatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dob' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paymentServiceUserId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerified' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'phoneNumberVerifiedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'referredByUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registeredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPpr' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatarProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'heroUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroFileName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroUploadUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heroProcessing' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketingWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'homeownerMarketingUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'twitterHandle' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inBusinessSince' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookDirectWebsiteUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'instagramUsername' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'facebookPageUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'youtubeUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insertedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firstPublishedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingCompletedAt' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditCardOnFile' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultListingLevel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingSubscription' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentPeriodEnd' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'latestTask' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importSuccessCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'importedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineOne' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addressLineTwo' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'countryOrRegionLongName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stateOrProvinceLongName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availableCoupon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'promoCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'percentOff' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'applicableSubscriptions',
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountTermsAndConditions',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'termsLink' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'AccountCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ListingCancellationPolicy',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cancellationPolicy',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountReviewSummaries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rating' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numberOfReviews' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
